import Axios from "axios";
import i18n from "@/plugins/i18n";
import moment from "moment";
import router from "@/router";
import PouchDB from "pouchdb";
const dbU = new PouchDB("UserRemember");
var dbL = new PouchDB("LastUser");
var NeurtinoDB = new PouchDB("NeutrinoData");
import Highcharts from "highcharts";
var workerLogin;
var workerOvewview;
var workerUpdateLevel;
var workerCommand;
import { saveAs } from "file-saver";
import $ from "jquery";
import XLSX from "xlsx/xlsx";
import MarkerClusterer from "@googlemaps/markerclustererplus";
import Highstock from "highcharts/highstock";

var formatNumber = {
  separador: ",", // separador para los miles
  sepDecimal: ".", // separador para los decimales
  formatear: function(num) {
    num += "";
    var splitStr = num.split(".");
    var splitLeft = splitStr[0];
    var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : "";
    var regx = /(\d+)(\d{3})/;
    while (regx.test(splitLeft)) {
      splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
    }
    return splitLeft + splitRight + " " + this.simbol;
  },
  new: function(num, simbol) {
    this.simbol = simbol || "";
    return this.formatear(num);
  },
};

export default {
  async ManageWorker({ dispatch, commit, state, getters }, request) {
    var worker;

    var offline = JSON.parse(localStorage.getItem("offline"));
    if (offline) {
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
      return;
    }

    if (request[0].from == "LOGIN" || request[0].from == "TOKEN") {
      dispatch("cancelLogin");
      workerLogin = new Worker("webWorker.js");
      workerLogin.addEventListener("message", async function(response) {
        //Manage request
        if (response.data.to == "LOGIN") {
          dispatch("responseLogin", response);
        } else if (response.data.to == "TOKEN") {
          await dispatch("responseToken", [response, request[1]]);
        } else if (response.data.to == "ERROR") {
          var message = i18n.t("loginErr");
          commit("snackbar", {
            snackbar: true,
            text: message,
          });
          commit("progresslogin", false);
          commit("loginBtn", i18n.t("loginCard"));
          dispatch("manageError", response);
          workerLogin.terminate();
        }
      });

      workerLogin.postMessage(request[0]);
    } else if (request[0].from == "OVERVIEW") {
      workerOvewview = new Worker("webWorker.js");

      workerOvewview.addEventListener("message", async function(response) {
        if (response.data.to == "OVERVIEW") {
          dispatch("setItemsDashboard", response);
          workerOvewview.terminate();
        }
        if (response.data.to == "ERROR") {
          commit("disableButton", false);
          dispatch("manageError", response);
          workerOvewview.terminate();
        }
      });

      workerOvewview.postMessage(request[0]);
    } else if (request[0].from == "LAST_LEVEL_COMMAND") {
      workerUpdateLevel = new Worker("webWorker.js");

      workerUpdateLevel.addEventListener("message", async function(response) {
        if (response.data.to == "LAST_LEVEL_COMMAND") {
          if (response.data.status == 200) {
            //OK
            dispatch("setLastLevelCommand", response.data.data);
            commit("cancelLoader", false);
            workerUpdateLevel.terminate();
            commit("updateBtn", i18n.t("update"));
          } else {
            //NONE
            commit("cancelLoader", false);
            workerUpdateLevel.terminate();
            commit("updateBtn", i18n.t("update"));
            dispatch("snackbarError", response);
          }
        }
        if (response.data.to == "ERROR") {
          commit("cancelLoader", false);
          dispatch("manageError", response);
          workerUpdateLevel.terminate();
        }
      });
      workerUpdateLevel.postMessage(request[0]);
    } else if (request[0].from == "SEND_COMMAND_REQUEST") {
      workerCommand = new Worker("webWorker.js");

      workerCommand.addEventListener("message", async function(response) {
        if (response.data.to == "SEND_COMMAND_REQUEST") {
          // console.log(response.data);
          var titleC =
            response.data.status == 200
              ? i18n.t("confirmedCommand")
              : i18n.t("noResponse");
          var fail = response.data.status == 200 ? false : true;
          commit("showMsgT", { val: true, title: titleC, failed: fail });
          if (response.data.status == 200) {
            dispatch("editActualState", response.data.data);
          } else {
            dispatch("snackbarError", response);
          }
          workerCommand.terminate();
        }
        if (response.data.to == "ERROR") {
          dispatch("manageError", response);
          workerUpdateLevel.terminate();
        }
      });
      workerCommand.postMessage(request[0]);
    } else {
      worker = new Worker("webWorker.js");

      worker.addEventListener("message", async function(response) {
        //Manage request

        if (response.data.to == "LOGOUT") {
          dispatch("responseLogOut", [response, request[1]]);
          worker.terminate();
        } else if (response.data.to == "REFRESH_TOKEN") {
          dispatch("responseRefreshToken", [response, request[1]]);
          worker.terminate();
        } else if (response.data.to == "ACCOUNT_CATALOG") {
          dispatch("responseFilterAccount", [response, request[1]]);
          worker.terminate();
        } else if (response.data.to == "GET_CATALOG") {
          await dispatch("responseFilterAccount", [response, request[1], true]);
          if (response.data.status == 200) {
            var type = "";
            if (request[1] == "Master") type = "Dealer";
            if (request[1] == "Dealer") type = "Client";
            if (request[1] == "Client") type = "Account";
            dispatch("getCatalog", type);
          }
          worker.terminate();
        } else if (response.data.to == "GET_VEHICLES") {
          var responseList =
            response.data.status == 200 || response.data.status == "200"
              ? response.data.data
              : [];
          dispatch("snackbarError", response);
          if (responseList.length > 0) {
            responseList.forEach((item) => {
              Object.assign(item, {
                active: false,
                MovilIdAndNick: item.Nick + " (" + item.MovilId + ")",
              });
              state.vehiclesAggregates.forEach((vehicle) => {
                if (vehicle.MovilId == item.MovilId) {
                  item.active = true;
                  return;
                }
              });
            });
          }
          commit("manageFilterAccount", [responseList, "Vehicles"]);
          commit("setVehicles", responseList);
          commit("showMoreVehicles");
          commit("setVehiclesAF", responseList);
          if (request[1]) {
            if (router.app.$route.path != "/tracking") {
              localStorage.removeItem("v_list");
              localStorage.setItem("v_list", JSON.stringify(responseList));
              localStorage.setItem("vehicles", responseList.length);
              commit("start", true);
              if (responseList.length > 0) {
                if (router.app.$route.path == "/dashboard") {
                  dispatch("getItemsDashboard", [true, request[2]]);
                }
              } else {
                if (router.app.$route.path == "/dashboard") {
                  dispatch("setSkeletons", [true, i18n.t("errorDashboard")]);
                }
              }
            }
          }
          commit("progressTableFilter", false);
          worker.terminate();
        } else if (response.data.to == "GET_REPORTS") {
          dispatch("snackbarError", response);
          var response =
            // response.data.data != null && response.data.data.length > 0
            response.data.status == 200 ? response.data.data : [];
          commit("setPermissions", true);
          commit("progressTable", false);
          localStorage.setItem("ListOfReports", JSON.stringify(response));
          //Set list
          commit("readListOfReports", response);
          worker.terminate();
        } else if (response.data.to == "CREATE_REPORT") {
          if (response.data.status == 200) {
            setTimeout(() => commit("showMessage", [true, true]), 3000);
          } else {
            commit("showMessage", [false, false]);
            commit("setAccount", false);
            router.replace({ name: "reportsPage" });
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "DELETE_REPORT") {
          //test
          if (response.data.status == 200) {
            dispatch("getListOfReports");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "GET_BLOB") {
          if (response.data.status == 200) {
            var FileSaver = require("file-saver");
            const url = new Blob([response.data.data]);
            FileSaver.saveAs(url, request[1].name + ".xls", {
              type: "application/octet-stream",
            });
            //const link = document.createElement("a");
            //link.href = url;
            //link.setAttribute("download", request[1].name + ".xls");
            //document.body.appendChild(link);
            //link.click();
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "ADD_SECURE_USER") {
          if (response.data.status == 409) {
            commit("snackbar", {
              snackbar: true,
              text: i18n.t("existinguser"),
            });
          } else if (response.data.status == 200) {
            commit("snackbar", {
              snackbar: true,
              text: i18n.t("addeduser"),
            });
            dispatch("getSecureUsers");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "GET_SECURE_USERS") {
          dispatch("snackbarError", response);
          var response = response.data.status == 200 ? response.data.data : [];
          localStorage.setItem("secureUsers", response);
          commit("secureUsers", response);
          worker.terminate();
        } else if (
          response.data.to == "EDIT_SECURE_USER" ||
          response.data.to == "DELETE_SECURE_USER"
        ) {
          if (response.data.status == 200) {
            dispatch("getSecureUsers");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "PERSONALIZATION") {
          if (response.data.status == 200) {
            dispatch("responsePersonalization", [response, request[1]]);
          } else {
            localStorage.removeItem("ItemsDashboard");
            localStorage.removeItem("last_Request");
            commit("disableButton", false);
            dispatch("setSkeletons", [true, i18n.t("errorDashboard")]);
            dispatch("onlyDestroyCharts");
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "DRIVER_LIST") {
          commit("progressOp", false);
          if (response.data.status == 200) {
            commit("listOperators", response.data.data);
          } else {
            commit("listOperators", []);
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "ADD_DRIVER") {
          if (response.data.status == 200) {
            dispatch("ListofOperators");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "EDIT_DRIVER") {
          if (response.data.status == 200) {
            dispatch("ListofOperators");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "DELETE_DRIVER") {
          if (response.data.status == 200) {
            dispatch("ListofOperators");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "ADD_MOVIL") {
          if (response.data.status == 200) {
            dispatch("ListofMovil");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "EDIT_MOBILE") {
          if (response.data.status == 200) {
            dispatch("ListofMovil");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "DELETE_MOBILE") {
          if (response.data.status == 200) {
            dispatch("ListofMovil");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "MOVIL_LIST") {
          commit("progressMovil", false);
          if (
            response.data.status == 200 &&
            response.data.data != null &&
            response.data.data.length > 0
          ) {
            var list = getters.searchOperator(response.data.data);
            commit("listMovil", list);
          } else {
            commit("listMovil", []);
            //cuando esta vacio como quiera responde status 200 entonces se comprueba si trae datos y si esta vacio se le pone snackbar al status 200
            response.data.status = 204;
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "TRAFFIC_LIST") {
          commit("progressOverTraffic", false);
          if (response.data.status == 200) {
            commit("trafficList", response.data.data);
            dispatch("customCharts", [response.data.data, "TrafficList"]);
            commit("viewSkeletonsT", false);
          } else {
            commit("trafficList", []);
            commit("viewSkeletonsT", true);
            commit("skeletonTitleT", "outskeletonTitle");
            commit("skeletonColumnT", "outskeletonColumn");
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "VEHICLES_CARRIER") {
          if (response.data.status == 200) {
            commit("vehiclesCarrier", response.data.data);
          } else {
            commit("vehiclesCarrier", []);
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "CARRIER_LIST") {
          commit("progressCarrier", false);
          if (response.data.status == 200) {
            commit("listCarrier", response.data.data);
          } else {
            commit("listCarrier", []);
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "ADD_CARRIER") {
          if (response.data.status == 200) {
            dispatch("ListofCariers");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "EDIT_CARRIER") {
          if (response.data.status == 200) {
            dispatch("ListofCariers");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "DELETE_CARRIER") {
          if (response.data.status == 200) {
            dispatch("ListofCariers");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "ADD_TRIP") {
          if (response.data.status == 200) {
            router.replace({ name: "traffic" });
          } else if (response.data.status == 409) {
            commit("snackbar", {
              snackbar: true,
              text: i18n.t("error409Trip"),
            });
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "EDIT_TRIP") {
          if (response.data.status == 200) {
            if (router.app.$route.path == "/traffic") {
              dispatch("ListOfTraffic");
            } else {
              router.replace({ name: "traffic" });
            }
          } else if (response.data.status == 409) {
            commit("snackbar", {
              snackbar: true,
              text: i18n.t("error409Trip"),
            });
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "DELETE_TRIP") {
          if (response.data.status == 200) {
            dispatch("ListOfTraffic");
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "UPDATE_POSITION") {
          if (response.data.status == 200) {
            commit("UpdatePosition", response.data.data);
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "FLEET_PERFORMANCE") {
          commit("progressDetails", false);
          if (response.data.status == 200) {
            dispatch("setListInTable", response.data.data);
            localStorage.setItem(
              "detailsTableInfo",
              JSON.stringify(response.data.data)
            );
          } else {
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "INDIVIDUAL_P") {
          if (response.data.status == 200) {
            var resp = response.data.data;
            commit("setitemsPerformanceData", response.data.data);

            await dispatch("addItemPouchDB", {
              id: "ItemsPerformance",
              data: resp,
              name: "ItemsPerformance",
            });

            dispatch("divideData", {
              itemsPerformance1: resp,
              comparative: false,
              byTrip: false,
            });
          } else {
            dispatch("cancelItemsPerformance", false);
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "GET_CARRIER_INFO") {
          if (response.data.status == 200) {
            localStorage.setItem(
              "CarrierId",
              JSON.stringify(response.data.data)
            );
            commit("setCarrierId", response.data.data.Id);
          } else {
            localStorage.setItem("CarrierId", null);
            localStorage.removeItem("ItemsDashboard");
            localStorage.removeItem("last_Request");
            commit("disableButton", false);
            dispatch("setSkeletons", [true, i18n.t("errorDashboard")]);
            dispatch("onlyDestroyCharts");
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "RETRIEVE_LEVEL") {
          //console.log(response.data.data);
          if (response.data.status == 200) {
            //OK
            localStorage.setItem(
              "setitemsRetrieveLevel",
              JSON.stringify(response.data.data)
            );
            dispatch("convertRetrieveLevel");
          } else {
            //NONE
            localStorage.removeItem("setitemsRetrieveLevel");
            dispatch("setSkeletonsRL");
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "FLEET_LAST_POSITION_LIST") {
          commit("progressTracking", false);
          if (response.data.status == 200) {
            //OK
            //console.log(response.data.data);
            //dispatch("setTrackingMap", response.data.data);
            dispatch("setTrackingMap", {
              listOfVeh: response.data.data,
              isRadius: false,
            });
          } else {
            //NONE
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "ACTIVITY_OF_VEHICLE") {
          if (response.data.status == 200) {
            //OK
            commit("forActivity", response.data.data);
          } else {
            commit("indeterminateReport", false);
            await commit("test", []);
            //NONE
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "FUEL_PERFORMANCE") {
          if (response.data.status == 200) {
            if (request[1]) {
              if (
                response.data.data.ALERTFUEL_RECENT_ACTIVTY.length == 0 &&
                response.data.data.PERFORMANCE.length == 0
              ) {
                commit("snackbar", {
                  snackbar: true,
                  text: i18n.t("noDataFP"),
                });
                commit("viewSkeletonsFP", false);
                commit("viewSkeletonsAR", false);
                // commit("disableBtnAFSM", true);
              } else {
                if (response.data.data.ALERTFUEL_RECENT_ACTIVTY.length == 0) {
                  commit("snackbar", {
                    snackbar: true,
                    text: i18n.t("noDataAR"),
                  });
                  // commit("disableBtnAFSM", true);
                }
                if (response.data.data.PERFORMANCE.length == 0) {
                  commit("snackbar", {
                    snackbar: true,
                    text: i18n.t("noDataPerformance"),
                  });
                }
                dispatch("getAllDataFuel", JSON.stringify(response.data.data));
                commit("cancelLoaderSeeMore", false);
              }
            } else {
              if (
                response.data.data.ALERTFUEL_RECENT_ACTIVTY.length == 0 &&
                response.data.data.PERFORMANCE.length == 0
              ) {
                commit("snackbar", {
                  snackbar: true,
                  text: i18n.t("noDataFP"),
                });
                localStorage.removeItem("setitemsPerformanceAF");
                dispatch("setSkeletonsFP");
                dispatch("setSkeletonsAR");
              } else {
                if (response.data.data.ALERTFUEL_RECENT_ACTIVTY.length == 0) {
                  commit("snackbar", {
                    snackbar: true,
                    text: i18n.t("noDataAR"),
                  });
                }
                // //obtener fecha de hoy
                // var today = moment().format("YYYY-MM-DDTHH:mm");
                // today = moment(today, "YYYY-MM-DDTHH:mm");
                // //Si una fecha es mayor al periodo seleccioando, se deshabilita boton ver mas
                // var periodAllowed = 62;
                // var mostRecentAct, result;
                // response.data.data.ALERTFUEL_RECENT_ACTIVTY.forEach((el, index) => {
                //   mostRecentAct = moment(el.Date, "YYYY-MM-DDTHH:mm");
                //   result = today.diff(mostRecentAct, 'days');
                //   if (result > periodAllowed) {
                //     commit("disableBtnAFSM", true);
                //     return;
                //   }
                // });
                localStorage.setItem(
                  "setitemsPerformanceAF",
                  JSON.stringify(response.data.data)
                );
                dispatch("convertPerformanceAF");
              }
            }
          } else {
            if (request[1]) {
              commit("cancelLoaderSeeMore", false);
              // commit("disableBtnAFSM", true);
              dispatch("snackbarError", response);
              if (response.data.status == 204 || response.data.status == 404) {
                commit("viewSkeletonsFP", false);
                commit("viewSkeletonsAR", false);
              } else if (response.data.status == 500) {
                //dispatch("setSkeletonsFP");
                commit("viewSkeletonsFP", false);
                commit("viewSkeletonsAR", false);
              }
            } else {
              localStorage.removeItem("setitemsPerformanceAF");
              dispatch("setSkeletonsFP");
              dispatch("setSkeletonsAR");
              dispatch("snackbarError", response);
            }
          }
          worker.terminate();
        } else if (response.data.to == "VEHICLES_AF") {
          if (response.data.status == 200) {
            commit("setVehiclesAF", response.data.data);
            if (
              state.vehicleSelectedAF == "" ||
              state.vehicleSelectedAF == undefined
            ) {
              state.disableFV = true;
            } else {
              state.disableFV = false;
            }
          } else {
            //NONE
            commit("setVehiclesAF", []);
            dispatch("snackbarError", response);
          }
          worker.terminate();
        } else if (response.data.to == "VEHICLES_AT") {
          commit("progressVehAT", false);
          if (response.data.status == 200) {
            //console.log(response.data.data);
            commit("listVehiclesAT", response.data.data);
          } else {
            //NONE
            dispatch("snackbarError", response);
          }
        } else if (response.data.to == "TEMPLATES_AT") {
          commit("progressTemplatesAT", false);
          if (response.data.status == 200) {
            //console.log(response.data.data);
            commit("listTemplatesAT", response.data.data);
          } else {
            //NONE
            dispatch("snackbarError", response);
          }
        } else if (response.data.to == "CONTENT_VEH_AT") {
          if (response.data.status == 200) {
            //console.log(response.data.data);
            dispatch("contentTemplateAT", response.data.data);
            commit("contentVehAT", response.data.data);
          } else {
            //NONE
            dispatch("snackbarError", response);
            commit("loadingComparativeTable", false);
          }
        } else if (response.data.to == "CONTENT_TEMPLATE_AT") {
          if (response.data.status == 200) {
            //console.log(response.data.data);
            commit("compareContent", response.data.data);
          } else {
            //NONE
            dispatch("snackbarError", response);
          }
        } else if (response.data.to == "CONTENT_CONFIG_AT") {
          commit("progressForConfigP", false);
          if (response.data.status == 200) {
            //console.log(response.data.data);
            commit("contentForConfigP", response.data.data);
          } else {
            //NONE
            dispatch("snackbarError", response);
          }
        } else if (response.data.to == "ALERTRUCK_VEHICLES_INFO") {
          if (response.data.status == 200) {
            commit("setTableContentAlertruckVehiclesInfo", response.data.data);
            localStorage.setItem(
              "alertruckVehiclesInfo",
              JSON.stringify(response.data.data)
            );

          } else {
            dispatch("snackbarError", response);
            localStorage.removeItem("alertruckVehiclesInfo");
            state.progressAlertruckVehiclesInfo = false;
          }

        } else if (response.data.to == "GET_TEMPLATE_CONTENT") {
          if (response.data.status == 200) {
            dispatch("setTemplateView", i18n.t("editTemplate").toUpperCase());
            commit("clearTemplate");
            commit("fillTemplate", response.data.data);
          } else {
            //NONE
            dispatch("snackbarError", response);
          }

        } else if(response.data.to == "GET_REFERENCE") {
          if (response.data.status == 200) {
            console.log(response.data.data);
          } else {
            dispatch("snackbarError", response);
          }
        }
        else if (response.data.to == "ERROR") {
          dispatch("manageError", response);
          worker.terminate();
        }
      });

      worker.postMessage(request[0]);
    }
  },
  manageError: ({ state, commit, dispatch }, response) => {
    commit("snackbar", {
      snackbar: true,
      text: i18n.t("autorization"),
    });
    dispatch("destroyDB");
    commit("auth", false);
    localStorage.removeItem("auth");
    dispatch("DeletedLocalStorage");
  },
  snackbarError: ({ state, commit, dispatch }, response) => {
    if (response.data.status == 204 || response.data.status == 404) {
      commit("snackbar", {
        snackbar: true,
        text: i18n.t("notExistData"),
      });
    } else if (response.data.status == 500 || response.data.status == 400) {
      commit("snackbar", {
        snackbar: true,
        text: i18n.t("error400"),
      });
    }
  },
  cancelItemsPerformance: ({ commit, dispatch, getters, state }, val) => {
    commit("viewSkeletonsP", true);
    commit("skeletonP", "outskeleton");
    commit("skeletonTitleP", "outskeletonTitle");
    commit("skeletonPieP", "outskeletonPie");
    commit("skeletonFooterP", "outskeletonFooter");
    commit("skeletonColumnP", "outskeletonColumn");
    if (val) {
      commit("snackbar", {
        snackbar: true,
        text: i18n.t("error400"),
      });
    }
  },
  //Get login for user
  async getLogin({ dispatch, commit, state }) {
    if (state.username != "" && state.password != "") {
      if (
        !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
          state.username
        )
      ) {
        commit("snackbar", { snackbar: true, text: i18n.t("invalidUs") });
        commit("progresslogin", false);
        commit("loginBtn", i18n.t("loginCard"));
      } else {
        const url =
          state.NeutrinoUrl +
          "login?Email=" +
          state.username +
          "&password=" +
          state.password;
        // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
        // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500

        var request = {
          from: "LOGIN",
          URL: url,
          method: "GET",
          responseType: "",
          headers: "",
          params: "",
        };
        await dispatch("ManageWorker", [request]);
      }
    } else {
      commit("snackbar", { snackbar: true, text: i18n.t("tryAgain") });
      commit("progresslogin", false);
      commit("loginBtn", i18n.t("loginCard"));
    }
  },

  responseLogin: ({ dispatch, commit, getters, state }, response) => {
    if (response.data.status == "200" || response.data.status == 200) {
      commit("responseLogin", response.data.data);
      dispatch("AddRememberUserDB");
      if (response.data.data.UserAccessList.length > 1) {
        commit("progresslogin", false);
        commit("loginBtn", i18n.t("loginCard"));
      } else {
        localStorage.setItem(
          "UserDataAccessList",
          JSON.stringify(response.data.data.UserAccessList[0])
        );
        dispatch("getToken", response.data.data.UserAccessList[0]);
      }
    } else if (response.data.status != "200" || response.data.status != 200) {
      var message =
        response.data.status == 204 || response.data.status == 404
          ? i18n.t("invalidUs")
          : i18n.t("loginErr");
      commit("snackbar", {
        snackbar: true,
        text: message,
      });
      commit("progresslogin", false);
      commit("loginBtn", i18n.t("loginCard"));
    }
  },

  cancelLogin: () => {
    if (workerLogin != undefined) {
      workerLogin.terminate();
      workerLogin = undefined;
    }
  },
  cancelCommand: () => {
    if (workerCommand != undefined) {
      workerCommand.terminate();
      workerCommand = undefined;
    }
  },
  cancelUpdateLevel: () => {
    if (workerUpdateLevel != undefined) {
      workerUpdateLevel.terminate();
      workerUpdateLevel = undefined;
    }
  },
  cancelData: () => {
    if (workerOvewview != undefined) {
      workerOvewview.terminate();
      workerOvewview = undefined;
    }
  },

  //Get token auth for user logged
  async getToken({ dispatch, commit, state }, userData) {
    dispatch("checkPermits", userData);
    if (state.invalidUser != true) {
      var AccessIdPass = localStorage.getItem("AccessId");
      if (
        AccessIdPass != undefined ||
        AccessIdPass != "" ||
        AccessIdPass != null
      ) {
        if (userData.AccessId != AccessIdPass) {
          dispatch("DeletedLocalStorage");
          localStorage.setItem("AccessId", userData.AccessId);
        }
      } else {
        localStorage.setItem("AccessId", userData.AccessId);
      }
      localStorage.setItem("userName", state.username);
      const token = {
        Email: state.username,
        UserAccessId: userData.AccessId,
        DealerId: userData.DealerId,
        ClientApplicationId: "bti.web.neutrino." + userData.AccessId,
      };
      const url = state.NeutrinoUrl + "login/token";
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401

      var request = {
        from: "TOKEN",
        URL: url,
        method: "POST",
        responseType: "",
        headers: {
          headers: { "Content-type": "application/json" },
        },
        params: token,
      };
      await dispatch("ManageWorker", [request, userData]);
    }
  },

  async responseToken({ dispatch, commit, state, getters }, response) {
    if (response[0].data.status == "200" || response[0].data.status == 200) {
      var userData = JSON.parse(localStorage.getItem("UserDataAccessList"));
      //Set data in vuex state
      commit("viewAwait", [false, ""]);
      commit("getToken", [response[0].data.data, userData]);
      dispatch("AddItemDB");
      dispatch("DeleteLastUser", [
        state.username,
        state.password,
        response[0].data.data,
        state.SelectedAccess,
      ]);
      localStorage.setItem("refreshToken", response[0].data.data.refresh_token);
      commit("progresslogin", false);
      commit("setValuesLanguage");
      dispatch("beforeInit", response[1]);
      var ItemsDashboard = JSON.parse(localStorage.getItem("ItemsDashboard"));
      if (ItemsDashboard != undefined) {
        commit("setItemsDashboard", ItemsDashboard);
      }
    } else {
      commit("snackbar", { snackbar: true, text: i18n.t("tryAgain") });
      commit("progresslogin", false);
      commit("loginBtn", i18n.t("loginCard"));
    }
  },

  async beforeInit({ state, dispatch, getters, commit }, userData) {
    var personalization =
      userData.Profile == null ? state.personalization : userData.Profile;
    localStorage.setItem("personalization", JSON.stringify(personalization));

    //Guardar la personalizacion y establecerla antes de que entre
    commit("Personalization", personalization);

    if (
      personalization.Account.DealerId != "ND" &&
      personalization.Account.ClientId != "ND"
    ) {
      dispatch("getCatalog");
      var languagePersonalitazion =
        personalization.Language != ""
          ? personalization.Language.split("-")
          : ["es"];
      var languageLocalStorage = localStorage.getItem("language");
      if (
        languageLocalStorage != null &&
        languageLocalStorage != languagePersonalitazion[0]
      ) {
        dispatch("setPersonalization", ["language", i18n.locale]);
      } else {
        commit("PersonalizationChangeLanguage", personalization.Language);
      }
      commit("setValuesLanguage");

      if (personalization.Media.UserAvatar != "ND") {
        dispatch("getUrlSAS", [
          personalization.Media.UserAvatar,
          "UserAvatar",
          userData.AccessId,
        ]);
      } else {
        if (localStorage.getItem("userImage") != null) {
          commit("userImage", localStorage.getItem("userImage"));
        }
      }

      if (personalization.Media.MainLogo != "ND") {
        dispatch("getUrlSAS", [
          personalization.Media.MainLogo,
          "MainLogo",
          userData.AccessId,
        ]);
      } else {
        if (localStorage.getItem("imageLogo") != null) {
          commit("imageLogo", localStorage.getItem("imageLogo"));
        }
      }
      localStorage.setItem("initialSettings", false);

      dispatch("getVehiclesCatalog", [
        "&did=" +
          personalization.Account.DealerId +
          "&cid=" +
          personalization.Account.ClientId,
        true,
        true,
      ]);
    } else if (
      personalization.Account.DealerId == "ND" &&
      personalization.Account.ClientId == "ND"
    ) {
      //Requiere wizzard
      localStorage.setItem("initialSettings", true);
      commit("viewSkeletons", true);
      commit("initialSettings", true);
      router.replace({
        name: "home",
      });
    }
  },

  //LogOut can delete access token or logout user
  //Payload = [AccessId, token] // Is optional
  async logOutApp({ dispatch, commit, state }, payload) {
    commit("viewAwait", [false, ""]);
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      var token = payload == null ? state.token : payload[0];
      var userData =
        payload == null ? state.SelectedAccess.AccessId : payload[1];
      const url = state.NeutrinoUrl + "login";
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "LOGOUT",
        URL: url,
        method: "DELETE",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };
      var data = payload == null ? [userData, true] : null;
      await dispatch("ManageWorker", [request, data]);
    } else {
      var userData =
        payload == null ? state.SelectedAccess.AccessId : payload[1];
      var data = payload == null ? [userData, true] : null;
      var responseWoker = {
        data: {
          data: "",
          status: 200,
          to: "",
          payload: "",
        },
      };
      dispatch("responseLogOut", [responseWoker, data]);
    }
  },

  responseLogOut: ({ dispatch, commit, state }, response) => {
    var userData = response[1];
    dispatch("DeleteItemDB", userData);
    commit("auth", false);
    dispatch("cancelData");
    localStorage.removeItem("vehicleAF");
    localStorage.removeItem("setitemsRetrieveLevel");
    localStorage.removeItem("setitemsPerformanceAF");
    if (response[0].data.status == 204 || response[0].data.status == 404) {
      commit("snackbar", {
        snackbar: true,
        text: i18n.t("notExistData"),
      });
    } else if (response[0].data.status == 500) {
      commit("snackbar", {
        snackbar: true,
        text: i18n.t("error400"),
      });
    }
  },

  //Refresh token for current user
  //UserData = [UserAccess, Email, refreshtoken] // Is optional
  async refreshToken({ dispatch, commit, state }, userData) {
    if (state.authenticated) {
      var userAccess =
        userData == undefined ? state.SelectedAccess : userData[1];
      var username =
        userData == undefined
          ? localStorage.getItem("userName")
          : userData[0].Email;
      var tokenInfo =
        userData == undefined
          ? localStorage.getItem("refreshToken")
          : userData[2];
      const token = {
        Email: username,
        UserAccessId: userAccess.AccessId,
        DealerId: userAccess.DealerId,
        ClientApplicationId: "bti.web.neutrino." + userAccess.AccessId,
      };
      const url = state.NeutrinoUrl + "login/refreshtoken?Token=" + tokenInfo;
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "REFRESH_TOKEN",
        URL: url,
        method: "POST",
        responseType: "",
        headers: {
          "Content-type": "application/json",
        },
        params: token,
      };

      await dispatch("ManageWorker", [request, userAccess]);
    }
  },

  responseRefreshToken: ({ dispatch, commit, state }, response) => {
    if (response[0].data.status == "200" || response[0].data.status == 200) {
      var payload = [response[0].data.data, response[1]];
      commit("getToken", payload);
      dispatch("UpdateItemDB");
    } else {
      //session expired
      //do something
      dispatch("manageError", response);
    }
  },

  async getCatalog({ dispatch, commit, state }, Level) {
    if (state.SelectedAccess.Level != "Master") {
      localStorage.setItem(
        "DealerSelectedId",
        JSON.stringify({
          DealerId: state.SelectedAccess.DealerId,
        })
      );
    }
    commit("progressTableFilter", true);
    var dealer =
      state.SelectedAccess.Level == "Dealer"
        ? state.SelectedAccess.DealerId
        : state.dealerSelected.DealerId;
    var client = "";
    if (state.SelectedAccess.Level == "Client") {
      dealer = state.SelectedAccess.DealerId;
      client = state.SelectedAccess.ClientId;
    } else {
      client = state.clientSelected.ClientId;
    }
    var account = "";
    if (state.SelectedAccess.Level == "Account") {
      dealer = state.SelectedAccess.DealerId;
      client = state.SelectedAccess.ClientId;
      account = state.SelectedAccess.AccountId;
    } else {
      account = state.accountSelected.AccountId;
    }

    var accessLevel = Level == null ? state.SelectedAccess.Level : Level;

    if (accessLevel == "Master") {
      await dispatch("getFilterAccountCatalog", [
        "dealers",
        "Master",
        "GET_CATALOG",
      ]);
    } else if (accessLevel == "Dealer") {
      await dispatch("getFilterAccountCatalog", [
        "clients?DealerId=" + dealer,
        "Dealer",
        "GET_CATALOG",
      ]);
    } else if (accessLevel == "Client") {
      if (client != undefined) {
        await dispatch("getFilterAccountCatalog", [
          "accounts?DealerId=" + dealer + "&ClientId=" + client,
          "Client",
          "GET_CATALOG",
        ]);
      }
    } else if (accessLevel == "Account") {
      if (account != undefined) {
        await dispatch("getFilterAccountCatalog", [
          "vehiclegroups?DealerId=" +
            dealer +
            "&ClientId=" +
            client +
            "&AccountId=" +
            account,
          "Account",
          "GET_CATALOG",
        ]);
      }
    }
  },

async updateGetCatalog({ dispatch, commit, state }, Level) {
    var urlRequest = "clients?DealerId=" + 
      state.dealerSelected.DealerId;
    var requestType = "Dealer";

        if (state.clientSelected.ClientId != null && state.clientSelected.ClientId != "") {
      urlRequest =
        "accounts?DealerId=" + state.dealerSelected.DealerId +
            "&ClientId=" + state.clientSelected.ClientId;
            requestType = "Client";
    }
    
    dispatch("getFilterAccountCatalog", [
             urlRequest,
             requestType
            ]);
  },
  
  //Get account Catalog
  async getFilterAccountCatalog({ getters, dispatch, commit, state }, payload) {
    //payload[0] == extension (for complete request)
    //payload[1] == type (for manage result of request)
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      state.nextWizzard = false;
      commit("disableFV", true);
      commit("progressTableFilter", true);
      var token = state.token;
      if (token == null || token == "" || token == undefined) {
        token = localStorage.getItem("Token");
      }
      const url = state.NeutrinoUrl + "management/" + payload[0];
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      //Payload[1] == MASTER -- DEALER - CLIENT - ACCOUNT - GROUP

      var request = {
        from: payload.length == 3 ? payload[2] : "ACCOUNT_CATALOG",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };
      commit("setVehicles", []);
      commit("clearVehiclesList", []);
      return await dispatch("ManageWorker", [request, payload[1]]);
    } else {
      var type = "";
      if (payload[1] == "Master") {
        var responseWoker = {
          data: {
            data: JSON.parse(localStorage.getItem("DealerList")),
            status: "200",
            to: "",
            payload: "",
          },
        };
        dispatch("responseFilterAccount", [responseWoker, payload[1], true]);
        type = "Dealer";
      }
      if (payload[1] == "Dealer") {
        var responseWoker = {
          data: {
            data: JSON.parse(localStorage.getItem("ClientList")),
            status: "200",
            to: "",
            payload: "",
          },
        };
        dispatch("responseFilterAccount", [responseWoker, payload[1], true]);
        type = "Client";
      }
      if (payload[1] == "Client") {
        var responseWoker = {
          data: {
            data: JSON.parse(localStorage.getItem("AccountList")),
            status: "200",
            to: "",
            payload: "",
          },
        };
        dispatch("responseFilterAccount", [responseWoker, payload[1], true]);
        type = "Account";
      }

      if (payload[1] == "Account") {
        var responseWoker = {
          data: {
            data: JSON.parse(localStorage.getItem("GroupList")),
            status: "200",
            to: "",
            payload: "",
          },
        };
        dispatch("responseFilterAccount", [responseWoker, payload[1], true]);
        type = "Group";
      }

      dispatch("getCatalog", type);
      commit("progressTableFilter", false);
    }
  },

  responseFilterAccount: ({ dispatch, commit, state, getters }, payload) => {
    var initial = payload.length == 3 ? true : false;
    var dealer =
      state.dealerSelected.DealerId == undefined ||
      state.dealerSelected.DealerId == null
        ? localStorage.getItem("Dealer_Id")
        : state.dealerSelected.DealerId;

    var client =
      state.clientSelected.ClientId == undefined ||
      state.clientSelected.ClientId == null
        ? localStorage.getItem("Client_Id")
        : state.clientSelected.ClientId;

    if (payload[0].data.status == "200") {
      var response = payload[0].data;
      var responseList = null;
      if (payload[1] == "Master") {
        //When is master only retrive dealers list
        responseList = getters.OrderBy(response.data);
        if (localStorage.getItem("DealerSelectedId") == undefined) {
          dispatch("setInitialAccount", [response.data, payload[1]]);
        }
        localStorage.setItem("DealerList", JSON.stringify(responseList));
        commit("manageFilterAccount", [responseList, payload[1], initial]);
        commit("dealersList", responseList);
      } else if (payload[1] == "Dealer") {
        if (localStorage.getItem("ClientSelectedId") == undefined) {
          dispatch("setInitialAccount", [response.data, payload[1]]);
        }
        //When is dealer only retrive clients list
        commit("filtersEnabled", [false, false, true, true]);
        responseList = getters.OrderBy(response.data);
        localStorage.setItem("ClientList", JSON.stringify(responseList));
        commit("manageFilterAccount", [responseList, payload[1], initial]);
        commit("selectionNames");
        if (state.SelectedAccess.Level != "Dealer") {
          dispatch("getVehiclesCatalog", ["&did=" + dealer, false, false]);
        }
      } else if (payload[1] == "Client") {
        if (localStorage.getItem("AccountSelectedId") == undefined) {
          dispatch("setInitialAccount", [response.data, payload[1]]);
        }
        //When is client only retrive account list
        commit("filtersEnabled", [false, false, false, true]);
        responseList = getters.OrderBy(response.data);
        localStorage.setItem("AccountList", JSON.stringify(responseList));
        commit("manageFilterAccount", [responseList, payload[1], initial]);
        dispatch("getVehiclesCatalog", [
          "&did=" + dealer + "&cid=" + client,
          false,
          false,
        ]);
        commit("selectionNames");
      } else if (payload[1] == "Account") {
        if (localStorage.getItem("GroupSelectedId") == undefined) {
          dispatch("setInitialAccount", [response.data, payload[1]]);
        }
        //When is account only retrive group list
        commit("filtersEnabled", [false, false, false, false]);
        responseList = getters.OrderBy(response.data);
        localStorage.setItem("GroupList", JSON.stringify(responseList));
        commit("manageFilterAccount", [responseList, payload[1], initial]);
        dispatch("getVehiclesCatalog", [
          "&did=" +
            state.dealerSelected.DealerId +
            "&cid=" +
            state.clientSelected.ClientId +
            "&acid=" +
            state.accountSelected.AccountId,
          false,
          false,
        ]);
      }
    } else {
      commit("progressTableFilter", false);
      commit("manageFilterAccount", [[], payload[1]]);
      commit("manageFilterAccount", [[], "Vehicles"]);
      commit("setVehicles", []);
      commit("clearVehiclesList", []);
      commit("filtersEnabled", [false, true, true, true]);
      localStorage.removeItem("ItemsDashboard");
      localStorage.removeItem("last_Request");
      commit("disableButton", false);
      dispatch("setSkeletons", [true, i18n.t("errorDashboard")]);
      dispatch("onlyDestroyCharts");
      if (payload[0].data.status == 204 || payload[0].data.status == 404) {
        commit("snackbar", {
          snackbar: true,
          text: i18n.t("notExistData"),
        });
      } else if (payload[0].data.status == 500) {
        commit("snackbar", {
          snackbar: true,
          text: i18n.t("error400"),
        });
      }
    }
  },

  setInitialAccount: ({ commit, state, getters }, payload) => {
    if (!state.initialSettings) {
      if (payload[1] == "Master") {
        var dealer_sel = getters.getAccessFilter([
          payload[0],
          localStorage.getItem("Dealer_Id"),
          "DealerId",
        ]);
        localStorage.setItem("DealerSelectedId", JSON.stringify(dealer_sel));
      } else if (payload[1] == "Dealer") {
        var client_sel = getters.getAccessFilter([
          payload[0],
          localStorage.getItem("Client_Id"),
          "ClientId",
        ]);
        localStorage.setItem("ClientSelectedId", JSON.stringify(client_sel));
      } else if (payload[1] == "Client") {
        var account_sel = getters.getAccessFilter([
          payload[0],
          localStorage.getItem("Account_Id"),
          "AccountId",
        ]);
        localStorage.setItem("AccountSelectedId", JSON.stringify(account_sel));
      } else if (payload[1] == "Account") {
        var group_sel = getters.getAccessFilter([
          payload[0],
          localStorage.getItem("Group_Id"),
          "GroupId",
        ]);
        localStorage.setItem("GroupSelectedId", JSON.stringify(group_sel));
      }
    }
  },

  //Get list of vehicles according request
  //urlExtension + si es filtro de vehiculos o si solo ocupas vehiculos de manera inicial algo asi
  //payload[0] == url extension
  //payload[1] == true o false
  async getVehiclesCatalog({ getters, dispatch, commit, state }, payload) {
    var offline = JSON.parse(localStorage.getItem("offline"));

    if (!offline) {
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");
      var svc = "3";
      if (router.app.$route.path == "/individualFuel") {
        svc = "0";
      } else if (router.app.$route.path == "/tracking") {
        svc = "8";
      } else if (router.app.$route.path == "/home") {
        svc = "255";
      }

      var initialSetttings = JSON.parse(
        localStorage.getItem("initialSettings")
      );
      if (initialSetttings) {
        svc = "255";
      }
      const url =
        state.NeutrinoUrl + "management/vehicles?svc=" + svc + payload[0];
      // const url ="https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401

      var request = {
        from: "GET_VEHICLES",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };

      await dispatch("ManageWorker", [request, payload[1]]);
    } else {
      var vehiclesList = JSON.parse(localStorage.getItem("v_list"));
      commit("manageFilterAccount", [vehiclesList, "Vehicles"]);
      commit("setVehicles", vehiclesList);
      commit("progressTableFilter", false);
    }
  },

  //Retrive reports list from db
  async getListOfReports({ dispatch, commit, state }) {
    commit("progressTable", true);
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");
      if (state.DealerId == "") {
        var DealerId = localStorage.getItem("Dealer_Id");
      } else {
        var DealerId = state.DealerId;
      }
      if (DealerId == undefined || DealerId == "") {
        commit("progressTable", false);
        commit("snackbar", { snackbar: true, text: i18n.t("selectDealer") });
      } else {
        const url =
          state.NeutrinoUrl +
          "operation/alertruck/fleet/reports/all?dealerid=" +
          DealerId;
        // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
        // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
        // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

        var request = {
          from: "GET_REPORTS",
          URL: url,
          method: "GET",
          responseType: "",
          headers: {
            Authorization: "bearer " + token,
            "Content-type": "application/json",
          },
          params: "",
        };

        await dispatch("ManageWorker", [request]);
      }
    } else {
      var lisOfReports = JSON.parse(localStorage.getItem("ListOfReports"));
      commit("setPermissions", true);
      commit("progressTable", false);
      if (lisOfReports != null && lisOfReports.length > 0) {
        commit("readListOfReports", lisOfReports);
      } else {
        commit("readListOfReports", []);
      }
    }
  },

  //CreateNew report
  async CreateReport({ dispatch, getters, commit, state }) {
    var token = state.token;
    var appID = localStorage.getItem("appID");
    if (token == null || token == "") token = localStorage.getItem("Token");
    commit("showMessage", [true, false]);
    var v_list = JSON.parse(localStorage.getItem("v_list"));
    var listVehicles = getters.listOfVehicles(state.vehicles);
    var metrics = getters.GetMetrics;
    var startDate = state.startDate + " " + getters.getTime("start");
    var endDate = state.endDate + " " + getters.getTime("end");
    const url = state.NeutrinoUrl + "operation/alertruck/fleet/reports";
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    const Report = {
      DealerId: state.dealerSelected.DealerId,
      ClientId: state.clientSelected.ClientId,
      StartDate: startDate,
      EndDate: endDate,
      ReportName: state.NameOfReport,
      ReportType: state.TypeOfReport == i18n.t("PerformanceReport") ? 0 : 1,
      //Test emails
      Emails: state.Emails,
      Metrics: metrics,
      Vehicles: listVehicles,
      RTCID: appID,
      ProfileUnitMeasure: {
        Distance: state.SelectedDistance,
        Volume: state.SelectedVolume === "L" ? "Lt" : state.SelectedVolume,
        Temperature: state.SelectedTemperature.replace("°", ""),
      },
    };

    var request = {
      from: "CREATE_REPORT",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: Report,
    };

    await dispatch("ManageWorker", [request]);
  },

  //Delete single report
  async DeleteReport({ getters, commit, dispatch, state }, Id) {
    var token =
      state.token == null || state.token == ""
        ? localStorage.getItem("Token")
        : state.token;

    const url =
      state.NeutrinoUrl + "operation/alertruck/fleet/reports?id=" + Id;
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    var request = {
      from: "DELETE_REPORT",
      URL: url,
      method: "DELETE",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };
    await dispatch("ManageWorker", [request]);
  },

  //Retrive only elements with status "Complete" or "urlBlob"
  getBlobs: ({ getters, dispatch }, Data) => {
    var reports = getters.getBlobsForDownload(Data);
    if (reports.length > 0) {
      reports.forEach((element) => {
        dispatch("getBlobAzure", element);
      });
    }
  },

  DeleteBlobs: ({ commit, dispatch }, Data) => {
    var reports = Data;
    if (reports.length > 0) {
      reports.forEach((element) => {
        dispatch("DeleteReport", element.Id);
      });
      commit("Allreports", []);
    }
  },

  //Download document from azure Blobs
  async getBlobAzure({ commit, state, dispatch }, report) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url =
      state.NeutrinoUrl +
      "operation/alertruck/fleet/reports/download?id=" +
      report.Id;
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    var request = {
      from: "GET_BLOB",
      URL: url,
      method: "GET",
      responseType: "blob",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };

    await dispatch("ManageWorker", [request, report]);
  },

  //Get all users with security
  async getSecureUsers({ commit, dispatch, state }) {
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");
      const url = state.NeutrinoUrl + "secure/user";
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "GET_SECURE_USERS",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };

      await dispatch("ManageWorker", [request]);
    } else {
      var secureUsers = JSON.parse(localStorage.getItem("secureUsers"));
      await commit("secureUsers", secureUsers);
    }
  },

  async addSecureUser({ commit, dispatch, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    let auth = {
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
    };
    const url = state.NeutrinoUrl + "secure/user";
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    payload.forEach((element, index) => {
      (async () => {
        var newSecureUser = { DealerId: element.DealerId, NIP: element.NIP };

        var request = {
          from: "ADD_SECURE_USER",
          URL: url,
          method: "POST",
          responseType: "",
          headers: {
            Authorization: "bearer " + token,
            "Content-type": "application/json",
          },
          params: newSecureUser,
        };

        await dispatch("ManageWorker", [request]);

        //if (payload.length == index + 1) dispatch("getSecureUsers");
      })();
    });
  },

  async editSecureUser({ commit, dispatch, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");

    const url = state.NeutrinoUrl + "secure/user";
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    var SecureUser = {
      Id: payload.Id,
      DealerName: payload.DealerName,
      Active: payload.Active,
    };

    var request = {
      from: "EDIT_SECURE_USER",
      URL: url,
      method: "PUT",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: SecureUser,
    };

    await dispatch("ManageWorker", [request]);
  },

  async delecteSecureUser({ commit, dispatch, state }, id) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");

    const url = state.NeutrinoUrl + "secure/user?Id=" + id;

    var request = {
      from: "DELETE_SECURE_USER",
      URL: url,
      method: "DELETE",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };

    await dispatch("ManageWorker", [request]);
  },

  //Delete item from pouchDB
  //item[0] as accessId for remove of pouchDB
  //item[1] as true or false for destroy DB and unauthorized page when user is no logged
  DeleteItemDB: ({ dispatch, commit, state }, item) => {
    try {
      if (item == "401") {
        commit("auth", false);
        dispatch("destroyDB");
      } else {
        if (item != null && item != undefined) {
          var accessID = item[0].toFixed();
          return new PouchDB("BosonNeutrino").get(
            accessID,
            { attachments: false },
            function(err, doc) {
              if (err) {
                return console.log(err);
              } else {
                return new PouchDB("BosonNeutrino").remove(
                  doc._id,
                  doc._rev,
                  function(err) {
                    if (err) {
                      return console.log(err);
                    } else {
                      if (item[1]) {
                        commit("auth", false);
                        dispatch("destroyDB");
                      }
                    }
                  }
                );
              }
            }
          );
        }
      }
    } catch (e) {
      commit("auth", false);
      dispatch("destroyDB");
    }
  },

  //Add single item for pouchDB
  //All data for add in pouchDB was be added in state for manage here
  AddItemDB: ({ dispatch, commit, state }) => {
    if (state.userData != null) {
      var accessID = state.SelectedAccess.AccessId.toFixed();
      localStorage.setItem("userDateToken", moment().format("x"));
      localStorage.setItem("Token", state.token);
      try {
        var userInfo = {
          _id: accessID,
          date: moment().format("x"),
          token: state.token,
          refreshToken: state.tokenInfo,
          user: state.userData.Email,
          DealerId: state.SelectedAccess.DealerId,
          ClientId: state.SelectedAccess.ClientId,
          UserData: state.userData,
          Access: state.SelectedAccess,
          completed: false,
        };

        return new PouchDB("BosonNeutrino").put(userInfo, function callback(
          err,
          result
        ) {
          if (!err) {
            commit("setLastUser", userInfo);
            //Timer for refresh token
            dispatch("refreshTimer");
          } else {
            if (err.status == "409") {
              //If item already exist then this is updated in pouchDB
              console.log("Access already exist");
              dispatch("UpdateItemDB");
            } else {
              console.log("Error" + err);
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      //no userdata
    }
  },

  //Update item for pouchDB
  //When user alreadyExist
  //Only for current logged user and access valid
  UpdateItemDB: ({ dispatch, commit, state }) => {
    if (state.userData != null) {
      var accessID = state.SelectedAccess.AccessId.toFixed();
      new PouchDB("BosonNeutrino").get(
        accessID,
        { attachments: false },
        function callback(err, doc) {
          if (err) {
            console.log(err);
            dispatch("AddItemDB");
          } else {
            new PouchDB("BosonNeutrino").remove(doc._id, doc._rev, function(
              err
            ) {
              if (err) {
                return console.log(err);
              } else {
                dispatch("AddItemDB");
              }
            });
          }
        }
      );
    } else {
      //no userdata
    }
  },

  //Get all items from PouchDB
  getAllItemsDB: ({ dispatch, commit, state }) => {
    return new PouchDB("BosonNeutrino").allDocs(
      { include_docs: true, descending: true },
      function(err, doc) {
        if (err) {
          console.log(err);
          dispatch("destroyDB");
        } else {
          var array = doc.rows;
          if (doc.rows != undefined && doc.total_rows != 0) {
            dispatch("lastUserDB", array);
          } else {
            dispatch("destroyDB");
            commit("auth", false);
          }
        }
      }
    );
  },

  //Destroy current DB from PouchDB
  destroyDB: ({ dispatch, commit, state }) => {
    return new PouchDB("BosonNeutrino").destroy(function(err, response) {
      if (err) {
        console.log("Error on desroy DB");
      } else {
        localStorage.removeItem("auth");
        localStorage.removeItem("SelectedAccess");
        localStorage.removeItem("appID");
        localStorage.removeItem("Token");
        localStorage.removeItem("userDateToken");
        localStorage.removeItem("initialSettings");
        commit("viewSkeletons", true);
        commit("viewSkeletonsT", true);
      }
    });
  },

  //Get current last user valid
  lastUserDB: ({ dispatch, commit, state }, array) => {
    var lastUser;
    //Compare docs dates for check last user
    array.forEach((element, index) => {
      if (index == 0) lastUser = element.doc;
      if (lastUser.date < element.doc.date) {
        lastUser = element.doc;
      }
    });

    //Delete users from pouchDB and logged out from authO
    array.forEach((element, index) => {
      if (element.doc._id != lastUser._id) {
        var payload = [element.doc.token, element.doc.Access];
        dispatch("logOutApp", payload);
      }
    });

    if (
      lastUser != undefined &&
      lastUser.refreshToken.refresh_token != undefined
    ) {
      var currentDate = moment().format("x");

      var substract = Math.round((currentDate - lastUser.date) / 1000) / 60;

      //Verifing validation of user token
      if (substract >= 18) {
        var payload = [lastUser.token, lastUser.Access];
        dispatch("logOutApp", payload);
        commit("auth", false);
      } else {
        var payload = [
          lastUser.UserData,
          lastUser.Access,
          lastUser.refreshToken.refresh_token,
        ];
        commit("auth", true);
        dispatch("refreshToken", payload);
      }
    } else {
      commit("auth", false);
    }
  },

  //Apply timmer for call refresh token
  refreshTimer: ({ dispatch, commmit, state }, item) => {
    setTimeout(() => {
      dispatch("refreshToken");
    }, 900000);

    //change timer 1080000
  },

  reportValidations: ({ dispatch, commit, state }) => {
    if (state.hiddeDetails == true && state.hiddeSummary == false) {
      dispatch("CreateReport");
    } else {
      if (state.hiddeFilterV == true || state.hiddeDetails == false) {
        if (!state.NameOfReport.replace(/\s/g, "").length) {
          commit("snackbar", {
            snackbar: true,
            text: i18n.t("invalidName"),
          });
        } else {
          var startHour = moment(state.startTimeH, "h:mma");
          var endHour = moment(state.endTimeH, "h:mma");
          if (startHour.isBefore(endHour) || state.startDate != state.endDate) {
            var days = moment(state.endDate).diff(
              moment(state.startDate),
              "days"
            );
            if (days <= 60) {
              commit("toContinueStepper");
            } else {
              commit("snackbar", {
                snackbar: true,
                text: i18n.t("errorFechas"),
              });
            }
          } else {
            //invalid
            commit("errorMessage", ["Periodo de fechas invalido", true]);
          }
        }
      } else {
        commit("toContinueStepper");
      }
    }
  },
  handleConnectivityChange: ({ dispatch, commit, state }, status) => {
    if (status == false) {
      localStorage.setItem("offline", true);
      commit("snackbar", {
        snackbar: true,
        text: i18n.t("offline"),
      });
    } else {
      localStorage.setItem("offline", false);
      if (router.app.$route.path != "/login" || router.app.$route.path != "/") {
        if (state.loginOffline) {
          commit("loginOffline", false);
          var userAccess = JSON.parse(localStorage.getItem("SelectedAccess"));
          dispatch("getToken", userAccess);
        } else {
          var userAccess = JSON.parse(localStorage.getItem("SelectedAccess"));
          var refreshToken =
            localStorage.getItem("refreshToken") != null ||
            localStorage.getItem("refreshToken") != undefined
              ? localStorage.getItem("refreshToken")
              : state.refreshToken;
          var userData = { Email: localStorage.getItem("userName") };
          var payload = [userData, userAccess, refreshToken];
          dispatch("refreshToken", payload);
        }
      }
    }
  },

  fillChartsTraffic: ({ commit, state, getters }, payload) => {
    var arr = payload;
    //console.log(arr);
    var list = getters.listTraffic(arr);

    var charttraffic = getters.trafficChart([
      i18n.t("operatingStates"),
      "Total: " + arr.length,
      state.colorTheme,
      '<span style="color:{series.color}">' +
        i18n.t("vehicles") +
        ": " +
        "</span>" +
        "{point.y}",
      i18n.t("vehicles"),
      list,
      state.statusTraffic,
      "",
      "traffic",
      undefined,
      "{point.key}",
      '<span style="font-size:11px">{point.x}</span><br>',
    ]);

    commit("saveChartsTraffic", charttraffic);
  },

  //Función para crear las gráficas de dashboard
  fillCharts: ({ commit, state, getters, dispatch }, payload) => {
    //Fuel ranking
    var keysNick = getters.getVehiclesKeys(payload.Fuel.Ralenti.Ranking);

    //Performance ranking
    var keysNickPerformance = getters.getVehiclesKeys(
      payload.Performance.Ranking
    );

    //Ranking engine usage
    var keysNickEngineUsage = getters.getVehiclesKeys(
      payload.EngineUsage.Ralenti.Ranking
    );

    //Ranking driver behavior
    var keysNickBehavior = getters.getVehiclesKeys(
      payload.IntransitIncidents.Ranking
    );

    var fuelArr = getters.getArr([payload.Fuel.Ralenti.Ranking, 0]);
    var performancArr = getters.getArr([payload.Performance.Ranking, 1]);
    var engineArr = getters.getArr([
      payload.EngineUsage.Ralenti.Ranking,
      false,
    ]);
    var behaviorsArr = getters.getArr([
      payload.IntransitIncidents.Ranking,
      false,
    ]);

    //Totales
    var totalFuel = payload.Fuel.Total;
    var ralentiFuel2 = payload.Fuel.Ralenti.Total;
    var PtoFuel = payload.Fuel.Pto.Total;
    PtoFuel = PtoFuel > 0 ? PtoFuel : 0;
    var fuelUsedTotal = totalFuel - ralentiFuel2 - PtoFuel;
    var engineUsage =
      payload.EngineUsage.Driving > 0 ? payload.EngineUsage.Driving : 0;
    var engineRalenti =
      payload.EngineUsage.Ralenti.Total > 0
        ? payload.EngineUsage.Ralenti.Total
        : 0;
    var enginePto =
      payload.EngineUsage.Pto.Total > 0 ? payload.EngineUsage.Pto.Total : 0;
    enginePto = enginePto > 0 ? enginePto : 0;

    //PieChart performance
    var performancePieChart = getters.performanceArr(
      payload.Performance.Categories
    );

    //PieChart Exceptions
    var pieChartExcept = getters.exceptionsArr(
      payload.IntransitIncidents.Scores
    );

    var SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    var Distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    //Ranking fuel Ralenti
    var chartRalentiFuel = getters.genericChart([
      i18n.t("moreRalenti"),
      i18n.t("fuel") + " (litros)",
      "#2f7573",
      '<span style="color:{series.color}">' +
        "Id: " +
        "</span>" +
        "{point.id} <br/><br/>" +
        '<span style="color:{series.color}">' +
        i18n.t("volume") +
        "</span>" +
        ": <b>{point.y} " +
        SelectedVolume +
        "</b>",
      "Ralentifuel",
      fuelArr,
      keysNick,
      "",
      "RalentiFuel",
      i18n.t("topRalenti"),
      "{point.y} " + SelectedVolume,
    ]);

    //Rankin rendimientos
    var chartFuelLowRange = getters.genericChart([
      i18n.t("menorRendimiento"),
      i18n.t("fuel") + " (litros)",
      "#2f7573",
      '<span style="color:{series.color}">' +
        "Id: " +
        "</span>" +
        "{point.id} <br/><br/>" +
        '<span style="color:{series.color}">' +
        i18n.t("rendimientoFuel") +
        "</span>" +
        ": <b>{point.y} " +
        Distance +
        "/" +
        SelectedVolume +
        "</b>",
      i18n.t("rendimientoFuel"),
      performancArr,
      keysNickPerformance,
      "",
      "FuelLowRange",
      i18n.t("topPerformance"),
      "{point.y} " + Distance + "/" + SelectedVolume,
    ]);

    //Ranking engine
    var chartMoreTimeEngineOn = getters.genericChart([
      i18n.t("moreTimeEngine"),
      i18n.t("hour"),
      "#2f7573",
      '<span style="color:{series.color}">' +
        "Id: " +
        "</span>" +
        "{point.id} <br/><br/>" +
        '<span style="color:{series.color}">' +
        i18n.t("hour") +
        "</span>" +
        ": <b>{point.y} </b>",
      i18n.t("timeEngineOn"),
      engineArr,
      keysNickEngineUsage,
      "",
      "MoreTimeEngineOn",
      i18n.t("topEngine"),
      "{point.y} H",
    ]);

    //Ranking exceptions
    var chartMoreExceptions = getters.genericChart([
      i18n.t("moreExcept"),
      i18n.t("exceptions"),
      "#2f7573",
      '<span style="color:{series.color}">' +
        "Id: " +
        "</span>" +
        "{point.id} <br/><br/>" +
        '<span style="color:{series.color}">' +
        "Total" +
        "</span>" +
        ": <b>{point.y} </b>",
      i18n.t("exceptions"),
      behaviorsArr,
      keysNickBehavior,
      "",
      "MoreExceptions",
      i18n.t("topExceptions"),
      "{point.y}",
    ]);

    var totalFuelUsed =
      SelectedVolume == "L"
        ? totalFuel
        : parseFloat(totalFuel / 3.78541).toFixed(1);

    //PieChart fuel used
    var fuelUsed = getters.changeUnitsfuelUsed([
      [i18n.t("drive"), fuelUsedTotal, false],
      [i18n.t("ralenti"), ralentiFuel2, false],
      ["Pto", PtoFuel, false],
    ]);
    var pieChartfuelUsed = getters.pieGenericChart([
      i18n.t("totalFuel"),
      fuelUsed,
      0,
      "center",
      20,
      "0.7rem",
      "fuelUsed",
      i18n.t("volume"),
      "Total: " + formatNumber.new(totalFuelUsed, SelectedVolume),
    ]);

    //PieChart performance falta cambiar rangos del sistema de unidades
    var pieChartFuelRange = getters.pieGenericChart([
      i18n.t("rangeFuel") + " (" + Distance + "/" + SelectedVolume + ")",
      performancePieChart,
      0,
      "center",
      state.itemDistanceFuelRange,
      "0.7rem",
      "FuelRange",
      "Total",
      "",
    ]);

    //Pie chart engine on new design
    var EngineOn = engineUsage + engineRalenti + enginePto;
    EngineOn = enginePto > 0 ? EngineOn + enginePto : EngineOn;
    EngineOn = parseFloat(EngineOn).toFixed(2);

    var dataEngine = [];
    if (engineUsage >= 0) {
      var engineU = [i18n.t("drive"), engineUsage, false];
      dataEngine.push(engineU);
    }
    if (engineRalenti >= 0) {
      var engineR = [i18n.t("stop"), engineRalenti, false];
      dataEngine.push(engineR);
    }
    if (enginePto >= 0) {
      var engineP = ["Pto", enginePto, false];
      dataEngine.push(engineP);
    }

    var pieChartEngineOn = getters.pieGenericChart([
      i18n.t("engineTime"),
      dataEngine,
      0,
      "center",
      20,
      "0.7rem",
      "EngineOn",
      i18n.t("hour"),
      //"Total: " + formatNumber.new(EngineOn, "H"),
      "Total: " + getters.splitTime({ time: EngineOn }),
    ]);

    //Pie chart exceptions
    var pieChartExceptions = getters.pieGenericChart([
      i18n.t("exceptions"),
      pieChartExcept,
      state.xchart,
      state.alignchart,
      state.itemDistanceExceptions,
      "0.7rem",
      "Exceptions",
      "Total",
      "Total: " + formatNumber.new(payload.IntransitIncidents.Total, ""),
    ]);

    //Save charts
    commit("saveCharts", [
      pieChartfuelUsed,
      chartRalentiFuel,
      pieChartFuelRange,
      chartFuelLowRange,
      pieChartEngineOn,
      chartMoreTimeEngineOn,
      pieChartExceptions,
      chartMoreExceptions,
    ]);

    //EngineOnTime

    var colors = [
      {
        color: "#084475",
      },
      {
        color: "#2f7573",
      },
      {
        color: "#2b59a2",
      },
    ];

    var arr = [];
    var total = 0;
    dataEngine.forEach((element, index) => {
      var obj = {
        name: element[0],
        y: element[1],
        color: colors[index].color,
      };

      arr.push(obj);

      if (element[0] != "Pto") {
        total += element[1];
      }
    });

    if (total == 0) {
      var obj = {
        name: "",
        color: "#eaeaea",
        y: 100,
      };
      arr.push(obj);
    }

    total = parseFloat(total.toFixed(2));

    dispatch("createChartsDetailsTravelEfficiency", {
      data: "EngineOn",
      myData: arr,
      total: total,
      name: i18n.t("engineTime"),
    });
  },

  fillExceptionCharts: ({ dispatch, commit, state, getters }, payload) => {
    var arrs = [87, 81, 76, 70, 54, 53, 44, 26, 21, 15];
    var categ = [
      "NICK-1",
      "NICK-2",
      "NICK-3",
      "NICK-4",
      "NICK-5",
      "NICK-6",
      "NICK-7",
      "NICK-8",
      "NICK-9",
      "NICK-10",
    ];
    var tooltip =
      '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b><br/>';
    //Columns
    var chartSpeedExcess = getters.genericChart([
      i18n.t("ExcessSpeed"),
      i18n.t("NumberExceptions"),
      "#2F7573",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "speedExcess",
    ]);
    var chartBrusqueAccelerations = getters.genericChart([
      i18n.t("BrusqueAccelerations"),
      i18n.t("NumberExceptions"),
      "#084475",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "brusqueAccelerations",
    ]);
    var chartBrakedBrusque = getters.genericChart([
      i18n.t("Brushesbrakes"),
      i18n.t("NumberExceptions"),
      "#2b59a2",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "brakedBrusque",
    ]);
    var chartExcessMotoLoad = getters.genericChart([
      i18n.t("ExcessMotorLoad"),
      i18n.t("NumberExceptions"),
      "#75808c",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "excessMotoLoad",
    ]);
    //PieChart
    var pieChartExcessRPM = getters.genericChart([
      i18n.t("ExcessRPM"),
      i18n.t("NumberExceptions"),
      "#3E6D8C",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "excessRPM",
    ]);
    var pieChartClutchExcesses = getters.genericChart([
      i18n.t("ExcessClutch"),
      i18n.t("NumberExceptions"),
      "#3186AD",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "clutchExcesses",
    ]);
    var pieChartRoundBrushes = getters.genericChart([
      i18n.t("SharpTurns"),
      i18n.t("NumberExceptions"),
      "#2b648a",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "roundBrushes",
    ]);
    var pieChartexcessEngineHours = getters.genericChart([
      i18n.t("ExcessEngineHours"),
      i18n.t("NumberExceptions"),
      "#55829F",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "excessEngineHours",
    ]);
    var pieChartmotorVacuumExceeces = getters.genericChart([
      i18n.t("ExcessEngineVacuum"),
      i18n.t("NumberExceptions"),
      "#576873",
      tooltip,
      i18n.t("NumberExceptions"),
      arrs,
      categ,
      "",
      "motorVacuumExceeces",
    ]);

    commit("saveChartsEx", [
      chartSpeedExcess,
      chartBrusqueAccelerations,
      chartBrakedBrusque,
      chartExcessMotoLoad,
      pieChartExcessRPM,
      pieChartClutchExcesses,
      pieChartRoundBrushes,
      pieChartexcessEngineHours,
      pieChartmotorVacuumExceeces,
    ]);
  },

  chartFillAcountBalance: ({ dispatch, commit, state, getters }, payload) => {
    var arrsRalentifuel = getters.changeUnits([200, 150]);
    var arrdrivefuel = getters.changeUnits([852, 924]);
    var arrRalentifuelWeek = getters.changeUnits([200, 150, 200, 150]);
    var arrdrivefuelWeek = getters.changeUnits([600, 150, 200, 150]);
    var arrdistance = getters.changeUnitsDistance([2000, 4500]);
    var arrdistanceWeek = getters.changeUnitsDistance([2000, 4500, 2000, 4500]);
    var arrrendi = getters.changeUnitsPerformance([2.3, 4.5]);
    var arrrendiWeek = getters.changeUnitsPerformance([2.3, 4.5, 1.5, 2.75]);

    var SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    var SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    var tooltipVolume =
      '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} ' +
      SelectedVolume +
      "</b> ({point.percentage:.0f}%)<br/>";
    var tooltipDistance =
      '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} ' +
      SelectedDistance +
      "</b> ({point.percentage:.0f}%)<br/>";
    var tooltipPerformance =
      '<span style="color:{series.color}">{series.name}</span>: <b>{point.y} ' +
      SelectedDistance +
      "/" +
      SelectedVolume +
      "</b> ({point.percentage:.0f}%)<br/>";

    var fillTotalFuel = getters.charFillmultiple([
      i18n.t("totalFuel"),
      i18n.t("fuel") + "(" + SelectedVolume + ")",
      "Ralentifuel",
      arrsRalentifuel,
      i18n.t("drivefuel"),
      arrdrivefuel,
      ["Junio", "Julio"],
      "TotalFuel",
      400,
      ["#2f7573", "#2b59a2"],
      tooltipVolume,
    ]);

    var fillFuelWeek = getters.charFillmultiple([
      i18n.t("compSemanal"),
      i18n.t("fuel") + "(" + SelectedVolume + ")",
      "Ralentifuel",
      arrRalentifuelWeek,
      i18n.t("drivefuel"),
      arrdrivefuelWeek,
      [
        "01/06/2019 - 15/06/2019",
        "16/06/2019 - 30/06/2019",
        "01/07/2019 - 15/07/2019",
        "16/07/2019 - 30/07/2019",
      ],
      "FuelWeek",
      700,
      ["#2f7573", "#2b59a2"],
      tooltipVolume,
    ]);

    var fillEngineOnTime = getters.charFillmultiple([
      i18n.t("engineTime"),
      i18n.t("hour"),
      i18n.t("emtyHours"),
      [50, 150],
      i18n.t("driveHours"),
      [20, 100],
      ["Junio", "Julio"],
      "EngineOnTime",
      400,
      ["#8fae2d", "#8d8d8d"],
    ]);

    var fillEngineOnWeek = getters.charFillmultiple([
      i18n.t("engineOnWeek"),
      i18n.t("hour"),
      i18n.t("emtyHours"),
      [50, 150, 50, 150],
      i18n.t("driveHours"),
      [20, 100, 50, 150],
      [
        "01/06/2019 - 15/06/2019",
        "16/06/2019 - 30/06/2019",
        "01/07/2019 - 15/07/2019",
        "16/07/2019 - 30/07/2019",
      ],
      "EngineOnWeek",
      700,
      ["#8fae2d", "#8d8d8d"],
    ]);

    var fillDistance = getters.charFillsimple([
      i18n.t("distancRoad"),
      SelectedDistance,
      i18n.t("distance"),
      arrdistance,
      ["Junio", "Julio"],
      "Distance",
      400,
      ["#467fd7"],
      tooltipDistance,
    ]);

    var fillDistanceWeek = getters.charFillsimple([
      i18n.t("weekDistances"),
      SelectedDistance,
      i18n.t("distance"),
      arrdistanceWeek,
      [
        "01/06/2019 - 15/06/2019",
        "16/06/2019 - 30/06/2019",
        "01/07/2019 - 15/07/2019",
        "16/07/2019 - 30/07/2019",
      ],
      "DistanceWeek",
      700,
      ["#467fd7"],
      tooltipDistance,
    ]);

    var fillRendimiento = getters.charFillsimple([
      i18n.t("rendi"),
      SelectedDistance + "/" + SelectedVolume,
      i18n.t("rendi"),
      arrrendi,
      ["Junio", "Julio"],
      "Rendimiento",
      400,
      ["#f5a44d"],
      tooltipPerformance,
    ]);

    var RendimientoSemanal = getters.charFillsimple([
      i18n.t("weekRend"),
      SelectedDistance + "/" + SelectedVolume,
      i18n.t("rendi"),
      arrrendiWeek,
      [
        "01/06/2019 - 15/06/2019",
        "16/06/2019 - 30/06/2019",
        "01/07/2019 - 15/07/2019",
        "16/07/2019 - 30/07/2019",
      ],
      "RendimientoSemanal",
      400,
      ["#f5a44d"],
      tooltipPerformance,
    ]);

    commit("saveChartsFill", [
      fillTotalFuel,
      fillFuelWeek,
      fillEngineOnTime,
      fillEngineOnWeek,
      fillDistance,
      fillDistanceWeek,
      fillRendimiento,
      RendimientoSemanal,
    ]);
  },

  //Add user and password from DB
  AddRememberUserDB: ({ dispatch, commit, state }) => {
    if (state.remember == true) {
      try {
        var UserId = state.userData.UserId.toFixed();
        var userInfo = {
          _id: UserId,
          date: moment().format("x"),
          user: state.username,
          password: state.password,
        };
        return dbU.put(userInfo, function callback(err, result) {
          if (!err) {
          } else {
            if (err.status == "409") {
              //If item already exist then this is updated in pouchDB
              console.log("Access already exist");
              dispatch("UpdateRememberUserDB");
            } else {
              console.log("Error" + err);
            }
          }
        });
      } catch (e) {
        console.log(e);
      }
    }
  },

  UpdateRememberUserDB: ({ dispatch, commit, state }) => {
    var UserId = state.userData.UserId.toFixed();
    dbU.get(UserId, { attachments: false }, function callback(err, doc) {
      if (err) {
        console.log(err);
      } else {
        dbU.remove(doc._id, doc._rev, function(err) {
          if (err) {
            return console.log(err);
          } else {
            dispatch("AddRememberUserDB");
          }
        });
      }
    });
  },

  GetAllRememberUserDB: ({ dispatch, commit, state }) => {
    return dbU.allDocs({ include_docs: true, descending: true }, function(
      err,
      doc
    ) {
      if (err) {
        console.log(err);
      } else {
        var array = doc.rows;
        if (doc.rows != undefined && doc.total_rows != 0) {
          dispatch("lastRememberUserDB", array);
          commit("rememberMe", true);
        }
      }
    });
  },
  lastRememberUserDB: ({ dispatch, commit, state }, array) => {
    var lastUser;
    array.forEach((element, index) => {
      if (index == 0) lastUser = element.doc;
      if (lastUser.date < element.doc.date) {
        lastUser = element.doc;
      }
    });
    commit("userEntry", lastUser.user);
    commit("passEntry", lastUser.password);
  },
  checkPermits: ({ dispatch, commit, state, getters }, userData) => {
    if (userData.Level != "Master") {
      var selectedAccess = userData.ServiceList;
      if (typeof selectedAccess === "object" && selectedAccess !== null) {
        // if (selectedAccess.AlertTruck == false) {
        //   commit("invalidUser", true);
        // }
        if (
          selectedAccess.AlertTruck == true ||
          selectedAccess.AlertFuel_Individual == true ||
          selectedAccess.Tracking == true
        ) {
        } else {
          commit("invalidUser", true);
        }
      } else {
        return commit("invalidUser", true);
      }
    }
  },
  onlyDestroyCharts: ({ dispatch, commit, state }) => {
    var charts = [];
    if (router.app.$route.path == "/dashboard") {
      charts = state.chartsDashboard;
    } else if (router.app.$route.path == "/vehiclesExceptions") {
      charts = state.chartsvehiclesExceptions;
    } else if (router.app.$route.path == "/accountBalancePage") {
      charts = state.chartsAcountBalance;
    } else if (router.app.$route.path == "/traffic") {
      charts = ["traffic"];
    } else if (router.app.$route.path == "/dashboard/performance") {
      charts = state.chartsDashboard;
    }

    charts.forEach(function(element) {
      var AllCharts = new Highcharts.Chart(element, state + element);
      AllCharts.destroy();
    });
  },
  customCharts: ({ dispatch, commit, state }, value) => {
    if (router.app.$route.path == "/dashboard") {
      dispatch("onlyDestroyCharts");
      //Values for create charts
      commit("setChartsValue");
      dispatch("fillCharts", value);
    } else if (router.app.$route.path == "/vehiclesExceptions") {
      dispatch("onlyDestroyCharts");
      //Values for create charts
      commit("setChartsValue");
      dispatch("fillExceptionCharts");
    } else if (router.app.$route.path == "/accountBalancePage") {
      dispatch("onlyDestroyCharts");
      //Values for create charts
      commit("setChartsValue");
      dispatch("chartFillAcountBalance");
    } else if (
      router.app.$route.path == "/traffic" &&
      value[1] == "TrafficList"
    ) {
      dispatch("onlyDestroyCharts");
      //Values for create charts
      commit("setChartsValue");
      dispatch("fillChartsTraffic", value[0]);
    } else if (router.app.$route.path == "/dashboard/performance") {
      dispatch("onlyDestroyCharts");
      //Values for create charts
      commit("setChartsValue");
      dispatch("fillCharts", value);
    }
  },

  createDetailsChart: ({ state, dispatch, commit }) => {
    var ItemsDashboard = JSON.parse(localStorage.getItem("ItemsDashboard"));
    dispatch("fillCharts", ItemsDashboard);
    commit("viewSkeletons", false);
  },

  DeletedLocalStorage: ({}) => {
    localStorage.removeItem("datesCalendar1");
    localStorage.removeItem("datesCalendar2");
    localStorage.removeItem("DealerId");
    localStorage.removeItem("DealerSelectedId");
    localStorage.removeItem("ClientSelectedId");
    localStorage.removeItem("AccountSelectedId");
    localStorage.removeItem("GroupSelectedId");
    localStorage.removeItem("initialSettings");
    localStorage.removeItem("ItemsDashboard");
    localStorage.removeItem("Distance");
    localStorage.removeItem("Volume");
    localStorage.removeItem("Temperature");
    localStorage.removeItem("vehicles");
    localStorage.removeItem("darkMode");
    localStorage.removeItem("colorSelected");
    localStorage.removeItem("v_list");
    localStorage.removeItem("userImage");
    localStorage.removeItem("imageLogo");
    localStorage.removeItem("Dealer_Id");
    localStorage.removeItem("Client_Id");
    localStorage.removeItem("Account_Id");
    localStorage.removeItem("Group_Id");
    localStorage.removeItem("last_Request");
    localStorage.removeItem("vehicleAF");
    localStorage.removeItem("setitemsRetrieveLevel");
    localStorage.removeItem("setitemsPerformanceAF");
  },

    getItemsDashboard: ({ dispatch, commit, state, getters }, payload) => {
    if (router.app.$route.path == "/accountBalancePage") {
      dispatch("customCharts");
    } else {
      var v_list = JSON.parse(localStorage.getItem("v_list"));

      var dID = localStorage.getItem("Dealer_Id");

      var cID = localStorage.getItem("Client_Id");

      //Value ND
      var aID = localStorage.getItem("Account_Id");
      //Value ND
      var gID = localStorage.getItem("Group_Id");
      var initialSettings = JSON.parse(localStorage.getItem("initialSettings"));
      dispatch("getCarrierInfo");
      if (!initialSettings && v_list != null && v_list.length > 0) {
        //Aun no hay nada de filtro de vehiculos la primera vez que entra ?
        //Set value last request localstorage

        var lastRequest = JSON.parse(localStorage.getItem("last_Request"));

        var startDate = moment(localStorage.getItem("datesCalendar1")).format(
          "YYYY-MM-DD"
        );
        var endDate = localStorage.getItem("datesCalendar2");

        var ItemsDashboard = JSON.parse(localStorage.getItem("ItemsDashboard"));

        var vehicles = getters.listOfVehicles(v_list);

        //Undefined == first time
        if (lastRequest == undefined) {
          if (state.checkFastList) {
            if (state.vehiclesAggregates.length > 0) {
              vehicles = getters.listOfVehicles(state.vehiclesAggregates);
            }
          }

          //Considerar cuando last request no halla sido exitoso y el usuario haga un segundo intento
          var dateTimeStartRequest = startDate == undefined || startDate == null ? moment().format("YYYY-MM-DD") + "T00:00" : startDate + "T" + state.startClock
          var dateTimeEndRequest = endDate == undefined || endDate == null ? moment().format("YYYY-MM-DD") + "T23:59": endDate  + "T" + state.endClock;
          //&& online
          //SEND PARAMS AND DATE TODAY
          var params = {
            StartDate: dateTimeStartRequest,
            EndDate: dateTimeEndRequest,
            DealerId: dID,
            ClientId: cID,
            Vehicles: vehicles,
          };
          dispatch("getMetricsOverview", [params, aID, gID]);
        } else {
          //compare last request
          //Last request:
          //Params
          //DateTimeNow
          var dateEnd =
            endDate == undefined || endDate == "undefined"
              ? startDate
              : endDate;
          dateEnd = moment(dateEnd).format("YYYY-MM-DD");

          startDate = startDate + "T" + state.startClock;
          dateEnd = dateEnd + "T" + state.endClock;

          var currentDate =
            payload[0] &&
            (ItemsDashboard === undefined || ItemsDashboard === null)
              ? moment().format("x") + 600000
              : moment().format("x");

          var vehiclesList = true;
          if (state.vehiclesAggregates.length > 0) {
            if (state.checkFastList) {
              var vehiclesList = getters.validList(lastRequest[0].Vehicles);
            } else {
              if (
                currentDate > parseInt(lastRequest[3]) + 600000 ||
                lastRequest[0].Vehicles.length != vehicles.length
              ) {
                vehiclesList = false;
              }
            }
          } else {
            if (
              currentDate > parseInt(lastRequest[3]) + 600000 ||
              lastRequest[0].Vehicles.length != vehicles.length
            ) {
              vehiclesList = false;
            }
          }
          //Si se cumple una condicion se envia la peticion y se recargan los datos
          var lastRequestDate =
            lastRequest[0].StartDate != undefined
              ? lastRequest[0].StartDate.replace("T", " ")
              : startDate;
          var lastRequestDateEnd =
            lastRequest[0].EndDate != undefined
              ? lastRequest[0].EndDate.replace("T", " ")
              : endDate;
          if (
            //Cambio el filtro
            lastRequest[0].DealerId != dID ||
            lastRequest[0].ClientId != cID ||
            lastRequest[1] != aID ||
            lastRequest[2] != gID ||
            //Cambiaron las fechas
            lastRequestDate != startDate.replace("T", " ") ||
            lastRequestDateEnd != dateEnd.replace("T", " ") ||
            //Ya paso tiempo de la peticion 5 min
            //currentDate < lastRequest[3] + 300000  60000|| cambia a 10 min = 600000
            currentDate > parseInt(lastRequest[3]) + 600000 ||
            //ItemsDashboard == undefined || //&& online
            !vehiclesList
          ) {
            //Con uno que sea diferente ya puedo enviar la peticion
            if (state.checkFastList) {
              if (state.vehiclesAggregates.length > 0) {
                vehicles = getters.listOfVehicles(state.vehiclesAggregates);
              }
            }
            var params = {
              StartDate: startDate,
              EndDate: dateEnd,
              DealerId: dID,
              ClientId: cID,
              Vehicles: vehicles,
            };
            dispatch("getMetricsOverview", [params, aID, gID]);
          } else {
            //No se cumplio el tiempo ni el cambio en el filtro, solo hay que recargar la pagina
            if (ItemsDashboard == undefined && !state.titleAwait) {
              dispatch("setSkeletons", [false, ""]);
            } else if (
              ItemsDashboard != undefined &&
              ItemsDashboard.Distance == 0 &&
              ItemsDashboard.EngineUsage.Driving == 0 &&
              ItemsDashboard.Fuel.Total == 0 &&
              ItemsDashboard.Performance.Avg == 0 &&
              ItemsDashboard.IntransitIncidents.Total == 0
            ) {
              dispatch("setSkeletons", [true, i18n.t("errorDashboard")]); // sin datos
            } else if (ItemsDashboard != undefined) {
              // if (!state.titleAwait) {
              commit("viewSkeletons", false);
              commit("setItemsDashboard", ItemsDashboard);
              dispatch("customCharts", ItemsDashboard);
            }
          }
        }
      } else if (!initialSettings) {
        var account = aID == "NA" || aID == "ND" ? "" : aID;
        var group = gID == "NA" || gID == "ND" ? "" : gID;
        dispatch("getVehiclesCatalog", [
          "&did=" + dID + "&cid=" + cID + "&acid=" + account + "&gpid=" + group,
          true,
          false,
        ]);
      }
    }
  },
  setSkeletons: ({ dispatch, commit, state }, payload) => {
    commit("viewSkeletons", true);
    commit("skeleton", "outskeleton");
    commit("skeletonTitle", "outskeletonTitle");
    commit("skeletonPie", "outskeletonPie");
    commit("skeletonFooter", "outskeletonFooter");
    commit("skeletonColumn", "outskeletonColumn");
    commit("snackbar", { snackbar: payload[0], text: payload[1] });
    commit("viewAwait", [false, ""]);
  },
  setItemsDashboard: ({ dispatch, state, commit }, response) => {
    commit("viewAwait", [false, ""]);
    //Set values
    if (response.data.status == 200) {
      var driving = response.data.data.IntransitIncidents.Categories.DRIVING;
      if (driving != null && driving.length != 0) {
        for (
          var i =
            response.data.data.IntransitIncidents.Categories.DRIVING.length - 1;
          i >= 0;
          i--
        ) {
          if (
            response.data.data.IntransitIncidents.Categories.DRIVING[i].Id ===
            "481"
          ) {
            response.data.data.IntransitIncidents.Categories.DRIVING.splice(
              i,
              1
            );
          }
        }
      }
      var numEv481 = 0;
      var scores = response.data.data.IntransitIncidents.Scores;
      if (scores != null && scores.length != 0) {
        for (
          var i = 0;
          i < response.data.data.IntransitIncidents.Scores.length;
          i++
        ) {
          if (response.data.data.IntransitIncidents.Scores[i].Key === "481") {
            numEv481 = response.data.data.IntransitIncidents.Scores[i].Value;
          }
        }
      }
      if (scores != null && scores.length != 0) {
        for (
          var i = response.data.data.IntransitIncidents.Scores.length - 1;
          i >= 0;
          i--
        ) {
          if (response.data.data.IntransitIncidents.Scores[i].Key === "481") {
            response.data.data.IntransitIncidents.Scores.splice(i, 1);
          }
        }
      }
      response.data.data.IntransitIncidents.Total =
        response.data.data.IntransitIncidents.Total - numEv481;
      localStorage.setItem(
        "ItemsDashboard",
        JSON.stringify(response.data.data)
      );
      commit("disableButton", false);
      if (
        response.data.data.Distance == 0 &&
        response.data.data.EngineUsage.Driving == 0 &&
        response.data.data.Fuel.Total == 0 &&
        response.data.data.Performance.Avg == 0 &&
        response.data.data.IntransitIncidents.Total == 0
      ) {
        dispatch("setSkeletons", [true, i18n.t("errorDashboard")]); // sin datos
      } else {
        commit("setItemsDashboard", response.data.data);
        dispatch("customCharts", response.data.data);
        commit("viewSkeletons", false);
      }
    } else {
      localStorage.removeItem("ItemsDashboard");
      localStorage.removeItem("last_Request");
      commit("disableButton", false);
      dispatch("setSkeletons", [true, i18n.t("errorDashboard")]);
      dispatch("onlyDestroyCharts");
      if (response.data.status == 204 || response.data.status == 404) {
        commit("snackbar", {
          snackbar: true,
          text: i18n.t("notExistData"),
        });
      } else if (response.data.status == 500) {
        commit("snackbar", {
          snackbar: true,
          text: i18n.t("error400"),
        });
      }
    }
  },
  getMetricsOverview: ({ dispatch, commit, state }, params) => {
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      localStorage.removeItem("ItemsDashboard");
      //params[0] == parametros
      //params[1] && params[2] for compare filter
      dispatch("onlyDestroyCharts");
      commit("viewSkeletons", true);
      commit("disableButton", true);
      var token = state.token;
      if (token == null || token == "" || token == undefined) {
        token = localStorage.getItem("Token");
      }
      //console.log(token);

      var url =
        state.NeutrinoUrl + "operation/alertruck/fleet/metrics/overview";
      // var url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // var url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // var url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "OVERVIEW",
        URL: url,
        method: "POST",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: params[0],
      };

      localStorage.setItem(
        "last_Request",
        JSON.stringify([params[0], params[1], params[2], moment().format("x")])
      );

      //set title
      commit("viewAwait", [true, i18n.t("loadingData")]);

      setTimeout(() => {
        //set title
        commit("viewAwait", [state.viewSkeletons, i18n.t("lateData")]);
      }, 90000);
      //One minute test //two minutes == 120000 // 1.5 minutes = 90000

      dispatch("ManageWorker", [request]);
    } else {
      var ItemsDashboard = JSON.parse(localStorage.getItem("ItemsDashboard"));
      if (ItemsDashboard != undefined) {
        commit("viewAwait", [false, ""]);
        commit("setItemsDashboard", ItemsDashboard);
        dispatch("customCharts", ItemsDashboard);
        commit("viewSkeletons", false);
      } else {
        commit("snackbar", {
          snackbar: true,
          text: i18n.t("later"),
        });
      }
    }
  },
  exceptionsCharts: ({ dispatch, commit, state }) => {
    if (!state.infoChartExceptions) {
      commit("viewSkeletons", true);
      commit("exceptionsCharts");
      setTimeout(() => {
        commit("viewSkeletons", false);
      }, 5000);
      setTimeout(() => {
        dispatch("fillExceptionCharts");
      }, 4999);
    } else {
      commit("viewSkeletons", false);
      dispatch("fillExceptionCharts");
    }
  },
  setPersonalization: ({ dispatch, commit, state, getters }, payload) => {
    var request = {};
    if (payload[0] == "initialSettings") {
      request = { Account: {} };
      if (
        state.dealerSelected.DealerId != undefined &&
        state.dealerSelected.DealerId != i18n.t("all")
      ) {
        Object.assign(request.Account, {
          DealerId: state.dealerSelected.DealerId,
        });
      }
      if (
        state.clientSelected.ClientId != undefined &&
        state.clientSelected.ClientId != i18n.t("all")
      ) {
        Object.assign(request.Account, {
          ClientId: state.clientSelected.ClientId,
        });
      }
      if (
        state.accountSelected.AccountId != undefined &&
        state.accountSelected.AccountId != i18n.t("all")
      ) {
        Object.assign(request.Account, {
          AccountId: state.accountSelected.AccountId,
        });
      }
      if (
        state.groupSelected.GroupId != undefined &&
        state.groupSelected.GroupId != i18n.t("all")
      ) {
        Object.assign(request.Account, {
          GroupId: state.groupSelected.GroupId,
        });
      }
      var Temperature = state.SelectedTemperature;
      Temperature = Temperature.replace("°", "");
      Object.assign(request, {
        SU: {
          Distance: state.SelectedDistance,
          Volume: state.SelectedVolume,
          Temperature: Temperature,
        },
      });

      var lang = i18n.locale.trim() == "es" ? "es-mx" : "en-us";

      Object.assign(request, {
        Language: lang,
      });
    } else {
      var personalizacion = JSON.parse(localStorage.getItem("personalization"));
      request = JSON.parse(localStorage.getItem("personalization"));
      request.Media.MainLogo = "ND";
      request.Media.UserAvatar = "ND";
      request.SU.Distance = "ND";
      request.SU.Volume = "ND";
      request.SU.Temperature = "ND";
      request.Account.DealerId = "ND";
      request.Account.ClientId = "ND";
      request.Account.AccountId = "ND";
      request.Account.GroupId = "ND";
      request.Theme.PrimaryColor = "ND";

      if (payload[0] == "AccountFilters") {
        if (
          state.dealerSelected.DealerId != localStorage.getItem("Dealer_Id")
        ) {
          request.Account.DealerId = state.dealerSelected.DealerId;
        }
        if (
          state.clientSelected.ClientId != localStorage.getItem("Client_Id")
        ) {
          request.Account.ClientId = state.clientSelected.ClientId;
        }
        if (
          state.accountSelected.AccountId != localStorage.getItem("Account_Id")
        ) {
          if (state.accountSelected != i18n.t("all")) {
            request.Account.AccountId = state.accountSelected.AccountId;
          } else {
            request.Account.AccountId = "NA";
          }
        }
        if (state.groupSelected.GroupId != localStorage.getItem("Group_Id")) {
          if (state.groupSelected != i18n.t("all")) {
            request.Account.GroupId = state.groupSelected.GroupId;
          } else {
            request.Account.GroupId = "NA";
          }
        }
      }
      if (payload[0] == "imageLogo") {
        request.Media.MainLogo = payload[1];
      }
      if (payload[0] == "userImage") {
        request.Media.UserAvatar = payload[1];
      }
      if (payload[0] == "ColorSelect") {
        var colorTheme = payload[1];
        colorTheme = colorTheme.replace("#", "");
        request.Theme.PrimaryColor = colorTheme;
      }
      if (payload[0] == "SU") {
        request.SU.Distance = state.SelectedDistance;
        request.SU.Volume = state.SelectedVolume;
        request.SU.Temperature = state.SelectedTemperature.replace("°", "");
      }
      if (payload[0] == "Dark") {
        request.Theme.DarkMode = payload[1];
        personalizacion.Theme.DarkMode = payload[1];
      }
      if (payload[0] == "language") {
        var lang = payload[1] == "es" ? payload[1] + "-mx" : payload[1] + "-us";
        request.Language = lang;
      }
      localStorage.setItem("personalization", JSON.stringify(personalizacion));
    }
    var type = payload[0] == "initialSettings" ? "POST" : "PUT";
    dispatch("requestPersonalization", [request, type, payload]);
  },
  async requestPersonalization({ dispatch, commit, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    var personalization = payload[0];

    const url = state.NeutrinoUrl + "login/profile";
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    var request = {
      from: "PERSONALIZATION",
      URL: url,
      method: payload[1],
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: personalization,
    };
    await dispatch("ManageWorker", [request, payload[2]]);
  },

  responsePersonalization: ({ dispatch, commit, state }, payload) => {
    if (state.initialSettings) {
      localStorage.setItem("Volume", state.SelectedVolume);
      localStorage.setItem("Distance", state.SelectedDistance);
      localStorage.setItem("Temperature", state.SelectedTemperature);
      commit("initialSettings", false);
      commit("setAccount", false);
      localStorage.setItem("initialSettings", false);
      if (router.app.$route.path == "/individualFuel") {
        dispatch("getFuelVehicles");
      } else if (router.app.$route.path == "/tracking") {
        dispatch("startTrackingMap", true);
      } else if (router.app.$route.path == "/dashboard") {
        dispatch("getItemsDashboard", [true, false]);
      }
    }
    if (payload[0].data.data != "") {
      localStorage.setItem(
        "personalization",
        JSON.stringify(payload[0].data.data)
      );
    } else {
      //   console.log(payload[0].data.data);
      if (payload[1][0] == "userImage") {
        var type = localStorage.getItem("typeImageUser");
        var userData = JSON.parse(localStorage.getItem("SelectedAccess"));
        var urlimage =
          "https://btibucket.blob.core.windows.net/neutrino-web/user-profiles/" +
          userData.AccessId +
          "/media/images/Avatar." +
          type;
        dispatch("getUrlSAS", [urlimage, "UserAvatar", userData.AccessId]);
      }
      if (payload[1][0] == "imageLogo") {
        var type = localStorage.getItem("typeImageLogo");
        var userData = JSON.parse(localStorage.getItem("SelectedAccess"));
        var urlimage =
          "https://btibucket.blob.core.windows.net/neutrino-web/user-profiles/" +
          userData.AccessId +
          "/media/images/MainLogo." +
          type;
        dispatch("getUrlSAS", [urlimage, "MainLogo", userData.AccessId]);
      }
      if (payload[1][0] == "SU") {
        localStorage.setItem("Volume", state.SelectedVolume);
        localStorage.setItem("Distance", state.SelectedDistance);
        localStorage.setItem("Temperature", state.SelectedTemperature);
      }
    }
  },

  getUrlSAS: ({ dispatch, commit, state }, payload) => {
    var image = payload[0].replace(
      "https://btibucket.blob.core.windows.net/neutrino-web/user-profiles/" +
        payload[2] +
        "/media/images/",
      ""
    );
    var Azure = require("azure-storage");
    const blobService = Azure.createBlobService(
      "DefaultEndpointsProtocol=https;" +
        "AccountName=btibucket;" +
        "AccountKey=nNQXzrI06SvqDJD2E2wQYQ59e1s/EXbYxbA4iibfaOVVtCYZXQZod85yz1O/UtpTNFmQvhj8/qMx/39UxmjlFQ=="
    );

    const startDate = new Date();
    const expiryDate = new Date(startDate);

    startDate.setMinutes(startDate.getMinutes() - 5);
    expiryDate.setMinutes(startDate.getMinutes() + 60);

    const SharedAccessPolicy = {
      AccessPolicy: {
        Permissions: Azure.BlobUtilities.SharedAccessPermissions.READ,
        Start: startDate,
        Expiry: expiryDate,
      },
    };

    const sastoken = blobService.generateSharedAccessSignature(
      "neutrino-web",
      "user-profiles/" + payload[2] + "/media/images/" + image,
      SharedAccessPolicy
    );

    var sasUrl = blobService.getUrl(
      "neutrino-web",
      "user-profiles/" + payload[2] + "/media/images/" + image,
      sastoken
    );

    // console.log(sastoken);
    // console.log(sasUrl);

    Axios.get(sasUrl)
      .then(function(e) {
        if (payload[1] == "UserAvatar") {
          commit("userImage", sasUrl);
          localStorage.setItem("userImage", sasUrl);
        } else {
          commit("imageLogo", sasUrl);
          localStorage.setItem("imageLogo", sasUrl);
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  },
  LastUserAccess: ({ dispatch, commit, state }, payload) => {
    try {
      var accessID = state.SelectedAccess.AccessId.toFixed();
      var userInfo = {
        _id: accessID,
        user: payload[0],
        password: payload[1],
        refreshToken: payload[2],
        userAccess: payload[3],
      };
      return dbL.put(userInfo, function callback(err, result) {
        if (!err) {
        } else {
          if (err.status == "409") {
            //If item already exist then this is updated in pouchDB
            console.log("Access already exist");
          } else {
            console.log("Error" + err);
          }
        }
      });
    } catch (e) {
      console.log(e);
    }
  },
  async DeleteLastUser({ dispatch, commit, state }, payload) {
    return await new PouchDB("LastUser").destroy(function(err, response) {
      if (err) {
        console.log("error");
      } else {
        dbL = new PouchDB("LastUser");
        dispatch("LastUserAccess", payload);
      }
    });
  },
  async LastUserLogin({ dispatch, commit, state }) {
    return dbL.allDocs({ include_docs: true, descending: true }, function(
      err,
      doc
    ) {
      if (err) {
        console.log(err);
        commit("snackbar", {
          snackbar: true,
          text: i18n.t("later"),
        });
        commit("loginBtn", i18n.t("loginCard"));
        commit("progresslogin", false);
      } else {
        var array = doc.rows;
        if (doc.rows != undefined && doc.total_rows != 0) {
          if (
            array[0].doc.password == state.password &&
            array[0].doc.user == state.username
          ) {
            localStorage.setItem("userName", array[0].doc.user);
            localStorage.setItem("AccessId", array[0].doc.userAccess.AccessId);
            localStorage.setItem("auth", true);
            commit("getToken", [
              array[0].doc.refreshToken,
              array[0].doc.userAccess,
            ]);
            localStorage.setItem(
              "refreshToken",
              array[0].doc.refreshToken.refresh_token
            );
            localStorage.setItem("initialSettings", false);
            commit("initialSettings", false);
            commit("progresslogin", false);
            commit("setValuesLanguage");
            //router.replace({ name: "dashboard" });
            dispatch("beforeInit", array[0].doc.userAccess);
            dispatch("AddItemDB");
          } else {
            commit("snackbar", {
              snackbar: true,
              text: i18n.t("later"),
            });
            commit("loginBtn", i18n.t("loginCard"));
            commit("progresslogin", false);
          }
        } else {
          commit("snackbar", {
            snackbar: true,
            text: i18n.t("later"),
          });
          commit("loginBtn", i18n.t("loginCard"));
          commit("progresslogin", false);
        }
      }
    });
  },
  //async ListofOperators({ dispatch, commit, state }) {
  //  commit("progressOp", true);
  //  var url = "http://www.mocky.io/v2/5e7b8d582d0000979811a256";
  //  var request = {
  //    from: "OPERATOR_LIST",
  //    URL: url,
  //    method: "GET",
  //    responseType: "",
  //    headers: "",
  //    params: "",
  //  };
  //  await dispatch("ManageWorker", [request]);
  //},
  async AddDriver({ dispatch, commit, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url = state.NeutrinoUrl + "operation/traffic/driver";

    var params = {
      CarrierId: state.carrierId,
      Name: payload.name,
      Address: payload.Address,
      LicenseId: payload.licenseId,
      LicenseType: payload.licenseType,
      LicenseExpiration: payload.licenseExp,
    };

    var request = {
      from: "ADD_DRIVER",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };
    await dispatch("ManageWorker", [request]);
  },
  async EditOperator({ dispatch, commit, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url = state.NeutrinoUrl + "operation/traffic/driver";

    var params = {
      Id: payload.id,
      CarrierId: state.carrierId,
      Name: payload.name,
      Address: payload.Address,
      LicenseId: payload.licenseId,
      LicenseType: payload.licenseType,
      LicenseExpiration: payload.licenseExp,
      MobileIMEI: payload.Bonding == "N/A" ? "" : payload.Bonding,
    };

    var request = {
      from: "EDIT_DRIVER",
      URL: url,
      method: "PUT",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };
    await dispatch("ManageWorker", [request]);
  },
  async DeleteOperator({ dispatch, commit, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");

    const url = state.NeutrinoUrl + "operation/traffic/driver?Id=" + payload;

    var request = {
      from: "DELETE_DRIVER",
      URL: url,
      method: "DELETE",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };
    await dispatch("ManageWorker", [request]);
  },
  async ListofOperators({ dispatch, commit, state }) {
    commit("progressOp", true);
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      // dispatch("getCarrierInfo");
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");
      const url =
        state.NeutrinoUrl +
        "operation/traffic/driver/all?CarrierId=" +
        state.carrierId;
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "DRIVER_LIST",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };
      await dispatch("ManageWorker", [request]);
    } else {
      commit("progressOp", false);
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
    }
  },
  //async ListofMovil({ dispatch, commit, state }) {
  //  commit("progressMovil", true);
  //  var url = "http://www.mocky.io/v2/5e7bad592d0000610011a3ed";
  //  var request = {
  //    from: "MOVIL_LIST",
  //    URL: url,
  //    method: "GET",
  //    responseType: "",
  //    headers: "",
  //    params: "",
  //  };
  //  await dispatch("ManageWorker", [request]);
  //},
  async AddMovil({ dispatch, commit, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url = state.NeutrinoUrl + "operation/traffic/mobile";

    var params = {
      CarrierId: state.carrierId,
      IMEI: payload.IMEI,
      CallingCode: payload.CallingCode,
      PhoneNumber: payload.PhoneNumber,
      SO: payload.SO,
      BrandName: payload.BrandName,
      Model: payload.Model,
      SerialNumber: payload.SerialNumber,
    };

    var request = {
      from: "ADD_MOVIL",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };
    await dispatch("ManageWorker", [request]);
  },
  async ListofMovil({ dispatch, commit, state }) {
    commit("progressMovil", true);
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");
      const url =
        state.NeutrinoUrl +
        "operation/traffic/mobile/all?CarrierId=" +
        state.carrierId;
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "MOVIL_LIST",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };
      await dispatch("ManageWorker", [request]);
    } else {
      commit("progressMovil", false);
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
    }
  },
  async EditMobile({ dispatch, commit, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url = state.NeutrinoUrl + "operation/traffic/mobile";

    var params = {
      CarrierId: state.carrierId,
      IMEI: payload.IMEI,
      CallingCode: payload.CallingCode,
      PhoneNumber: payload.mobile,
      SO: payload.OS,
      BrandName: payload.marca,
      Model: payload.model,
      SerialNumber: payload.SerialNumber,
    };

    var request = {
      from: "EDIT_MOBILE",
      URL: url,
      method: "PUT",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };
    await dispatch("ManageWorker", [request]);
  },
  async DeleteMobile({ dispatch, commit, state }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");

    const url = state.NeutrinoUrl + "operation/traffic/mobile?imei=" + payload;

    var request = {
      from: "DELETE_MOBILE",
      URL: url,
      method: "DELETE",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };
    await dispatch("ManageWorker", [request]);
  },
  async AddTrip({ dispatch, commit, state, getters }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url = state.NeutrinoUrl + "operation/traffic/trip";
    //   console.log(state.enaEndDateT);

    if (state.enaEndDateT == false) {
      var stillUtc = moment.utc(payload.StartDate).format("MM/DD/YYYY HH:mm");
      var params = {
        CarrierId: state.carrierId,
        DriverId: payload.DriverId,
        VehicleId: payload.VehicleId,
        StartDate: stillUtc,
        TripName: payload.TripName,
        Origin: payload.Origin,
        Destination: payload.Destination,
        RouteName: payload.RouteName,
        OwnerName:
          state.userData.Email != null
            ? state.userData.Email
            : localStorage.getItem("userName"),
      };
    } else {
      var startStillUtc = moment
        .utc(payload.StartDate)
        .format("MM/DD/YYYY HH:mm");
      var endStillUtc = moment.utc(payload.EndDate).format("MM/DD/YYYY HH:mm");
      var params = {
        CarrierId: state.carrierId,
        DriverId: payload.DriverId,
        VehicleId: payload.VehicleId,
        StartDate: startStillUtc,
        EndDate: endStillUtc,
        TripName: payload.TripName,
        Origin: payload.Origin,
        Destination: payload.Destination,
        RouteName: payload.RouteName,
        IsComplete: true,
        FinalizerName:
          state.userData.Email != null
            ? state.userData.Email
            : localStorage.getItem("userName"),
        FinalizedDate: moment.utc().format("MM/DD/YYYY HH:mm"),
        OwnerName:
          state.userData.Email != null
            ? state.userData.Email
            : localStorage.getItem("userName"),
      };
    }
    // console.log(params);
    var request = {
      from: "ADD_TRIP",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };
    await dispatch("ManageWorker", [request]);
  },
  async EditTrip({ dispatch, commit, state, getters }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url = state.NeutrinoUrl + "operation/traffic/trip";
    // console.log(state.enaEndDateT);
    // console.log(payload);
    if (router.app.$route.path == "/traffic") {
      var startDate = moment(payload.info.start, "DD/MM/YYYY h:mma");
      // console.log(startDate);
      var stillUtc = moment.utc(startDate).format("MM/DD/YYYY HH:mm");
      var params = {
        Id: payload.info.TripId,
        CarrierId: state.carrierId,
        DriverId: payload.info.DriverId,
        VehicleId: payload.info.vehicle,
        StartDate: stillUtc,
        EndDate: moment.utc().format("MM/DD/YYYY HH:mm"),
        TripName: payload.info.travelName,
        Origin: payload.info.origin,
        Destination: payload.info.destination,
        RouteName: payload.info.pathName,
        IsComplete: true,
        FinalizerName:
          state.userData.Email != null
            ? state.userData.Email
            : localStorage.getItem("userName"),
        FinalizedDate: moment.utc().format("MM/DD/YYYY HH:mm"),
        OwnerName:
          state.userData.Email != null
            ? state.userData.Email
            : localStorage.getItem("userName"),
      };
    } else {
      if (state.enaEndDateT == false) {
        var StillUtc = moment.utc(payload.StartDate).format("MM/DD/YYYY HH:mm");
        var params = {
          Id: payload.Id,
          CarrierId: state.carrierId,
          DriverId: payload.DriverId,
          VehicleId: payload.VehicleId,
          StartDate: StillUtc,
          TripName: payload.TripName,
          Origin: payload.Origin,
          Destination: payload.Destination,
          RouteName: payload.RouteName,
          OwnerName:
            state.userData.Email != null
              ? state.userData.Email
              : localStorage.getItem("userName"),
        };
      } else {
        var startStillUtc = moment
          .utc(payload.StartDate)
          .format("MM/DD/YYYY HH:mm");
        var endStillUtc = moment
          .utc(payload.EndDate)
          .format("MM/DD/YYYY HH:mm");
        var params = {
          Id: payload.Id,
          CarrierId: state.carrierId,
          DriverId: payload.DriverId,
          VehicleId: payload.VehicleId,
          StartDate: startStillUtc,
          EndDate: endStillUtc,
          TripName: payload.TripName,
          Origin: payload.Origin,
          Destination: payload.Destination,
          RouteName: payload.RouteName,
          IsComplete: true,
          FinalizerName:
            state.userData.Email != null
              ? state.userData.Email
              : localStorage.getItem("userName"),
          FinalizedDate: moment.utc().format("MM/DD/YYYY HH:mm"),
          OwnerName:
            state.userData.Email != null
              ? state.userData.Email
              : localStorage.getItem("userName"),
        };
      }
    }
    // console.log(params);
    var request = {
      from: "EDIT_TRIP",
      URL: url,
      method: "PUT",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };
    await dispatch("ManageWorker", [request]);
  },
  async DeleteTrip({ getters, commit, dispatch, state }, Id) {
    var token =
      state.token == null || state.token == ""
        ? localStorage.getItem("Token")
        : state.token;

    const url = state.NeutrinoUrl + "operation/traffic/trip?Id=" + Id;

    var request = {
      from: "DELETE_TRIP",
      URL: url,
      method: "DELETE",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };

    await dispatch("ManageWorker", [request]);
  },
  async ListOfTraffic({ dispatch, commit, state }) {
    commit("progressOverTraffic", true);
    // commit("progressTracking", true);
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      dispatch("onlyDestroyCharts");
      commit("viewSkeletonsT", true);
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");
      var carrierId = JSON.parse(localStorage.getItem("CarrierId"));
      if (carrierId == null) {
        state.carrierId = carrierId;
      } else {
        state.carrierId = carrierId.Id;
      }
      const url =
        state.NeutrinoUrl +
        "operation/traffic/fleet/overview?Id=" +
        state.carrierId; //check carrier
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "TRAFFIC_LIST",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };
      await dispatch("ManageWorker", [request]);
    } else {
      commit("progressOverTraffic", false);
      // commit("progressTracking", false);
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
    }
  },
  async ListVehiclesCarrier({ dispatch, commit, state }) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url =
      state.NeutrinoUrl +
      "operation/traffic/carrier/vehicles?CarrierId=" +
      state.carrierId;
    var request = {
      from: "VEHICLES_CARRIER",
      URL: url,
      method: "GET",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };
    await dispatch("ManageWorker", [request]);
  },
  async ListofCariers({ dispatch, commit, state }) {
    commit("progressCarrier", true);
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");
      var dealer = JSON.parse(localStorage.getItem("DealerSelectedId"));
      var dealerId;
      var nip;
      if (state.SelectedAccess.Level != "Master") {
        nip =
          state.dealerSelected.NIP == undefined ||
          state.dealerSelected.NIP == null
            ? dealer.NIP
            : state.dealerSelected.NIP;
        dealerId =
          state.dealerSelected.DealerId == undefined ||
          state.dealerSelected.DealerId == null
            ? dealer.DealerId
            : state.dealerSelected.DealerId;
      } else {
        nip = "NA";
        dealerId = "00000";
      }

      const url =
        state.NeutrinoUrl +
        "operation/traffic/carriers?did=" +
        dealerId +
        "&nip=" +
        nip;

      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "CARRIER_LIST",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };
      await dispatch("ManageWorker", [request]);
    } else {
      commit("progressCarrier", false);
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
    }
  },
  async AddCarrier({ dispatch, commit, state, getters }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url = state.NeutrinoUrl + "operation/traffic/carrier";
    var dealerId = state.dealerSelected.DealerId;
    var clientId = state.clientSelected.ClientId;
    var accountId =
      state.accountSelected.AccountId == undefined ||
      state.accountSelected.AccountId == null
        ? ""
        : state.accountSelected.AccountId;
    // console.log(dealerId);
    // console.log(clientId);
    // console.log(accountId);
    var contacts = [];
    if (payload.Contacts.length > 0) {
      var item = getters.AddContacts(payload.Contacts);
      contacts = item;
    }

    var params = {
      DealerId: dealerId,
      ClientId: clientId,
      AccountId: accountId,
      TradeName: payload.TradeName,
      BusinessName: payload.BusinessName,
      Address: payload.Address,
      ServiceType: payload.ServiceType,
      Modality: payload.Modality,
      Contacts: contacts,
    };
    //  console.log(params);
    var request = {
      from: "ADD_CARRIER",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };
    await dispatch("ManageWorker", [request]);
  },
  async getCarrierInfo({ dispatch, commit, state, getters }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");

    var dealerId = localStorage.getItem("Dealer_Id");

    var clientId = localStorage.getItem("Client_Id");

    var accountId = localStorage.getItem("Account_Id");

    accountId =
      accountId == undefined || accountId == null || accountId == "ND"
        ? "NA"
        : accountId;

    const url =
      state.NeutrinoUrl +
      "operation/traffic/carrier?did=" +
      dealerId +
      "&cid=" +
      clientId +
      "&acid=" +
      accountId;
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204
    var request = {
      from: "GET_CARRIER_INFO",
      URL: url,
      method: "GET",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };
    await dispatch("ManageWorker", [request]);
  },
  async EditCarrier({ dispatch, commit, state, getters }, payload) {
    var token = state.token;
    if (token == null || token == "") token = localStorage.getItem("Token");
    const url = state.NeutrinoUrl + "operation/traffic/carrier";
    var dealerId = state.dealerSelected.DealerId;
    var clientId = state.clientSelected.ClientId;
    var accountId =
      state.accountSelected.AccountId == undefined ||
      state.accountSelected.AccountId == null
        ? ""
        : state.accountSelected.AccountId;
    var contacts = [];
    if (payload.Contacts.length > 0) {
      var item = getters.EditContactsFull(payload.Contacts);
      contacts = item;
    }

    var params = {
      Id: payload.Id,
      DealerId: dealerId,
      ClientId: clientId,
      AccountId: accountId,
      TradeName: payload.TradeName,
      BusinessName: payload.BusinessName,
      Address: payload.Address,
      ServiceType: payload.ServiceType,
      Modality: payload.Modality,
      Contacts: contacts,
    };
    // console.log(params);
    var request = {
      from: "EDIT_CARRIER",
      URL: url,
      method: "PUT",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };
    await dispatch("ManageWorker", [request]);
  },
  DeleteAllCarriers: ({ commit, dispatch }, Data) => {
    var carriers = Data;
    if (carriers.length > 0) {
      carriers.forEach((element) => {
        dispatch("DeleteCarrier", element.Id);
      });
      commit("allCarriers", []);
    }
  },
  async DeleteCarrier({ getters, commit, dispatch, state }, Id) {
    var token =
      state.token == null || state.token == ""
        ? localStorage.getItem("Token")
        : state.token;

    const url = state.NeutrinoUrl + "operation/traffic/carrier?Id=" + Id;

    var request = {
      from: "DELETE_CARRIER",
      URL: url,
      method: "DELETE",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };

    await dispatch("ManageWorker", [request]);
  },
  async editObCarrier({ getters, commit, dispatch, state }, Data) {
    var contacts = getters.EditContacts(Data.Contacts);
    Data.Contacts = contacts;
    await commit("editCarrier", Data);
    router.replace({ name: "editCarrier" });
  },
  async UpdatePosition({ getters, commit, dispatch, state }, Data) {
    var token =
      state.token == null || state.token == ""
        ? localStorage.getItem("Token")
        : state.token;

    const url =
      state.NeutrinoUrl +
      "operation/vehicle/status?did=01035&mid=" +
      Data.vehicle;
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    var request = {
      from: "UPDATE_POSITION",
      URL: url,
      method: "GET",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: "",
    };

    await dispatch("ManageWorker", [request]);
  },
  showCharts({ state, dispatch, commit }, data) {
    router.push({ name: "inTransitIncidents" });
  },
  createPieCharts({ state, dispatch, commit }, params) {
    var itemsDashboardInfo = params[1];
    var myData;
    var n = 0;
    if (itemsDashboardInfo != undefined && itemsDashboardInfo != null) {
      var arr = [];
      var total = 0;
      itemsDashboardInfo.forEach((element) => {
        var obj = {
          name: i18n.t("ev" + element.Id),
          //color: element.total,
          y: element.Total,
        };
        arr.push(obj);
        total += element.Total;
        n++;
      });
      var sizes = "80%";
      var languageLocalStorage = localStorage.getItem("language");
      if (n >= 5) {
        commit("changeChartSize", params[0]);
        sizes = languageLocalStorage == "ES" ? "90%" : "85%";
      }
      if (n >= 7) {
        sizes = languageLocalStorage == "ES" ? "100%" : "85%";
      }

      myData = [
        {
          name: "In transit incidents",
          data: arr,
          size: sizes,
          innerSize: "60%",
          showInLegend: true,
          dataLabels: {
            enabled: false,
          },
          marker: {
            symbol: "square",
            radius: 12,
          },
        },
      ];
    }
    if (itemsDashboardInfo.length == 0) {
      var obj = {
        name: "",
        color: "#eaeaea",
        y: 100,
      };
      arr.push(obj);
    }

    dispatch("createChartsDetails", {
      data: params[0],
      myData: myData,
      total: total,
    });
  },
  createChartsDetails({ state, dispatch, commit }, { data, myData, total }) {
    $(function() {
      var chart;
      var darkMode = JSON.parse(localStorage.getItem("darkMode"));
      chart = new Highcharts.Chart({
        chart: {
          borderWidth: 0,
          renderTo: data,
          type: "pie",
          events: {
            load: addTitle,
            redraw: addTitle,
          },
          backgroundColor: null,
          style: {
            fontFamily: "Arial",
          },
        },
        plotOptions: {
          pie: {
            // animation: false,
            height: "50%",
            size: "50%",
            borderWidth: 0,
            innerSize: "70%",
            dataLabels: {
              enabled: false,
            },
            allowPointSelect: true,
            cursor: "pointer",
          },
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          pointFormat:
            total == 0
              ? "{series.name}: <br>0 %<br>Total: 0"
              : "{series.name}: <br>{point.percentage:.1f} %<br> Total: {point.y}",
        },
        legend: {
          // layout: "vertical",
          // align: "left",
          // verticalAlign: "top",
          // x: 40,
          // y: 120,
          // floating: false,
          // borderWidth: 1,
          // backgroundColor:
          //   Highcharts.defaultOptions.legend.backgroundColor || "#FFFFFF",
        },
        title: {
          text: "",
          margin: 0,
          y: 0,
          x: 0,
          align: "center",
          verticalAlign: "middle",
        },
        yAxis: {
          title: {
            text: null,
          },
        },

        series: myData,
      });

      function addTitle() {
        if (this.title) {
          this.title.destroy();
        }
        var titles = formatNumber.new(total, "");
        var r = this.renderer,
          x = this.series[0].center[0] + this.plotLeft,
          y = this.series[0].center[1] + this.plotTop;
        this.title = r
          .text(titles, 0, 0)
          .css({
            color: darkMode ? "#FFFFFF" : "#000000",
            fontSize: "0.9rem",
          })
          .hide()
          .add();

        var bbox = this.title.getBBox();
        this.title
          .attr({
            x: x - bbox.width / 2,
            y: y,
          })
          .show();
      }
    });
  },
  //for travel efficiency
  createPieChartsTravelEfficiency({ state, dispatch, commit }, params) {
    var itemsTravel = params[1];
    var myData;
    var n = 0;
    //console.log(itemsTravel);
    var linearGradient = {
      x1: 0,
      x2: 0,
      y1: 0,
      y2: 1,
    };
    var colors = [
      {
        color: {
          stops: [[0, "#4679F8"], [1, "#0E3E69"]],
          linearGradient: linearGradient,
        },
      },
      {
        color: "#5A7A92",
      },
      {
        color: {
          stops: [[0, "#8BA1A7"], [1, "#4EB9D9"], [2, "#00d4ff"]],
          //     stops: [[0, "#1F487E"], [1, "#247BA0"], [2, "#247BA0"]],
          linearGradient: linearGradient,
        },
      },
      {
        color: "#1E546B",
      },
      {
        color: "#8C8C8C",
      },
    ];

    if (itemsTravel != undefined && itemsTravel != null) {
      var arr = [];
      var total = 0;
      itemsTravel.forEach((element, index) => {
        var totalElement = parseFloat(element.Total.toFixed(2));
        var obj = {
          name: i18n.t(element.Id),
          y: totalElement,
          color: colors[index].color,
        };

        arr.push(obj);

        total += totalElement;

        if (params[0] == "EngineUsageTime" && element.Id == "Pto") {
          total -= totalElement;
        }

        // if (element.Id == "cruiseActive") {
        //   obj.y = 0;
        // }
        n++;
      });
    }

    if (itemsTravel.length == 0 || total == 0) {
      var obj = {
        name: "",
        color: "#eaeaea",
        y: 100,
      };
      arr.push(obj);
    }

    if (params[0] != "BadHabits") {
      total = parseFloat(total.toFixed(2));
    }
    //dispatch("createChartsDetailsTravelEfficiency", {
    dispatch("createChartsDetailsTravelEfficiency", {
      data: params[0],
      myData: arr,
      total: total,
      name: i18n.t(params[0]),
    });
  },
  createChartsDetailsTravelEfficiency(
    { state, getters, actions, commit },
    { data, myData, total, name }
  ) {
    var info = [];
    var distanc = state.SelectedDistance;
    var vol = state.SelectedVolume;
    var unit;
    if (data == "FuelConsumed") {
      unit = " " + vol;
    } else if (data == "EngineUsageTime" || data == "EngineOn") {
      unit = "";
      var minTotal = myData[0].y + myData[1].y;

      info = [
        {
          name: myData[2].name,
          y: myData[2].y,
        },
        {
          name: i18n.t("timeWithOutPto"),
          y: minTotal - myData[2].y,
          color: "rgba(0,0,0,0)",
        },
      ];

      if (myData[0].y > 0) {
        if (myData[1].y > 0) {
          myData = [myData[0], myData[1]];
        } else {
          myData = [myData[0]];
        }
      } else {
        if (myData[1].y > 0) {
          myData = [myData[1]];
        }
      }
    } else if (data == "FuelControlCrucero") {
      unit = " " + vol;
    } else if (data == "TimeControlCrucero") {
      unit = "";
    } else if (data == "DistanceControlCrucero") {
      unit = " " + distanc;
    } else {
      unit = "";
    }

    var darkMode = JSON.parse(localStorage.getItem("darkMode"));

    var chart = new Highcharts.Chart({
      chart: {
        borderWidth: 0,
        renderTo: data,
        type: "pie",
        style: {
          fontFamily: "Arial",
        },
        events: {
          load: addTitle,
          redraw: addTitle,
        },
        backgroundColor: null,
      },
      title: {
        verticalAlign: "middle",
        floating: true,
        text: "70% <br> 750K <br> Utilized"
      },
      subtitle: {
        //título de gráficas EFICIENCIA DE VIAJE
        text: name,
        style: {
          fontSize: "0.9rem",
          color: "#000"
        },
      },
      legend: {
        title: {
          style: {
            fontSize: "0.7rem",
            color: "#C0C0C0"
          },
        },
        labelFormatter: function() {
          if (!this.name.includes("/")) {
            return this.name;
          } else {
            return "";
          }
        },
      },
      plotOptions: {
        pie: {
          innerSize: "100%",
          dataLabels: {
            enabled: false,
          },
          allowPointSelect: true,
          cursor: "pointer",
          showInLegend: false,
        },
        series: {
          states: {
            hover: {
              enabled: true,
            },
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      series: [
        {
          borderWidth: 0,
          name: name,
          data: myData,
          size: "80%",
          innerSize: "65%",
          showInLegend: true,
          dataLabels: {
            enabled: false,
          },
          marker: {
            symbol: "square",
            radius: 12,
          },
        },
        {
          showInLegend: true,
          name: name,
          size: "40%",
          innerSize: "90%",
          dataLabels: {
            enabled: false,
          },
          data: info,
        },
      ],
      credits: {
        enabled: false,
      },
      tooltip: {
        borderWidth: 0,
        backgroundColor: "rgba(219,219,216,0.8)",
        shadow: false,
        style: {
          fontSize: "0.7rem",
          color: "#000"
        },
        formatter: function() {
          var dataTooltip = this.point.y + unit;
          if (
            data == "EngineUsageTime" ||
            data == "TimeControlCrucero" ||
            data == "EngineOn"
          ) {
            dataTooltip = getters.splitTime({ time: this.point.y });
            //console.log(this.point.y);
            // console.log(dataTooltip);
          }
          var series = this.point.series.chart.series, // get all series
            index = this.point.series.xData.indexOf(this.point.x), // get index
            str =
              total == 0
                ? this.point.name + " <br>0 %<br>Total: 0"
                : this.point.name +
                  " <br>" +
                  this.point.percentage.toFixed(2) +
                  " %<br> Total: " +
                  dataTooltip;

          // "this" refers to the selected point:
          // str += "Selected point? x: " + this.x + " y: " + this.y;
          str = "<p><b>" + this.point.series.name + "</b></p>" + ": <br>" + str;
          return str;
        },
      },
    });

    function addTitle() {
      if (this.title) {
        this.title.destroy();
      }
      var texts = total.toString();

      texts = formatNumber.new(texts, unit);
      var r = this.renderer,
        x = this.series[0].center[0] + this.plotLeft,
        y = this.series[0].center[1] + this.plotTop;

      if (
        data == "EngineUsageTime" ||
        data == "TimeControlCrucero" ||
        data == "EngineOn"
      ) {
        texts = getters.splitTime({ time: total });
      }

      this.title = r
        .text(texts, 0, 0)
        .css({
          color: darkMode ? "#FFFFFF" : "#000000",
          fontSize: "0.8rem",
        })
        .hide()
        .add();

      var bbox = this.title.getBBox();
      this.title
        .attr({
          x: x - bbox.width / 2,
          y: y,
        })
        .show();
    }
  },
  async getDetailsTable({ dispatch, commit, state, getters }) {
    commit("progressDetails", true);
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      var lastRequest = JSON.parse(
        localStorage.getItem("fleetPerformanceRequest")
      );
      var currentDate = moment().format("x");
      var ItemsTable = JSON.parse(localStorage.getItem("detailsTableInfo"));
      var token = state.token;
      if (token == null || token == "") {
        token = localStorage.getItem("Token");
      }
      var startDate = moment(localStorage.getItem("datesCalendar1")).format(
        "YYYY-MM-DD"
      );
      var endDate =
        localStorage.getItem("datesCalendar2") == null
          ? startDate
          : moment(localStorage.getItem("datesCalendar2")).format("YYYY-MM-DD");
      startDate = startDate + "T" + state.startClock;
      endDate = endDate + "T" + state.endClock;

      if (lastRequest != null || lastRequest != undefined) {
        var lastRequestDate =
          lastRequest[0].StartDate != undefined
            ? lastRequest[0].StartDate.replace("T", " ")
            : startDate;
        var lastRequestDateEnd =
          lastRequest[0].EndDate != undefined
            ? lastRequest[0].EndDate.replace("T", " ")
            : endDate;
      }

      var v_list = JSON.parse(localStorage.getItem("v_list"));

      if (
        localStorage.getItem("checkQuickList") != undefined ||
        localStorage.getItem("checkQuickList") != null
      ) {
        state.checkFastList = JSON.parse(
          localStorage.getItem("checkQuickList")
        );
      }

      if (
        localStorage.getItem("quickList") != undefined ||
        localStorage.getItem("quickList") != null
      ) {
        if (state.checkFastList) {
          v_list = JSON.parse(localStorage.getItem("quickList"));
        }
      }

      var listVehicles = getters.listOfVehicles(v_list);
      const url = state.NeutrinoUrl + "operation/alertruck/fleet/performance";
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204
      var dID = localStorage.getItem("Dealer_Id");
      var cID = localStorage.getItem("Client_Id");
      var data = {
        DealerId: dID,
        ClientId: cID,
        StartDate: startDate,
        EndDate: endDate,
        Vehicles: listVehicles,
      };

      var request = {
        from: "FLEET_PERFORMANCE",
        URL: url,
        method: "POST",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: data,
      };
      commit("fillPerformanceFleet", []);
      // console.log(ItemsTable);
      // console.log(lastRequest);
      if (
        lastRequest == null ||
        lastRequest == undefined ||
        ItemsTable == null ||
        ItemsTable == undefined
      ) {
        await dispatch("ManageWorker", [request]);
        localStorage.setItem(
          "fleetPerformanceRequest",
          JSON.stringify([data, moment().format("x")])
        );
      } else {
        // console.log("H O L A");
        // console.log(lastRequestDate);
        // console.log(lastRequestDateEnd);
        // console.log(lastRequest);
        if (
          //Cambio el filtro
          lastRequest[0].DealerId != dID ||
          lastRequest[0].ClientId != cID ||
          lastRequestDate != startDate.replace("T", " ") ||
          lastRequestDateEnd != endDate.replace("T", " ") ||
          currentDate > parseInt(lastRequest[1]) + 600000 ||
          lastRequest[0].Vehicles.length != listVehicles.length
          //compare vehicle
        ) {
          await dispatch("ManageWorker", [request]);

          localStorage.setItem(
            "fleetPerformanceRequest",
            JSON.stringify([data, moment().format("x")])
          );
        } else {
          //refresh
          commit("progressDetails", false);

          dispatch("setListInTable", ItemsTable);
        }
      }
    } else {
      commit("progressDetails", false);
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
    }
  },

  //Funcion para formatear los datos a mostrar en tabla de dashboard/perfomance
   setListInTable({ dispatch, commit, state, getters }, data) {
    localStorage.setItem("performanceFleet", JSON.stringify(data));
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    var arr = [],
      timeDrivingArr = [],
      timeRalentiArr = [],
      timePtoArr = [];
    var timeDriving, timeRalenti, timePto;
    if (data.length > 0) {
      data.forEach((element) => {
        var distance = element.Distance;
        var fuelDriving = element.FUEL_CONSUMPTION.Driving;
        var fuelRalenti = element.FUEL_CONSUMPTION.Ralenti;
        var fuelPto = element.FUEL_CONSUMPTION.Pto;
        var performance = element.Performance;

        if (state.SelectedVolume != "L") {
          fuelDriving =
            fuelDriving <= 0
              ? 0
              : parseFloat(fuelDriving * 0.264172051).toFixed(1);
          fuelPto =
            fuelPto <= 0 ? 0 : parseFloat(fuelPto * 0.264172051).toFixed(1);
          fuelRalenti =
            fuelRalenti <= 0
              ? 0
              : parseFloat(fuelRalenti * 0.264172051).toFixed(1);
        }
        if (state.SelectedDistance != "Km") {
          if (distance != 0) {
            distance = parseFloat(distance * 0.621371192).toFixed(3);
          }
        }

        if (state.SelectedVolume == "gal" && state.SelectedDistance == "mi") {
          if (performance != 0) {
            performance = parseFloat(performance * 2.35).toFixed(2);
          }
        }

        if (state.SelectedVolume == "gal" && state.SelectedDistance == "Km") {
          if (performance != 0) {
            performance = parseFloat(performance * 3.78).toFixed(2);
          }
        }

        if (state.SelectedVolume == "L" && state.SelectedDistance == "mi") {
          if (performance != 0) {
            performance = parseFloat(performance * 0.62).toFixed(2);
          }
        }

        timeDriving = element.ENGINE_USE.Driving <= 0 ? "0D, 00:00" : getters.splitTime({
          time: element.ENGINE_USE.Driving,
        });
        timeRalenti = element.ENGINE_USE.Ralenti <= 0 ? "0D, 00:00" : getters.splitTime({
          time: element.ENGINE_USE.Ralenti,
        });
        timePto = element.ENGINE_USE.Pto <= 0 ? "0D, 00:00" : getters.splitTime({ time: element.ENGINE_USE.Pto });

        var maxSpeed = 0;
        if (element.Speed != undefined && element.Speed != null) {
             maxSpeed = getters.convertMilesPerHour(element.Speed.Max);
             maxSpeed = parseFloat(maxSpeed.toFixed(2));
        }
 
        var obj = {
          deviceId: element.Nick + " " + "(" + element.DeviceId + ")",
          distance: formatNumber.new(distance, "").trim(),
          valueDistance: distance,
          fuelDriving: formatNumber.new(fuelDriving, "").trim(),
          valuefuelDriving: fuelDriving,
          fuelRalenti: formatNumber.new(fuelRalenti, "").trim(),
          valueFuelRalenti: fuelRalenti,
          fuelPto: formatNumber.new(fuelPto, "").trim(),
          valueFuelPto: fuelPto,
          engineDriving: timeDriving,
          valueEngineDriving: element.ENGINE_USE.Driving,
          engineRalenti: timeRalenti,
          valueEngineRalenti: element.ENGINE_USE.Ralenti,
          enginePto: timePto,
          valueEnginePto: element.ENGINE_USE.Pto,
          performance: formatNumber.new(performance, "").trim(),
          valuePerformance:  performance,
          intransitIncidents: formatNumber.new(element.IntransitIncidents, "").trim(),
          valueIntransitIncidents: element.IntransitIncidents,
          speedMax: maxSpeed,
          valueSpeedMax: maxSpeed
        };
        arr.push(obj);
        timeDrivingArr.push(timeDriving);
        timeRalentiArr.push(timeRalenti);
        timePtoArr.push(timePto);
      });

      timeDrivingArr.forEach((el) => {
        if (el.includes("D")) {
          return (state.headersMetrics[4].text =
            i18n.t("drivingMotorUsage").toUpperCase() + " (DD, HH:mm)");
        }
      });
      timeRalentiArr.forEach((el) => {
        if (el.includes("D")) {
          return (state.headersMetrics[5].text =
            i18n.t("motorUsageIdle").toUpperCase() + " (DD, HH:mm)");
        }
      });
      timePtoArr.forEach((el) => {
        if (el.includes("D")) {
          return (state.headersMetrics[6].text =
            i18n.t("motorUsage").toUpperCase() + " (DD, HH:mm)");
        }
      });
    }
    commit("fillPerformanceFleet", arr);
    //console.log(arr);
  },
  exportExcel({ state }) {
    let createXLSLFormatObj = [];
    let newXlsHeader = [];
    if (state.headersMetricsNoAction.length === 0) {
      return;
    }
    if (state.PerformanceFleet.length === 0) {
      return;
    }
    $.each(state.headersMetricsNoAction, function(index, value) {
      newXlsHeader.push(value.label);
    });
    createXLSLFormatObj.push(newXlsHeader);
    $.each(state.PerformanceFleet, function(index, value) {
      let innerRowData = [];
      $.each(state.headersMetricsNoAction, function(index, val) {
        if (val.dataFormat && typeof val.dataFormat === "function") {
          innerRowData.push(val.dataFormat(value[val.field]));
        } else {
          innerRowData.push(value[val.field]);
        }
      });
      createXLSLFormatObj.push(innerRowData);
    });
    let timestamp = Date.now();
    var name = "AT-" + timestamp;
    let filename = name + ".xlsx";
    let ws_name = "SheetName";
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(wb, filename);
  },
  exportExcelInTransit({ state }, params) {
    let createXLSLFormatObj = [];
    let newXlsHeader = [];
    //var vm = this;
    if (state.headersPerformanceExcel.length === 0) {
      return;
    }
    if (state.itemsTableInTransit2.length === 0) {
      return;
    }
    $.each(state.headersPerformanceExcel, function(index, value) {
      newXlsHeader.push(value.label);
    });
    createXLSLFormatObj.push(newXlsHeader);
    $.each(state.itemsTableInTransit2, function(index, value) {
      let innerRowData = [];
      $.each(state.headersPerformanceExcel, function(index, val) {
        if (val.dataFormat && typeof val.dataFormat === "function") {
          innerRowData.push(val.dataFormat(value[val.field]));
        } else {
          innerRowData.push(value[val.field]);
        }
      });
      createXLSLFormatObj.push(innerRowData);
    });
    let timestamp = Date.now();
    var name = "ITIR-" + timestamp;
    let filename = name + ".xlsx";
    let ws_name = "SheetName";
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(wb, filename);
  },
  downloadExcelJson: ({ dispatch, state, getters }, Datas) => {
    var vehicle = localStorage.getItem("performanceVehicle");
    vehicle = vehicle.split("@");
    var nickId = vehicle[0];
    var vehicleId = vehicle[1];
    var tripsData = [];
    var engineTrip = [];
    var inTransitTrips = [];
    var address;

    var vol =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");
    var distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    var headersGeneral = [
      { label: "Id".toUpperCase(), field: "TripId" },
      { label: i18n.t("nameOfTheTrip").toUpperCase(), field: "TripName" },
      { label: i18n.t("startDate").toUpperCase(), field: "StartDate" },
      { label: i18n.t("endDate").toUpperCase(), field: "EndDate" },
      { label: i18n.t("tripDuration").toUpperCase(), field: "TripDuration" },
      { label: i18n.t("tripTime").toUpperCase(), field: "TripTime" },
      {
        label: i18n.t("totalDistance").toUpperCase() + " (" + distance + ")",
        field: "Distance",
      },
      {
        label: i18n.t("PerformancePerHour").toUpperCase(),
        field: "PerformancePerHour",
      },
      {
        label:
          i18n.t("rendi").toUpperCase() + " (" + distance + "/" + vol + ")",
        field: "PerformancePerDistance",
      },
      {
        label: i18n.t("DrivingPerformance").toUpperCase(),
        field: "DrivingPerformance",
      },
      {
        label: i18n.t("speedmax").toUpperCase() + " (" + distance + "/h)",
        field: "MaxSpeed",
      },
      { label: i18n.t("maxSpeedDate").toUpperCase(), field: "MaxSpeedDate" },
      {
        label: i18n.t("avgSpeed").toUpperCase() + " (" + distance + "/h)",
        field: "AverageSpeed",
      },
      { label: i18n.t("rpmMax").toUpperCase() + " (Rpms)", field: "MaxRPMs" },
      {
        label: i18n.t("rpmAvg").toUpperCase() + " (Rpms)",
        field: "AverageRPMs",
      },
      {
        label: i18n.t("ralentifuel").toUpperCase() + " (" + vol + ")",
        field: "RalentiFuel",
      },
      {
        label: i18n.t("drivefuel").toUpperCase() + " (" + vol + ")",
        field: "DrivingFuel",
      },
      {
        label: i18n.t("fuelpto").toUpperCase() + " (" + vol + ")",
        field: "PtoFuel",
      },
      {
        label: i18n.t("emtyHours").toUpperCase() + " (H)",
        field: "RalentiEngine",
      },
      {
        label: i18n.t("driveHours").toUpperCase() + " (H)",
        field: "DrivingEngine",
      },
      { label: i18n.t("timepto").toUpperCase() + " (H)", field: "PtoEngine" },
      {
        label: i18n.t("TimeControlCrucero").toUpperCase() + " (H)",
        field: "TimeCruise",
      },
      {
        label:
          i18n.t("DistanceControlCrucero").toUpperCase() +
          " (" +
          distance +
          ")",
        field: "DistanceCruise",
      },
      {
        label: i18n.t("FuelControlCrucero").toUpperCase() + " (" + vol + ")",
        field: "FuelCruise",
      },
    ];

    var headersEngine = [
      { label: i18n.t("dateT").toUpperCase(), field: "Date" },
      { label: i18n.t("lat").toUpperCase(), field: "Lat" },
      { label: i18n.t("lon").toUpperCase(), field: "Lon" },
      { label: i18n.t("address").toUpperCase(), field: "Address" },
      {
        label: i18n.t("speedpromedy").toUpperCase() + " ( Rpm )",
        field: "Speedpromedy",
      },
      {
        label: i18n.t("speedpromedy").toUpperCase() + " (" + distance + "/h)",
        field: "AvgVehicleSpeed",
      },
      {
        label: i18n.t("cargaProm").toUpperCase(),
        field: "AvgMotorLoadPercentage",
      },
      {
        label: i18n.t("pedalProm").toUpperCase(),
        field: "AcceleratorPedalPositionAvg",
      },
      {
        label: i18n.t("TimeControlCrucero").toUpperCase(),
        field: "CruiseModeTime",
      },
      {
        label:
          i18n.t("DistanceControlCrucero").toUpperCase() +
          " (" +
          distance +
          ")",
        field: "DistanceCruiseMode",
      },
      {
        label: i18n.t("FuelControlCrucero").toUpperCase() + " (" + vol + ")",
        field: "FuelCruiseMode",
      },
      { label: i18n.t("BrakeCounter").toUpperCase(), field: "BrakeCounter" },
      { label: i18n.t("ClutchCounter").toUpperCase(), field: "ClutchCounter" },
      {
        label: i18n.t("RoughBrakeCounter").toUpperCase(),
        field: "RoughBrakeCounter",
      },
      {
        label: i18n.t("ExcessRpmCounter").toUpperCase() + " (Rpms)",
        field: "ExcessRpmCounter",
      },
      { label: "Id".toUpperCase(), field: "TripId" },
      { label: i18n.t("nameOfTheTrip").toUpperCase(), field: "TripName" },
    ];

    var headersInstransit = [
      { label: i18n.t("event").toUpperCase(), field: "Id" },
      { label: i18n.t("date").toUpperCase(), field: "Date" },
      { label: i18n.t("address").toUpperCase(), field: "Address" },
      { label: i18n.t("lat").toUpperCase(), field: "Lat" },
      { label: i18n.t("lon").toUpperCase(), field: "Lon" },
      { label: i18n.t("eventDetails").toUpperCase(), field: "Details" },
      { label: i18n.t("descripcion").toUpperCase(), field: "Description" },
      { label: i18n.t("nameOfTheTrip").toUpperCase(), field: "TripName" },
      { label: "Id".toUpperCase(), field: "TripId" },
      // { label: i18n.t("vehicle").toUpperCase(), field: "TripName" },
    ];

    // export json to Worksheet of Excel
    // only array possible
    Datas.Trips.forEach((element) => {
      var RalentiFuel = getters.convertVolume(element.UsedFuel.Ralenti);
      RalentiFuel = parseFloat(RalentiFuel.toFixed(2));

      var DrivingF = getters.convertVolume(element.UsedFuel.Driving);
      DrivingF = parseFloat(DrivingF.toFixed(2));

      var PtoF = getters.convertVolume(element.UsedFuel.Pto);
      PtoF = parseFloat(PtoF.toFixed(2));

      var cruiseFuel = getters.convertVolume(element.CruiseModeOperation.Fuel);
      cruiseFuel = parseFloat(cruiseFuel.toFixed(2));

      var gDistance = getters.convertDistance(element.General.Distance);
      gDistance = parseFloat(gDistance.toFixed(2));

      var cruiseDistance = getters.convertDistance(
        element.CruiseModeOperation.Distance
      );
      cruiseDistance = parseFloat(cruiseDistance.toFixed(2));
      var drivingPerformance = 0;
      if (DrivingF != 0 && element.EngineUsageTime.Driving != 0) {
        drivingPerformance = DrivingF / element.EngineUsageTime.Driving;
      }

      var performanc = getters.convertPerformance(
        element.General.PerformancePerDistance
      );
      performanc = parseFloat(performanc.toFixed(2));

      var avgSpeed = getters.convertMilesPerHour(element.Speed.AverageSpeed);
      avgSpeed = parseFloat(avgSpeed.toFixed(2));

      var maxSpeed = getters.convertMilesPerHour(element.Speed.MaxSpeed);
      maxSpeed = parseFloat(maxSpeed.toFixed(2));

      var obj = {
        TripId: element.General.TripId,
        TripName:
          element.General.Name == "Viaje sin periodo asignado"
            ? i18n.t("noTrips")
            : element.General.Name,
        StartDate: element.General.StartDate,
        EndDate: element.General.EndDate,
        TripDuration: element.General.TripDuration,
        TripTime: element.General.TripTime,
        Distance: gDistance,
        PerformancePerHour: element.General.PerformancePerHour,
        PerformancePerDistance: performanc,
        DrivingPerformance: drivingPerformance,
        MaxSpeed: maxSpeed,
        MaxSpeedDate: element.Speed.MaxSpeedDate,
        AverageSpeed: avgSpeed,
        MaxRPMs: element.Speed.MaxRPMs,
        AverageRPMs: element.Speed.AverageRPMs,
        RalentiFuel: RalentiFuel,
        DrivingFuel: DrivingF,
        PtoFuel: PtoF,
        RalentiEngine: element.EngineUsageTime.Ralenti,
        DrivingEngine: element.EngineUsageTime.Driving,
        PtoEngine: element.EngineUsageTime.Pto,
        TimeCruise: element.CruiseModeOperation.Time,
        DistanceCruise: cruiseDistance,
        FuelCruise: cruiseFuel,
      };

      element.InTransitIncidents.forEach((element1) => {
        if (element1.Address == "~") {
          element1.Address = i18n.t("notAvailable");
        }
        element1.TripId = element.General.TripId;
        element1.TripName =
          element.General.Name == "Viaje sin periodo asignado"
            ? i18n.t("noTrips")
            : element.General.Name;
        inTransitTrips.push(element1);
      });

      element.EngineUsageHistory.forEach((element2) => {
        element2.TripId = element.General.TripId;
        element2.TripName =
          element.General.Name == "Viaje sin periodo asignado"
            ? i18n.t("noTrips")
            : element.General.Name;

        var speedEngine = getters.convertMilesPerHour(element2.AvgVehicleSpeed);
        element2.AvgVehicleSpeed = speedEngine;

        element2.DistanceCruiseMode = getters.convertDistance(
          element2.DistanceCruiseMode
        );
        element2.DistanceCruiseMode = parseFloat(
          element2.DistanceCruiseMode.toFixed(2)
        );

        element2.FuelCruiseMode = getters.convertDistance(
          element2.FuelCruiseMode
        );
        element2.FuelCruiseMode = parseFloat(
          element2.FuelCruiseMode.toFixed(2)
        );
        if (element2.Address == "~") {
          address = i18n.t("notAvailable");
        } else {
          address = element2.Address;
        }
        //engineTrip.push(element2);

        var objEngine = {
          Date: element2.Date,
          Lat: element2.Lat,
          Lon: element2.Lon,
          Address: address,
          Speedpromedy: element2.AvgEngineSpeedInRPM,
          AvgVehicleSpeed: element2.AvgVehicleSpeed,
          AvgMotorLoadPercentage: element2.AvgMotorLoadPercentage,
          AcceleratorPedalPositionAvg: element2.AcceleratorPedalPositionAvg,
          CruiseModeTime: element2.CruiseModeTime,
          DistanceCruiseMode: element2.DistanceCruiseMode,
          FuelCruiseMode: element2.FuelCruiseMode,
          BrakeCounter: element2.BrakeCounter,
          ClutchCounter: element2.ClutchCounter,
          RoughBrakeCounter: element2.RoughBrakeCounter,
          ExcessRpmCounter: element2.ExcessRpmCounter,
          TripId: element2.TripId,
          TripName: element2.TripName,
        };
        engineTrip.push(objEngine);
      });

      tripsData.push(obj);
    });
    let createXLSLFormatObj1 = [];
    let newXlsHeader1 = [];
    let createXLSLFormatObj2 = [];
    let newXlsHeader2 = [];
    let createXLSLFormatObj3 = [];
    let newXlsHeader3 = [];
    if (headersGeneral.length === 0) {
      return;
    }
    if (tripsData.length === 0) {
      return;
    }
    $.each(headersGeneral, function(index, value) {
      newXlsHeader1.push(value.label);
    });
    createXLSLFormatObj1.push(newXlsHeader1);
    $.each(tripsData, function(index, value) {
      let innerRowData = [];
      $.each(headersGeneral, function(index, val) {
        if (val.dataFormat && typeof val.dataFormat === "function") {
          innerRowData.push(val.dataFormat(value[val.field]));
        } else {
          innerRowData.push(value[val.field]);
        }
      });
      createXLSLFormatObj1.push(innerRowData);
    });
    //
    if (headersEngine.length === 0) {
      return;
    }
    if (engineTrip.length === 0) {
      return;
    }
    $.each(headersEngine, function(index, value) {
      newXlsHeader2.push(value.label);
    });
    createXLSLFormatObj2.push(newXlsHeader2);
    $.each(engineTrip, function(index, value) {
      let innerRowData = [];
      $.each(headersEngine, function(index, val) {
        if (val.dataFormat && typeof val.dataFormat === "function") {
          innerRowData.push(val.dataFormat(value[val.field]));
        } else {
          innerRowData.push(value[val.field]);
        }
      });
      createXLSLFormatObj2.push(innerRowData);
    });
    //Exceptions
    $.each(headersInstransit, function(index, value) {
      newXlsHeader3.push(value.label);
    });
    createXLSLFormatObj3.push(newXlsHeader3);
    $.each(inTransitTrips, function(index, value) {
      let innerRowData = [];
      $.each(headersInstransit, function(index, val) {
        if (val.dataFormat && typeof val.dataFormat === "function") {
          innerRowData.push(val.dataFormat(value[val.field]));
        } else {
          innerRowData.push(value[val.field]);
        }
      });
      createXLSLFormatObj3.push(innerRowData);
    });
    let wb = XLSX.utils.book_new();
    var trips = XLSX.utils.aoa_to_sheet(createXLSLFormatObj1);
    var engine = XLSX.utils.aoa_to_sheet(createXLSLFormatObj2);
    var incidents = XLSX.utils.aoa_to_sheet(createXLSLFormatObj3);
    XLSX.utils.book_append_sheet(wb, trips, i18n.t("tripsHistory"));
    XLSX.utils.book_append_sheet(wb, engine, i18n.t("engineHistory"));
    XLSX.utils.book_append_sheet(wb, incidents, i18n.t("exceptions"));
    XLSX.writeFile(wb, nickId + " (" + vehicleId + ").xlsx");
  },
  mockSkeletons: ({ dispatch, commit, state }) => {
    commit("viewSkeletonsP", true);
    setTimeout(() => {
      commit("viewSkeletonsP", false);
    }, 4000);
  },
  async getItemsIP({ commit, dispatch, getters, state }) {
    dispatch("destroyPerformanceCharts");
    commit("viewSkeletonsP", true);
    commit("btnDisabled", true);
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      var token = state.token;
      if (token == null || token == "" || token == undefined) {
        token = localStorage.getItem("Token");
      }
      //console.log(token);

      var vehicle = localStorage.getItem("performanceVehicle");
      vehicle = vehicle.split("@");
      var selectedVehicle = vehicle[1];
      var lastRequest = JSON.parse(localStorage.getItem("last_Request_P"));
      // console.log(lastRequest);
      // var ItemsPerformance = JSON.parse(
      //   localStorage.getItem("ItemsPerformance")
      // );

      var ItemsPerformance = state.itemsPerformanceInfo;
      if (ItemsPerformance == null) {
        ItemsPerformance = await dispatch("getItemPouchdb", "ItemsPerformance");
      }
      // console.log(ItemsPerformance);

      var startDate = moment(localStorage.getItem("datesCalendar1")).format(
        "YYYY-MM-DD"
      );
      var endDate = localStorage.getItem("datesCalendar2");

      var dID = localStorage.getItem("Dealer_Id");

      var cID = localStorage.getItem("Client_Id");

      var currentDate = moment().format("x");

      var dateEnd =
        endDate == undefined || endDate == "undefined" ? startDate : endDate;
      dateEnd = moment(dateEnd).format("YYYY-MM-DD");

      startDate = startDate + "T" + state.startClock;
      dateEnd = dateEnd + "T" + state.endClock;
      if (lastRequest != null || lastRequest != undefined) {
        var lastRequestDate =
          lastRequest[0].StartDate != undefined
            ? lastRequest[0].StartDate.replace("T", " ")
            : startDate;
        var lastRequestDateEnd =
          lastRequest[0].EndDate != undefined
            ? lastRequest[0].EndDate.replace("T", " ")
            : endDate;
      }

      const url =
        state.NeutrinoUrl +
        "operation/alertruck/individual/performancespertrips";
      //const url = "https://run.mocky.io/v3/ffa64d09-53c9-4758-b24f-4f5f51bf1024";
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var dID = localStorage.getItem("Dealer_Id");
      var cID = localStorage.getItem("Client_Id");

      var data = {
        StartDate: startDate,
        EndDate: dateEnd,
        DealerId: dID,
        ClientId: cID,
        DeviceId: selectedVehicle,
      };
      // console.log(data);

      var request = {
        from: "INDIVIDUAL_P",
        URL: url,
        method: "POST",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: data,
      };

      if (
        lastRequest == null ||
        lastRequest == undefined ||
        ItemsPerformance == null ||
        ItemsPerformance == undefined
      ) {
        await dispatch("ManageWorker", [request]);
        localStorage.getItem("ItemsPerformance", null);
        localStorage.setItem(
          "last_Request_P",
          JSON.stringify([data, moment().format("x")])
        );
      } else {
        //    console.log("H O L A");
        if (
          //Cambio el filtro
          lastRequest[0].DealerId != dID ||
          lastRequest[0].ClientId != cID ||
          lastRequestDate != startDate.replace("T", " ") ||
          lastRequestDateEnd != dateEnd.replace("T", " ") ||
          currentDate > parseInt(lastRequest[1]) + 600000 ||
          lastRequest[0].DeviceId != selectedVehicle
          //compare vehicle
        ) {
          await dispatch("ManageWorker", [request]);
          //    localStorage.setItem("ItemsPerformance", null);
          localStorage.setItem(
            "last_Request_P",
            JSON.stringify([data, moment().format("x")])
          );
        } else {
          //refresh
          if (ItemsPerformance == null || ItemsPerformance == undefined) {
            commit("snackbar", {
              snackbar: true,
              text: i18n.t("later"),
            });

            dispatch("cancelItemsPerformance", false);
          } else {
            setTimeout(() => commit("btnDisabled", false), 2000);
            setTimeout(
              () =>
                dispatch("divideData", {
                  itemsPerformance1: ItemsPerformance,
                  comparative: false,
                  byTrip: false,
                }),
              1000
            );
          }
        }
      }
    } else {
      if (ItemsPerformance == null || ItemsPerformance == undefined) {
        commit("snackbar", {
          snackbar: true,
          text: i18n.t("later"),
        });

        dispatch("cancelItemsPerformance", false);
      } else {
        setTimeout(() => commit("viewSkeletonsP", false), 2000);
        setTimeout(() => commit("btnDisabled", false), 2000);
        setTimeout(
          () =>
            dispatch("divideData", {
              itemsPerformance1: ItemsPerformance,
              comparative: false,
              byTrip: false,
            }),
          1000
        );
      }
    }
  },

  async infoDivideData(
    { commit, dispatch, getters, state },
    { itemsPerformance1, comparative, byTrip, ItemsPerformance }
  ) {
    dispatch("destroyPerformanceCharts");
    if (!comparative) setTimeout(() => commit("viewSkeletonsP", false), 2000);
    commit("setitemsPerformanceData", ItemsPerformance);

    // console.log(ItemsPerformance);
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    //GENERAL
    var dist = 0;
    var totalFuel = 0;
    var totalEngine = 0;
    var totalEnginePTO = 0;
    var intransit = 0;
    var tripTime = [];
    var breakTime = 0;
    var speedMax = [];
    var speedMaxFinal = 0;
    var maxrpm = [];
    var maxrpmFinal = 0;
    var performances = 0;
    var odometer = 0;
    var avgSpeed = [];
    var avgRpm = [];
    var avgMotorLoad = [];
    var finalFuelFinal = 0;
    odometer = itemsPerformance1.FinalOdometer;
    var finalFuelFinal = itemsPerformance1.FinalFuel;

    var motorLoad = 0;
    var maxMotorLoad = [];
    var maxMotorLoadFinal = 0;
    var intervalStart = i18n.t("notAvailable");
    var intervalEnd = i18n.t("notAvailable");

    //charts
    var engine = [];
    var percentUsage = [];
    var engine1 = [];
    var percentUsage1 = [];
    var categories = [];

    //PIE CHARTS
    var pieFuel = [];
    var pieEngine = [];
    var pieCruiseF = [];
    var pieCruiseD = [];
    var pieCruiseT = [];
    var badHabitsDetected = [];

    var drivingF = 0;
    var ralentiF = 0;
    var ptoF = 0;

    var drivingE = 0;
    var ralentiE = 0;
    var ptoE = 0;

    var fuelC = 0;
    var distanceC = 0;
    var timeC = 0;

    var BrakeCounter = 0;
    var ClutchCounter = 0;
    var RoughBrakeCounter = 0;
    var ExcessRpmCounter = 0;

    //In transit incidents

    var drivingObj = [];
    var operationObj = [];
    var logisticObj = [];
    var diagnosticObj = [];
    var inTransitIncidents1 = {
      DRIVING: drivingObj,
      OPERATION: operationObj,
      LOGISTICS: logisticObj,
      DIAGNOSTICS: diagnosticObj,
    };
    var listIntransit = [];

    var listOfTrips = [i18n.t("all")];

    var arrComparativeTable = [];
    var arrComparativeTableE = [];

    //Charts comparative
    var fuelForTrips1 = [];
    var engineForTrips1 = [];

    var fuelForTrips2 = [];
    var engineForTrips2 = [];

    var fuelForTrips3 = [];
    var engineForTrips3 = [];

    var diagnosticUnit = [];
    var conductionUnit = [];
    var logisticUnit = [];
    var operationUnit = [];

    var chartDeficiences = [
      {
        name: "Total",
        data: [],
        color: "#08779A",
      },
    ];
    var chartBadHabits = [];
    var totalHabits = 0;

    var colorsCharts1 = [
      "#7DA61D",
      "#96A18D",
      "#126467",
      "#424242",
      "#8C8F8F",
      "#1588A4",
      "#1572A4",
      "#404040",
      "#424242",
      "#8C8F8F",
      "#1588A4",
      "#1572A4",
      "#404040",
    ];
    var colorsCharts2 = [
      "#BD8102",
      "#0A6C7B",
      "#0A4B7B",
      "#60717E",
      "#1D3B51",
      "#BD8102",
      "#0A6C7B",
      "#0A4B7B",
      "#60717E",
      "#1D3B51",
    ];
    var j = 0;

    var chartCruiseFuel1 = {
      name: i18n.t("cruiseActive"),
      data: [],
      color: "#084F9A",
    };
    var chartCruiseFuel2 = {
      name: i18n.t("cruiseInactive"),
      data: [],
      color: "#4A6F7E",
    };
    var chartCruiseDist1 = {
      name: i18n.t("cruiseActive"),
      data: [],
      color: "#9A7B08",
    };
    var chartCruiseDist2 = {
      name: i18n.t("cruiseInactive"),
      data: [],
      color: "#52524E",
    };
    var chartCruiseTime1 = {
      name: i18n.t("cruiseActive"),
      data: [],
      color: "#095368",
    };
    var chartCruiseTime2 = {
      name: i18n.t("cruiseInactive"),
      data: [],
      color: "#17323D",
    };

    //  console.log(ItemsPerformance);
    if (
      (ItemsPerformance != undefined &&
        ItemsPerformance != null &&
        ItemsPerformance.Trips.length > 0 &&
        comparative) ||
      byTrip
    ) {
      ItemsPerformance.Trips.forEach((element1) => {
        listOfTrips.push({
          name:
            element1.General.Name == "Viaje sin periodo asignado"
              ? i18n.t("noTrips")
              : element1.General.Name,
          id: element1.General.TripId,
        });
      });
    }
    if (itemsPerformance1.Trips == undefined) {
      //No hay datos
      dispatch("cancelItemsPerformance", true);
    } else {
      itemsPerformance1.Trips.forEach((element) => {
        //Si no es por comparativo de viajes y no es consulta por un viaje seleccionado
        if (!comparative && !byTrip) {
          listOfTrips.push({
            name:
              element.General.Name == "Viaje sin periodo asignado"
                ? i18n.t("noTrips")
                : element.General.Name,
            id: element.General.TripId,
          });
        }

        var mxSpeeed = getters.convertMilesPerHour(element.Speed.MaxSpeed);
        dist += element.General.Distance;
        totalFuel += element.General.Fuel;
        breakTime += element.General.RestingTime;
        tripTime.push(element.General.TripTime);
        speedMax.push(mxSpeeed);
        maxMotorLoad.push(element.Speed.MaxMotorLoad);
        maxrpm.push(element.Speed.MaxRPMs);
        intervalStart =
          element.General.Interval.Start == null
            ? i18n.t("notAvailable")
            : element.General.Interval.Start;
        intervalEnd =
          element.General.Interval.End == null
            ? i18n.t("notAvailable")
            : element.General.Interval.End;

        var avgssped = getters.convertMilesPerHour(element.Speed.AverageSpeed);

        //Calculo de tiempo de motor general
        totalEngine += element.EngineUsageTime.Driving;
        totalEngine += element.EngineUsageTime.Ralenti;
        //totalEngine += element.EngineUsageTime.Pto;
        //Calculo de PTO
        totalEnginePTO += element.EngineUsageTime.Pto;

        //Promedios
        avgSpeed.push(avgssped);
        avgRpm.push(element.Speed.AverageRPMs);
        avgMotorLoad.push(element.Speed.AverageMotorLoad);

        //Calculo de combustible
        drivingF += element.UsedFuel.Driving;
        ralentiF += element.UsedFuel.Ralenti;
        ptoF += element.UsedFuel.Pto;

        //Calculo de Tiempo de motor por categoria
        drivingE += element.EngineUsageTime.Driving;
        ralentiE += element.EngineUsageTime.Ralenti;
        ptoE += element.EngineUsageTime.Pto;

        //Calculo de combustible en control crucero
        fuelC += element.CruiseModeOperation.Fuel;
        distanceC += element.CruiseModeOperation.Distance;
        timeC += element.CruiseModeOperation.Time;

        //charts comparision Control crucero
        var fCruise = element.CruiseModeOperation.Fuel;
        fCruise = fCruise > 0 ? fCruise : 0;
        var dCruise = element.CruiseModeOperation.Fuel;
        dCruise = dCruise > 0 ? dCruise : 0;
        var tCruise = element.CruiseModeOperation.Fuel;
        tCruise = tCruise > 0 ? tCruise : 0;

        var ptoFuel = element.UsedFuel.Pto;
        ptoFuel = ptoFuel > 0 ? ptoFuel : 0;
        var ralentFuel = element.UsedFuel.Ralenti;
        ralentFuel = ralentFuel > 0 ? ralentFuel : 0;
        var drivFuel = element.UsedFuel.Driving;
        drivFuel = drivFuel > 0 ? drivFuel : 0;

        var sum = ptoFuel + ralentFuel + drivFuel;

        var ptoEngine = element.EngineUsageTime.Pto;
        ptoEngine = ptoEngine > 0 ? ptoEngine : 0;
        var ralentEngine = element.EngineUsageTime.Ralenti;
        ralentEngine = ralentEngine > 0 ? ralentEngine : 0;
        var drivEngine = element.EngineUsageTime.Driving;
        drivEngine = drivEngine > 0 ? drivEngine : 0;

        var sumE = ptoEngine + ralentEngine + drivEngine;
        var fCruiseInactive = sum - fCruise;
        var dCruiseInactive = element.General.Distance - dCruise;
        var tCruiseInactive = sumE - tCruise;
        dCruiseInactive = getters.convertDistance(dCruiseInactive);
        dCruise = getters.convertDistance(dCruise);
        fCruiseInactive = getters.convertVolume(fCruiseInactive);
        fCruise = getters.convertVolume(fCruise);
        fCruise = fCruise == 0 ? 0 : parseFloat(fCruise.toFixed(1));
        fCruiseInactive =
          fCruiseInactive == 0 ? 0 : parseFloat(fCruiseInactive.toFixed(1));
        dCruise = dCruise == 0 ? 0 : parseFloat(dCruise.toFixed(1));
        dCruiseInactive =
          dCruiseInactive == 0 ? 0 : parseFloat(dCruiseInactive.toFixed(1));
        tCruise = tCruise == 0 ? 0 : parseFloat(tCruise.toFixed(1));
        tCruiseInactive =
          tCruiseInactive == 0 ? 0 : parseFloat(tCruiseInactive.toFixed(1));

        //Graficas de comparativo de control crucero
        chartCruiseFuel1.data.push(fCruise);
        chartCruiseFuel2.data.push(fCruiseInactive);
        chartCruiseDist1.data.push(dCruise);
        chartCruiseDist2.data.push(dCruiseInactive);
        chartCruiseTime1.data.push(tCruise);
        chartCruiseTime2.data.push(tCruiseInactive);

        // chartCruiseFuel1.data.push(fCruise + fCruiseInactive);
        // chartCruiseFuel2.data.push(0);
        // chartCruiseDist1.data.push(dCruise + dCruiseInactive);
        // chartCruiseDist2.data.push(0);
        // chartCruiseTime1.data.push(tCruise + tCruiseInactive);
        // chartCruiseTime2.data.push(0);

        //Calculo de combustible por viajes
        var usedFD = getters.convertVolume(element.UsedFuel.Driving);
        var usedRF = getters.convertVolume(element.UsedFuel.Ralenti);
        var usedPtoFuel = getters.convertVolume(element.UsedFuel.Pto);

        //Charts comparision
        fuelForTrips1.push(parseFloat(usedFD.toFixed(1)));
        engineForTrips1.push(
          parseFloat(element.EngineUsageTime.Ralenti).toFixed(1)
        );
        fuelForTrips2.push(parseFloat(usedRF.toFixed(1)));
        engineForTrips2.push(
          parseFloat(element.EngineUsageTime.Driving.toFixed(1))
        );
        fuelForTrips3.push(parseFloat(usedPtoFuel.toFixed(1)));
        engineForTrips3.push(
          parseFloat(element.EngineUsageTime.Pto.toFixed(1))
        );

        var driving = [
          "445",
          "446",
          "447",
          "448",
          "449",
          "452",
          "453",
          "457",
          "458",
          "481",
          "483",
          "484",
        ];
        var operation = ["450", "454", "459", "463", "466", "479", "480"];
        var logistic = ["451", "456", "455", "464", "482"];

        var totalDriving = 0;
        var totalOperation = 0;
        var totalLogistic = 0;
        var totalDiagnostic = 0;
        if (
          element.InTransitIncidents != null &&
          element.InTransitIncidents.length > 0
        ) {
          //Comparative
          chartDeficiences[0].data.push(element.InTransitIncidents.length);

          intransit += element.InTransitIncidents.length;

          if (
            element.InTransitIncidents != null &&
            element.InTransitIncidents.length > 0
          ) {
            element.InTransitIncidents.forEach((elements) => {
              var objIntransit = elements;
              objIntransit.TripName =
                element.General.Name == "Viaje sin periodo asignado"
                  ? i18n.t("noTrips")
                  : element.General.Name;
              objIntransit.TripId = element.General.TripId;
              objIntransit.DateFormatted = getters.formatDateCustom(
                objIntransit.Date.replace("T", " ")
              );
              listIntransit.push(objIntransit);

              //Exceso de tiempo de freno
              if (elements.Id === "449") {
                BrakeCounter++;
              }
              //Frenado brusco
              if (elements.Id === "453") {
                RoughBrakeCounter++;
              }
              //Exceso de embrague
              if (elements.Id === "447" && elements.Id === "448") {
                ClutchCounter++;
              }
              //Exceso de rpm
              if (elements.Id === "445") {
                ExcessRpmCounter++;
              }

              var obj = {
                Id: elements.Id,
                Total: 1,
                Name: elements.Description,
              };

              if (driving.includes(elements.Id)) {
                //DRIVING
                if (drivingObj.length != 0) {
                  let objData = drivingObj.find((f) => f.Id == elements.Id);
                  if (objData) {
                    objData = objData.Total++;
                    //  console.log(objData);
                  } else {
                    drivingObj.push(obj);
                  }
                } else {
                  drivingObj.push(obj);
                }
                totalDriving++;
              } else if (operation.includes(elements.Id)) {
                //OPERATION
                if (operationObj.length != 0) {
                  let objData = operationObj.find((f) => f.Id == elements.Id);
                  if (objData) {
                    objData = objData.Total++;
                  } else {
                    operationObj.push(obj);
                  }
                } else {
                  operationObj.push(obj);
                }
                totalOperation++;
              } else if (logistic.includes(elements.Id)) {
                //LOGISTICS
                if (logisticObj.length != 0) {
                  let objData = logisticObj.find((f) => f.Id == elements.Id);
                  if (objData) {
                    objData = objData.Total++;
                  } else {
                    logisticObj.push(obj);
                  }
                } else {
                  logisticObj.push(obj);
                }
                totalLogistic++;
              } else {
                //DIAGNOSTICS
                if (diagnosticObj.length != 0) {
                  let objData = diagnosticObj.find((f) => f.Id == elements.Id);
                  if (objData) {
                    objData = objData.Total++;
                  } else {
                    diagnosticObj.push(obj);
                  }
                } else {
                  diagnosticObj.push(obj);
                }
                totalDiagnostic++;
              }
            });
          }
        } else {
          intransit += 0;
          //Comparative
          chartDeficiences[0].data.push(0);
        }

        inTransitIncidents1 = {
          DRIVING: drivingObj,
          OPERATION: operationObj,
          LOGISTICS: logisticObj,
          DIAGNOSTICS: diagnosticObj,
        };

        //Asignando las deficiencias de manejo
        diagnosticUnit.push(totalDiagnostic);
        conductionUnit.push(totalDriving);
        logisticUnit.push(totalLogistic);
        operationUnit.push(totalOperation);

        var speedss = [];
        var repmss = [];
        var pedal = [];

        element.EngineUsageHistory.forEach((elements) => {
          var elemntSpeed =
            elements.AvgVehicleSpeed > 0 ? elements.AvgVehicleSpeed : 0;
          elemntSpeed = getters.convertMilesPerHour(elemntSpeed);
          var elemntRPMS =
            elements.AvgEngineSpeedInRPM > 0 ? elements.AvgEngineSpeedInRPM : 0;
          var elemntPedal =
            elements.AcceleratorPedalPositionAvg > 0
              ? elements.AcceleratorPedalPositionAvg
              : 0;
          speedss.push(elemntSpeed);
          repmss.push(elemntRPMS);
          pedal.push(elemntPedal);

          var date = getters.formatDateCustom(elements.Date.replace("T", " "));
          var utcDate = moment(
            elements.Date.replace("T", " "),
            "YYYY-MM-DD HH:mm"
          ).format(); //2020-12-23T00:21:47
          var dateUtc = moment(utcDate).valueOf();

          var objEngine = {
            x: dateUtc,
            Date: date,
            Lat: elements.Lat,
            Lon: elements.Lon,
            Address: elements.Address,
            y: elemntSpeed,
            CruiseModeTime: elements.CruiseModeTime,
            DistanceCruiseMode: elements.DistanceCruiseMode,
            FuelCruiseMode: elements.FuelCruiseMode,
            nameSerie: "avgSpeed",
            //  DistanceCruiseMode: 30,
            //  FuelCruiseMode: 63,
            // BrakeCounter: 16,
            // ClutchCounter: 16,
            // RoughBrakeCounter: 16,
            // ExcessRpmCounter: 16,
          };
          var objEngine1 = {
            x: dateUtc,
            Date: date,
            Lat: elements.Lat,
            Lon: elements.Lon,
            Address: elements.Address,
            y: elemntRPMS,
            CruiseModeTime: elements.CruiseModeTime,
            DistanceCruiseMode: elements.DistanceCruiseMode,
            FuelCruiseMode: elements.FuelCruiseMode,
            nameSerie: "avgRpms",
          };

          var objPercent = {
            x: dateUtc,
            Date: date,
            Lat: elements.Lat,
            Lon: elements.Lon,
            Address: elements.Address,
            y: elements.AvgMotorLoadPercentage,
            CruiseModeTime: elements.CruiseModeTime,
            DistanceCruiseMode: elements.DistanceCruiseMode,
            FuelCruiseMode: elements.FuelCruiseMode,
            nameSerie: "avgMotorLoad",
          };
          var objPercent1 = {
            x: dateUtc,
            Date: date,
            Lat: elements.Lat,
            Lon: elements.Lon,
            Address: elements.Address,
            y: elements.AcceleratorPedalPositionAvg,
            CruiseModeTime: elements.CruiseModeTime,
            DistanceCruiseMode: elements.DistanceCruiseMode,
            FuelCruiseMode: elements.FuelCruiseMode,
            nameSerie: "avgPedal",
          };
          engine.push(objEngine);
          percentUsage.push(objPercent);
          engine1.push(objEngine1);
          percentUsage1.push(objPercent1);

          categories.push(date);
        });

        //COMPARATIVE

        //Bad Habits detected

        //Comparative
        j++;
        var objChartBad = {
          name:
            element.General.Name == "Viaje sin periodo asignado"
              ? i18n.t("noTrips")
              : element.General.Name,
          data: [
            ExcessRpmCounter,
            BrakeCounter,
            ClutchCounter,
            RoughBrakeCounter,
          ],
          color: colorsCharts2[j],
        };
        totalHabits +=
          ExcessRpmCounter + BrakeCounter + ClutchCounter + RoughBrakeCounter;
        chartBadHabits.push(objChartBad);

        var drivingF2 = getters.convertVolume(element.UsedFuel.Driving);
        var ralentiF2 = getters.convertVolume(element.UsedFuel.Ralenti);
        var ptoF2 = getters.convertVolume(element.UsedFuel.Pto);
        var sumFuelConsumed = drivingF2 + ralentiF2 + ptoF2;

        var drivingE2 = element.EngineUsageTime.Driving;
        var ralentiE2 = element.EngineUsageTime.Ralenti;
        var ptoE2 = element.EngineUsageTime.Pto;
        ptoE2 = ptoE2 > 0 ? ptoE2 : 0;

        var distancP = getters.convertDistance(element.General.Distance);
        dist = getters.convertDistance(dist);
        var performanceP = getters.convertPerformance(
          element.General.PerformancePerDistance
        );

        var timeTotalEngine1 = drivingE2 + ralentiE2; // + ptoE2;

        performanceP =
          performanceP == 0 ? 0 : parseFloat(performanceP.toFixed(3));
        distancP = distancP == 0 ? 0 : parseFloat(distancP.toFixed(3));
        timeTotalEngine1 =
          timeTotalEngine1 == 0 ? 0 : parseFloat(timeTotalEngine1.toFixed(3));

        sumFuelConsumed =
          sumFuelConsumed == 0 ? 0 : parseFloat(sumFuelConsumed.toFixed(1));

        var breakTimeC =
          element.General.RestingTime == 0
            ? 0
            : parseFloat(element.General.RestingTime.toFixed(2));

        var inTransitData =
          element.InTransitIncidents != null &&
          element.InTransitIncidents.length > 0
            ? element.InTransitIncidents.length
            : 0;

        var objComparative = {
          trip:
            element.General.Name == "Viaje sin periodo asignado"
              ? i18n.t("noTrips")
              : element.General.Name,
          performance: performanceP,
          distancRoad: distancP,
          timeEngine: getters.splitTime({ time: timeTotalEngine1 }),
          breakTime: getters.splitTime({ time: breakTimeC }),
          fuelConsumed: sumFuelConsumed,
          tripDuration: element.General.TripTime,
          exceptions: inTransitData,
        };

        var avgssped = getters.convertMilesPerHour(element.Speed.AverageSpeed);
        var mxSpeeed = getters.convertMilesPerHour(element.Speed.MaxSpeed);

        arrComparativeTable.push(objComparative);

        /// speedMax.push(mxSpeeed);
        //maxrpm.push(element.Speed.MaxRPMs);
        // avgSpeed.push(avgssped);
        //avgRpm.push(element.Speed.AverageRPMs);

        Array.prototype.min = function() {
          return Math.min.apply(null, this);
        };

        //  var speedss = [];
        //  var repmss = [];
        var pedalF = 0;
        //var motorLoadF = 0;

        pedal.forEach((element) => {
          if (element > 0) {
            pedalF += element;
          }
        });
        // motorLoad.forEach((element) => {
        //   if (element > 0) {
        //     motorLoadF += element;
        //   }
        // });

        pedalF = pedalF > 0 ? pedalF / pedal.length : 0;
        // motorLoadF = motorLoadF > 0 ? motorLoadF / motorLoad.length : 0;
        pedalF = pedalF > 0 ? parseFloat(pedalF).toFixed(2) : 0;
        // motorLoadF = motorLoadF > 0 ? parseFloat(motorLoadF).toFixed(2) : 0;

        var objEfficiencyByA = {
          trip:
            element.General.Name == "Viaje sin periodo asignado"
              ? i18n.t("noTrips")
              : element.General.Name,
          maxSpeed: mxSpeeed,
          avgSpeed: avgssped,
          maxRpmm: element.Speed.MaxRPMs,
          rpmAvg: element.Speed.AverageRPMs,
          AvgMotorLoad: element.Speed.AverageMotorLoad,
          pedalProm: pedalF,
        };
        arrComparativeTableE.push(objEfficiencyByA);
      });

      ptoF = getters.convertVolume(ptoF);
      drivingF = getters.convertVolume(drivingF);
      ralentiF = getters.convertVolume(ralentiF);
      var totalFuelT = drivingF + ralentiF + ptoF;
      distanceC = getters.convertVolume(distanceC);
      fuelC = getters.convertVolume(fuelC);

      var ptoEngine = ptoE > 0 ? ptoE : 0;
      var totalEngine = drivingE + ralentiE; //+ ptoEngine;
      drivingF = drivingF == 0 ? 0 : parseFloat(drivingF.toFixed(1));
      ralentiF = ralentiF == 0 ? 0 : parseFloat(ralentiF.toFixed(1));
      ptoF = ptoF == 0 ? 0 : parseFloat(ptoF.toFixed(1));
      distanceC = distanceC == 0 ? 0 : parseFloat(distanceC.toFixed(3));
      var cruiseInactiveF = totalFuelT - fuelC;
      cruiseInactiveF =
        cruiseInactiveF == 0 ? 0 : parseFloat(cruiseInactiveF.toFixed(3));
      var cruiseInactiveD = dist - distanceC;
      cruiseInactiveD = getters.convertDistance(cruiseInactiveD);
      cruiseInactiveD =
        cruiseInactiveD == 0 ? 0 : parseFloat(cruiseInactiveD.toFixed(3));

      pieFuel.push(
        {
          Id: "drive",
          Total: parseFloat(drivingF),
        },
        {
          Id: "Pto",
          Total: parseFloat(ptoF),
        },
        {
          Id: "ralenti",
          Total: parseFloat(ralentiF),
        }
      );
      pieEngine.push(
        {
          Id: "drive",
          Total: drivingE,
        },
        {
          Id: "stop",
          Total: ralentiE,
        },
        {
          Id: "Pto",
          Total: ptoE,
        }
      );
      pieCruiseF.push(
        {
          Id: "cruiseActive",
          Total: parseFloat(fuelC),
          //  Total: 0,
        },
        {
          Id: "cruiseInactive",
          Total: parseFloat(cruiseInactiveF),
        }
      );
      pieCruiseD.push(
        {
          Id: "cruiseActive",
          Total: parseFloat(distanceC),
          //Total: 0,
        },
        {
          Id: "cruiseInactive",
          Total: parseFloat(cruiseInactiveD),
        }
      );
      pieCruiseT.push(
        {
          Id: "cruiseActive",
          Total: timeC,
          //  Total: 0,
        },
        {
          Id: "cruiseInactive",
          Total: totalEngine - timeC,
        }
      );
      badHabitsDetected.push(
        {
          Id: "BrakeCounter",
          Total: BrakeCounter,
        },
        {
          Id: "ClutchCounter",
          Total: ClutchCounter,
        },
        {
          Id: "RoughBrakeCounter",
          Total: RoughBrakeCounter,
        },
        {
          Id: "ExcessRpmCounter",
          Total: ExcessRpmCounter,
        }
      );

      var daysTotal = 0;
      var hoursTotal = 0;
      var minsTotal = 0;
      var secondsTotal = 0;
      tripTime.forEach((element, index) => {
        var divide = element.replace("D", "").split(",");
        daysTotal += parseInt(divide[0]);
        // console.log(divide);
        // console.log(element);
        var divide2 = divide[1].replace(" ", "").split(":");
        hoursTotal += parseInt(divide2[0]);
        minsTotal += parseInt(divide2[1]);
        secondsTotal += parseInt(divide2[2]);
      });

      var timeToConvert = daysTotal * 24 + hoursTotal + minsTotal / 60;
      //console.log(timeToConvert);

      var tripTimeFinal = getters.splitTime({ time: timeToConvert });

      var distance = state.SelectedDistance;
      var vol = state.SelectedVolume;
      var performances1 = totalFuel == 0 || dist == 0 ? 0 : dist / totalFuel;
      performances1 = parseFloat(performances1).toFixed(2);
      //dist = dist == 0 ? 0 : dist.toFixed(3);
      dist =
        dist == 0 ? 0 : dist % 1 !== 0 ? parseFloat(dist).toFixed(3) : dist;

      if (vol == "L" && distance == "Km") {
        if (performances1 == 0) {
          performances = formatNumber.new(0, "km/L");
        } else {
          //performances1 = parseFloat(performances1).toFixed(2);
          performances1 =
            performances1 % 1 !== 0
              ? parseFloat(performances1).toFixed(2)
              : performances1;
          performances = formatNumber.new(performances1, "Km/L");
        }
      }

      if (vol == "gal" && distance == "mi") {
        if (performances1 == 0) {
          performances = formatNumber.new(0, "mi/gal");
        } else {
          //performances1 = parseFloat(performances1).toFixed(2);
          performances1 =
            performances1 % 1 !== 0
              ? parseFloat(performances1).toFixed(2)
              : performances1;
          performances = formatNumber.new(performances1, "mi/gal");
        }
      }

      if (vol == "gal" && distance == "Km") {
        if (performances1 == 0) {
          performances = formatNumber.new(0, "Km/gal");
        } else {
          //performances1 = parseFloat(performances1).toFixed(2);
          performances1 =
            performances1 % 1 !== 0
              ? parseFloat(performances1).toFixed(2)
              : performances1;
          performances = formatNumber.new(performances1, "Km/gal");
        }
      }

      if (vol == "L" && distance == "mi") {
        if (performances1 == 0) {
          performances = formatNumber.new(0, "mi/L");
        } else {
          //performances1 = parseFloat(performances1).toFixed(2);
          performances1 =
            performances1 % 1 !== 0
              ? parseFloat(performances1).toFixed(2)
              : performances1;
          performances = formatNumber.new(performances1, "mi/L");
        }
      }

      var promSpeed = getters.getProm(avgSpeed);
      var promRpms = getters.getProm(avgRpm);
      var promMotorLoad = getters.getProm(avgMotorLoad);

      speedMaxFinal = Math.max.apply(Math, speedMax);
      maxrpmFinal = Math.max.apply(Math, maxrpm);
      maxMotorLoadFinal = Math.max.apply(Math, maxMotorLoad);

      //comparative charts
      var seriesFuel = [
        {
          name: i18n.t("drive"),
          data: fuelForTrips1,
          color: colorsCharts1[0],
        },
        {
          name: i18n.t("ralenti"),
          data: fuelForTrips2,
          color: colorsCharts1[1],
        },
        {
          name: "Pto",
          data: fuelForTrips3,
          color: colorsCharts1[2],
        },
      ];

      var seriesEngine = [
        {
          name: i18n.t("drive"),
          data: engineForTrips1,
          color: colorsCharts2[0],
        },
        {
          name: i18n.t("stop"),
          data: engineForTrips2,
          color: colorsCharts2[1],
        },
        {
          name: "Pto",
          data: engineForTrips3,
          color: colorsCharts2[2],
        },
      ];

      var seriesExcep = [
        {
          name: i18n.t("driving"),
          data: conductionUnit,
          color: colorsCharts1[0],
        },
        {
          name: i18n.t("operation"),
          data: operationUnit,
          color: colorsCharts1[1],
        },
        {
          name: i18n.t("logistic"),
          data: logisticUnit,
          color: colorsCharts1[2],
        },
        {
          name: i18n.t("diagnosticUnit"),
          data: diagnosticUnit,
          color: colorsCharts1[3],
        },
      ];

      //For comparative
      if (comparative) {
        commit("viewSkeletonsC", false);
        commit("progressComparative", false);
        commit("setGlobalCalculations", arrComparativeTable);
        commit("setEfficiencyByAnalisis", arrComparativeTableE);
        var listTrips = [];

        listOfTrips.forEach((element) => {
          listTrips.push(element.name);
        });

        listTrips.splice(0, 1);

        dispatch("barGenericChart", {
          container: "comparative1",
          title: i18n.t("fuelConsum"),
          series: seriesFuel,
          trips: listTrips,
          yaxis: i18n.t("vol") + " (" + state.SelectedVolume + ")",
          stack: "",
          totalSerie: totalFuel,
        });

        dispatch("barGenericChart", {
          container: "comparative2",
          title: i18n.t("timeEngine"),
          series: seriesEngine,
          trips: listTrips,
          yaxis: i18n.t("time") + " (H)",
          stack: "",
          totalSerie: totalEngine,
        });

        var cat = [
          i18n.t("ExcessRpmCounter"),
          i18n.t("BrakeCounter"),
          i18n.t("ClutchCounter"),
          i18n.t("RoughBrakeCounter"),
        ];

        dispatch("barGenericChart", {
          container: "comparative3",
          title: i18n.t("titleExceptions"),
          series: chartDeficiences,
          trips: listTrips,
          yaxis: "Total",
          stack: "",
          totalSerie: listIntransit.length,
        });

        dispatch("barGenericChart", {
          container: "comparative4",
          title: i18n.t("BadHabits"),
          series: chartBadHabits,
          trips: cat,
          yaxis: "Total",
          stack: "",
          totalSerie: totalHabits,
        });

        dispatch("barGenericChart", {
          container: "comparative5",
          title: i18n.t("FuelControlCrucero"),
          series: [chartCruiseFuel1, chartCruiseFuel2],
          trips: listTrips,
          yaxis: i18n.t("totalFuel") + " (" + state.SelectedVolume + ")",
          stack: "normal",
          totalSerie: 0,
        });

        dispatch("barGenericChart", {
          container: "comparative6",
          title: i18n.t("TimeControlCrucero"),
          series: [chartCruiseTime1, chartCruiseTime2],
          trips: listTrips,
          yaxis: i18n.t("time") + "  (H)",
          stack: "normal",
          totalSerie: 0,
        });

        dispatch("barGenericChart", {
          container: "comparative7",
          title: i18n.t("DistanceControlCrucero"),
          series: [chartCruiseDist1, chartCruiseDist2],
          trips: listTrips,
          yaxis: i18n.t("totalFuel") + " (" + state.SelectedDistance + ")",
          stack: "normal",
          totalSerie: 0,
        });

        dispatch("barGenericChart", {
          container: "comparative8",
          title: i18n.t("titleExceptions"),
          series: seriesExcep,
          trips: listTrips,
          yaxis: "Total",
          stack: "",
          totalSerie: listIntransit.length,
        });
      } else {
        commit("viewSkeletonsP", false);
        //var totalFuelFinal = parseFloat(totalFuel).toFixed(1);
        var totalFuelFinal;
        if (state.SelectedVolume == "L") {
          totalFuelFinal = totalFuel.toFixed();
        } else {
          totalFuelFinal =
            totalFuel % 1 !== 0 ? parseFloat(totalFuel).toFixed(1) : totalFuel;
        }
        //var bTime = parseFloat(breakTime.toFixed(1));
        var bTime =
          breakTime % 1 !== 0 ? parseFloat(breakTime).toFixed(2) : breakTime;
        totalEngine =
          totalEngine % 1 !== 0
            ? parseFloat(totalEngine).toFixed(2)
            : totalEngine;
        speedMaxFinal =
          speedMaxFinal % 1 !== 0
            ? parseFloat(speedMaxFinal).toFixed(1)
            : speedMaxFinal;
        var time = getters.splitTime({ time: totalEngine });
        var Breaaktime = getters.splitTime({ time: bTime });
        var totalEnginePTOConvert = getters.splitTime({ time: totalEnginePTO });
        commit("setItemsPerformance", [
          performances, //Rendimiento
          formatNumber.new(dist, distance), //Distancia
          formatNumber.new(totalFuelFinal, vol), //Combustible usado
          formatNumber.new(odometer, distance), //Odometro
          formatNumber.new(time, ""), //Tiempo de uso de motor
          formatNumber.new(totalEnginePTOConvert, ""), //Tiempo de motor pto
          formatNumber.new(intransit, ""), //Indicentes en transito
          formatNumber.new(speedMaxFinal, distance + "/h"), //Velocidad maxima
          formatNumber.new(promSpeed, distance + "/h"), //velocidad promedio
          formatNumber.new(maxrpmFinal, "Rpms"), //Rpm maxima
          formatNumber.new(promRpms, "Rpms"), //Rpm promedio
          formatNumber.new(maxMotorLoadFinal, "%"), //Carga de motor maxima
          formatNumber.new(promMotorLoad, "%"), //Carga de motor promedio
          formatNumber.new(Breaaktime, ""), //Tiempo de descanso
          tripTimeFinal, //Tiempo de viaje
        ]);

        dispatch("createChartTravelEfficiency", [
          pieFuel,
          pieEngine,
          badHabitsDetected,
          pieCruiseF,
          pieCruiseT,
          pieCruiseD,
        ]);

        dispatch("createDeficienciesCharts", inTransitIncidents1);
        // dispatch("createPerformanceChart", {
        //   data: {
        //     engine: engine,
        //     engine1: engine1,
        //     percentUsage: percentUsage,
        //     percentUsage1: percentUsage1,
        //   },
        //   categories,
        // });

        dispatch("createChartsTest", {
          data: {
            engine: engine,
            engine1: engine1,
            percentUsage: percentUsage,
            percentUsage1: percentUsage1,
          },
          categories,
        });

        commit("btnDisabled", false);
      }
    }
    if (itemsPerformance1.Trips != undefined) {
      commit("setItemsTableIncidents", listIntransit);
      commit("setDataPerformance", {
        data: itemsPerformance1,
        trips: listOfTrips,
      });

      setTimeout(() => {
        dispatch("performanceMap");
      }, 2000);

      //general data
      //odometer = itemsPerformance1.FinalOdometer;
      //  var finalFuelFinal = itemsPerformance1.FinalOdometer;
      odometer = getters.convertDistance(odometer);
      finalFuelFinal = getters.convertVolume(finalFuelFinal);
      commit("setGeneralData", [
        odometer,
        finalFuelFinal,
        intervalStart,
        intervalEnd,
      ]);
    }
  },

  async divideData(
    { commit, dispatch, getters, state },
    { itemsPerformance1, comparative, byTrip }
  ) {
    var ItemsPerformance = state.itemsPerformanceInfo;
    if (ItemsPerformance.Trips == undefined || ItemsPerformance.Trips == null) {
      //  ItemsPerformance = await dispatch(
      //    "getItemPouchdb",
      //    "ItemsPerformance"
      //  );
      // ItemsPerformance = await dispatch("getItemPouchdb", "ItemsPerformance");
      ItemsPerformance = await dispatch("getItemPouchdb", "ItemsPerformance");
    }

    if (itemsPerformance1.Trips == undefined) {
      itemsPerformance1 = ItemsPerformance;
    }

    setTimeout(
      () =>
        dispatch("infoDivideData", {
          itemsPerformance1: itemsPerformance1,
          comparative: comparative,
          byTrip: byTrip,
          ItemsPerformance: ItemsPerformance,
        }),
      2500
    );
  },
  createChartTravelEfficiency({ state, dispatch, commit, getters }, data) {
    state.itemsTravelEfficiencyCharts.forEach((element, index) => {
      //Si contiene una grafica de control crucero y es produccion no se mostrara por el momento
      if (element.title.toLowerCase().includes("crucero") && state.production) return;

   dispatch("createPieChartsTravelEfficiency", [
      element.title,
      data[index],
   ]);
      
    });
  },
  createDeficienciesCharts: (
    { dispatch, commit, getters, state },
    inTransit
  ) => {
    dispatch("createPieCharts", ["container1", inTransit.DRIVING]);
    dispatch("createPieCharts", ["container2", inTransit.OPERATION]);
    dispatch("createPieCharts", ["container3", inTransit.LOGISTICS]);
    dispatch("createPieCharts", ["container4", inTransit.DIAGNOSTICS]);
  },
  createChartsTest: ({ dispatch, state}, { data, categories }) => {
    var activity = [
      {
        type: "spline",
        name: i18n.t("velProm"),
        data: data.engine,
        color: "#D54421",
      },
      {
        type: "spline",
        name: i18n.t("velPromRPM"),
        data: data.engine1,
        color: "#2B75B2",
      },

      {
        type: "spline",
        name: i18n.t("cargaProm"),
        data: data.percentUsage,
        yAxis: 1,
        color: "#0B3A61",
      },
      {
        type: "spline",
        name: i18n.t("pedalProm"),
        data: data.percentUsage1,
        yAxis: 1,
        color: "#C88A0E",
      },
    ];

    var distance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");
    var finalUnit = distance.toUpperCase() == "KM" ? distance + "/h" : "mph";
    var title1 = i18n.t("vel"); //+ " " + finalUnit;
    var title2 = i18n.t("percent");
    var title3 = i18n.t("vel") + " Rpms";

    var darkMode = JSON.parse(localStorage.getItem("darkMode"));

    Highstock.chart("containerPerformance", {
      chart: { backgroundColor: null },
      title: {
        text: "",
      },
      navigator: {
        enabled: true,
      },
      rangeSelector: {
        selected: 2,
      },
      xAxis: {
        className: darkMode
          ? "highcharts-color-personalized-F"
          : "highcharts-color-personalized-0",
        type: "datetime",
        labels: {
          formatter: function() {
            var lang = localStorage.getItem("language");
            var dates = moment.utc(this.value).valueOf();
            var datefinal = "";
            if (lang.toUpperCase() == "ES") {
              datefinal = moment(dates).format("DD/MMM/YYYY HH:mm");
              datefinal = datefinal.replace(".", "");
            } else {
              datefinal = moment(dates).format("MMM/DD/YYYY HH:mm");
            }

            return datefinal;
          },
        },
      },

      plotOptions: {
        series: {
          // fillOpacity: 0.1,
          turboThreshold: activity[0].data.length + 1,
        },
      },

      credits: {
        enabled: false,
      },

      legend: {
        itemStyle: {
          color: darkMode ? "#FFFFFF" : "#000000",
          //  fontWeight: "bold",
        },
      },

      yAxis: [
        {
          className: darkMode
            ? "highcharts-color-personalized-F"
            : "highcharts-color-personalized-0",
          title: {
            text: title1,
          },
          height: "50%",
          lineWidth: 2,
        },
        {
          className: darkMode
            ? "highcharts-color-personalized-F"
            : "highcharts-color-personalized-0",
          title: {
            text: title2,
          },
          top: "50%",
          height: "50%",
          offset: 0,
          lineWidth: 2,
        },
      ],
      tooltip: {
        split: true,
        formatter: function() {
          var lang = localStorage.getItem("language");
          var outputString = "";
          var j = 0;
          this.points.forEach(function(point) {
            var date = j == 0 ? point.point.Date : "";
            var units = "";
            if (point.point.nameSerie == "avgSpeed") {
              units = distance + "/h";
            } else if (point.point.nameSerie == "avgRpms") {
              units = "Rpms";
            } else {
              units = "%";
            }
            var fuelCruiseMode =
              j == 3
                ? "</b><br/>" +
                  i18n.t("FuelControlCrucero") +
                  ": " +
                  point.point.FuelCruiseMode.toString()
                : "";
            var cruiseModeTime =
              j == 3
                ? "</b><br/>" +
                  i18n.t("TimeControlCrucero") +
                  ": " +
                  point.point.CruiseModeTime.toString()
                : "";
            var distanceCruiseMode =
              j == 3
                ? "</b><br/>" +
                  i18n.t("DistanceControlCrucero") +
                  ": " +
                  point.point.DistanceCruiseMode.toString()
                : "";
            if (point.x === this.x) {
                   outputString +=
                  "<b>" +
                  date +
                  "</b><br/>" +
                  "<span style='color:" +
                  point.color +
                  "'>\u25CF</span> " +
                  point.series.name +
                  ": <b>" +
                  point.y +
                  " " +
                  units;

                if (!state.production) {
                  outputString +=
                  fuelCruiseMode +
                  cruiseModeTime +
                  distanceCruiseMode;              
                }  

                outputString +=("</b><br/>");
            }
            j++;
          }, this);
          return outputString;
        },
      },
      series: activity,
    });
  },
  createPerformanceChart: (
    { dispatch, commit, getters, state },
    { data, categories }
  ) => {
    /*
   The purpose of this demo is to demonstrate how multiple charts on the same page
   can be linked through DOM and Highcharts events and API methods. It takes a
   standard Highcharts config with a small variation for each data set, and a
   mouse/touch event handler to bind the charts together.
   */

    /**
     * In order to synchronize tooltips and crosshairs, override the
     * built-in events with handlers defined on the parent element.
     */
    ["mousemove", "touchmove", "touchstart"].forEach(function(eventType) {
      document
        .getElementById("containerPerformance")
        .addEventListener(eventType, function(e) {
          var chart, point, i, event;

          for (i = 0; i < Highcharts.charts.length; i = i + 1) {
            chart = Highcharts.charts[i];

            if (chart.userOptions.chart && chart.userOptions.chart.customSync) {
              // Find coordinates within the chart
              event = chart.pointer.normalize(e);
              // Get the hovered point
              point = chart.series[0].searchPoint(event, true);

              if (point) {
                point.highlight(e);
              }
            }
          }
        });
    });

    /**
     * Override the reset function, we don't need to hide the tooltips and
     * crosshairs.
     */
    Highcharts.Pointer.prototype.reset = function() {
      return undefined;
    };

    /**
     * Highlight a point by showing tooltip, setting hover state and draw crosshair
     */
    Highcharts.Point.prototype.highlight = function(event) {
      event = this.series.chart.pointer.normalize(event);
      this.onMouseOver(); // Show the hover marker
      this.series.chart.tooltip.refresh(this); // Show the tooltip
      this.series.chart.xAxis[0].drawCrosshair(event, this); // Show the crosshair
    };

    /**
     * Synchronize zooming through the setExtremes event handler.
     */
    function syncExtremes(e) {
      var thisChart = this.chart;

      if (e.trigger !== "syncExtremes") {
        // Prevent feedback loop
        Highcharts.each(Highcharts.charts, function(chart) {
          if (chart !== thisChart) {
            if (chart.xAxis[0].setExtremes) {
              // It is null while updating
              chart.xAxis[0].setExtremes(e.min, e.max, undefined, false, {
                trigger: "syncExtremes",
              });
            }
          }
        });
      }
    }

    // Get the data. The contents of the data file can be viewed at
    var i = 0;
    var title = i18n.t("motorEfficiency").toUpperCase();

    var activity = [
      [
        {
          name: i18n.t("velProm"),
          data: data.engine,
          yAxis: 1,
          color: "#424242",
        },
        {
          name: i18n.t("velPromRPM"),
          data: data.engine1,
          color: "#2B75B2",
        },
      ],
      [
        {
          name: i18n.t("cargaProm"),
          data: data.percentUsage,
          yAxis: 1,
          color: "#0B3A61",
        },
        {
          name: i18n.t("pedalProm"),
          data: data.percentUsage1,
          color: "#C88A0E",
        },
      ],
    ];
    activity.forEach(function(datitos) {
      var distance =
        localStorage.getItem("Distance") == undefined
          ? "Km"
          : localStorage.getItem("Distance");
      var finalUnit = distance.toUpperCase() == "KM" ? distance + "/h" : "mph";

      var yAxisData = [
        {
          lineWidth: 1,
          opposite: false,
          title: {
            text: i == 0 ? i18n.t("vel") + " " + finalUnit : i18n.t("percent"),
            style: {
              visibility: "visible",
            },
          },
        },
        {
          //  visible: i == 0 ? true : false,
          lineWidth: 1,
          opposite: true,
          title: {
            text: i == 0 ? i18n.t("vel") + " Rpms" : i18n.t("percent"),
            style: {
              visibility: "visible",
              color: i == 1 ? "#FFFFFF" : "#000000",
            },
          },
        },
      ];

      var chartDiv = document.createElement("div");
      chartDiv.className = "chart";
      document.getElementById("containerPerformance").appendChild(chartDiv);

      Highcharts.chart(chartDiv, {
        chart: {
          backgroundColor: "#FFFFFF",
          type: "areaspline",
          spacingTop: 20,
          spacingBottom: 20,
          zoomType: "x",
          style: {
            fontFamily: "Arial",
          },
        },
        title: {
          text: i == 0 ? title : "",
          align: "center",
          margin: 0,
          x: 30,
        },
        credits: {
          enabled: false,
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          series: {
            fillOpacity: 0.1,
            turboThreshold: datitos[i].data.length + 1,
          },
        },
        xAxis: {
          categories: categories,
          crosshair: true,
          events: {
            setExtremes: syncExtremes,
          },
          labels: {
            format: "{value}",
          },
          plotBands: [],
        },
        yAxis: yAxisData,

        tooltip: {
          shared: true,
          formatter: function() {
            var lang = localStorage.getItem("language");
            var outputString = "";
            var j = 0;
            this.points.forEach(function(point) {
              var date = j == 0 ? point.point.Date : "";
              var units = "";
              if (point.point.nameSerie == "avgSpeed") {
                units = distance + "/h";
              } else if (point.point.nameSerie == "avgRpms") {
                units = "Rpms";
              } else {
                units = "%";
              }
              var fuelCruiseMode =
                j == 1
                  ? "</b><br/>" +
                    i18n.t("FuelControlCrucero") +
                    ": " +
                    point.point.FuelCruiseMode.toString()
                  : "";
              var cruiseModeTime =
                j == 1
                  ? "</b><br/>" +
                    i18n.t("TimeControlCrucero") +
                    ": " +
                    point.point.CruiseModeTime.toString()
                  : "";
              var distanceCruiseMode =
                j == 1
                  ? "</b><br/>" +
                    i18n.t("DistanceControlCrucero") +
                    ": " +
                    point.point.DistanceCruiseMode.toString()
                  : "";
              if (point.x === this.x)
              {

                outputString +=
                  "<b>" +
                  date +
                  "</b><br/>" +
                  "<span style='color:" +
                  point.color +
                  "'>\u25CF</span> " +
                  point.series.name +
                  ": <b>" +
                  point.y +
                  " " +
                  units;

                if (!state.production) {
                  outputString +=
                  fuelCruiseMode +
                  cruiseModeTime +
                  distanceCruiseMode;              
                }  

                outputString +=("</b><br/>");

              }
              j++;
            }, this);
            return outputString;
          },
        },
        series: datitos,
      });
      i++;
    });
  },
  CenterMap: ({ state }, { miLat, miLng }) => {
    var center = new google.maps.LatLng(miLat, miLng);
    var map = state.insideMap;
    map.panTo(center);
    map.setZoom(20);
  },

  //Función para crear mapa de performance/individual
  performanceMap: ({ state, dispatch }) => {
    if (state.listOfMarkersPC.length > 0) {
      for (var i = 0; i < state.listOfMarkersPC.length; i++) {
        state.listOfMarkersPC[i].setMap(null);
      }
      state.listOfMarkersPC = [];
      state.markerClusterPC.clearMarkers();
    }

    //var mySet = state.coor;

    var latlng;
    var map;
    //mapComparative
    if (router.app.$route.path == "/dashboard/performance/individual") {
      if (state.itemsTableInTransit2.length == 0) {
        map = new google.maps.Map(document.getElementById("mapPerformance"), {
          zoom: 5,
          center: {
            lat: 19.609722,
            lng: -99.059998,
          },
          options: {
            gestureHandling: "greedy",
          },
        });
      } else {
        latlng = {
          lat: state.itemsTableInTransit2[0].Lat,
          lng: state.itemsTableInTransit2[0].Lon,
        };
        map = new google.maps.Map(document.getElementById("mapPerformance"), {
          zoom: 5,
          center: latlng,
          options: {
            gestureHandling: "greedy",
          },
        });
      }
    } else if (
      router.app.$route.path ==
      "/dashboard/performance/individual/comparative"
    ) {
      if (state.itemsTableInTransit2.length == 0) {
        map = new google.maps.Map(document.getElementById("mapComparative"), {
          zoom: 5,
          center: {
            lat: 19.609722,
            lng: -99.059998,
          },
          options: {
            gestureHandling: "greedy",
          },
        });
      } else {
        latlng = {
          lat: state.itemsTableInTransit2[0].Lat,
          lng: state.itemsTableInTransit2[0].Lon,
        };
        map = new google.maps.Map(document.getElementById("mapComparative"), {
          zoom: 5,
          center: latlng,
          options: {
            gestureHandling: "greedy",
          },
        });
      }
    }

    var infowindow = new google.maps.InfoWindow();
    var marker, i;
    var gmarkers = state.listOfMarkersPC;

    for (i = 0; i < state.itemsTableInTransit2.length; i++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(state.itemsTableInTransit2[i].Lat, state.itemsTableInTransit2[i].Lon),
        draggable: false,
        icon:
          "https://maps.google.com/mapfiles/ms/icons/" +
          state.itemsTableInTransit2[i].newColor +
          "-dot.png",
      });
      //http://maps.google.com/mapfiles/ms/icons/red-dot.png
      //http://maps.google.com/mapfiles/ms/icons/yellow-dot.png
      //http://maps.google.com/mapfiles/ms/icons/blue-dot.png
      //http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png
      //http://maps.google.com/mapfiles/ms/icons/orange-dot.png
      //http://maps.google.com/mapfiles/ms/icons/pink-dot.png
      //http://maps.google.com/mapfiles/ms/icons/purple-dot.png

      google.maps.event.addListener(marker, "click",
        (function(marker, i) {
          return async function () {
            try {
              let reference = state.itemsTableInTransit2[i].Reference;
              if (reference == i18n.t("showReference")) {
                try {
                  infowindow.setContent(
                    '<div style="max-width: 340px;" id="content">' +
                    `<h4 class="mb-2"> ${state.itemsTableInTransit2[i].tripName}</h4>` +
                    '<div id="bodyContent" style="color:black;">' +
                    `<p class="mb-0"><b class="font-weight-bold">${i18n.t("vehicle")}:</b> ${state.itemsTableInTransit2[i].Device}</p>` +
                    `<p class="mb-0"><b class="font-weight-bold">${i18n.t("event")}:</b> ${state.itemsTableInTransit2[i].Description}</p>` +
                    `<p class="mb-0"><b class="font-weight-bold">${i18n.t("dateT")}:</b> ${state.itemsTableInTransit2[i].DateFormatted}</p>` +
                    "<hr style='margin-bottom:3%;margin-top:3%;'/>" +
                    `<p class="mb-0"><b class="font-weight-bold">${i18n.t("location")}:</b> ${i18n.t("loading")} </p>` +
                    "</div>" +
                    "</div>"
                  );
    
                  infowindow.open(map, marker);

                  reference = await dispatch("getReferenceData", state.itemsTableInTransit2[i]);
                } catch (e) {
                  reference = null;
                }
              }

              reference = reference == null ? i18n.t("notAvailable") : reference;
              state.itemsTableInTransit2[i].Reference = reference;

              infowindow.setContent(
                '<div style="max-width: 340px;" id="content">' +
                `<h4 class="mb-2"> ${state.itemsTableInTransit2[i].tripName}</h4>` +
                '<div id="bodyContent" style="color:black;">' +
                `<p class="mb-0"><b class="font-weight-bold">${i18n.t("vehicle")}:</b> ${state.itemsTableInTransit2[i].Device}</p>` +
                `<p class="mb-0"><b class="font-weight-bold">${i18n.t("event")}:</b> ${state.itemsTableInTransit2[i].Description}</p>` +
                `<p class="mb-0"><b class="font-weight-bold">${i18n.t("dateT")}:</b> ${state.itemsTableInTransit2[i].DateFormatted}</p>` +
                "<hr style='margin-bottom:3%;margin-top:3%;'/>" +
                `<p class="mb-0"><b class="font-weight-bold">${i18n.t("location")}:</b> ${reference} </p>` +
                "</div>" +
                "</div>"
              );

              infowindow.open(map, marker);

            } catch (e) {
              alert("infoWindow, Excepción: " + e.message);
            }
          };
        })(marker, i)
      );

      gmarkers.push(marker);
    }

    var clustererOptions = {
      maxZoom: 15,
      styles: [
        {
          //a blue circle indicates less than 10 markers
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
          height: 52,
          width: 53,
          anchorText: [20, 27],
        },
        {
          //a yellow circle indicates 10 to 99 markers
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m2.png",
          height: 55,
          width: 56,
          anchorText: [22, 28],
        },
        {
          //a red circle indicates 100 to 999 markers
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m3.png",
          height: 65,
          width: 66,
          anchorText: [27, 34],
        },
        {
          //a pink circle indicates 1000 to 9999 markers
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m4.png",
          height: 77,
          width: 78,
          anchorText: [32, 40],
        },
        {
          //a violet circle indicates 10000 markers or more
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m5.png",
          height: 89,
          width: 90,
          anchorText: [39, 46],
        },
      ],
    };

    state.markerClusterPC = new MarkerClusterer(
      map,
      gmarkers,
      clustererOptions
    );

    state.insideMap = map;
  },
  startTrackingMap: ({ state, dispatch }, loadMap) => {
    var latlngT;
    var mapTracking;
    latlngT = {
      lat: 19.609722,
      lng: -99.059998,
    };
    mapTracking = new google.maps.Map(document.getElementById("trackingMap"), {
      zoom: 5,
      center: latlngT,
      options: {
        gestureHandling: "greedy",
      },
    });
    ////Se comenta AUTOCOMPLETE para subir cambios a Production
    //  // Create the DIV to hold the control and call the CenterControl()
    // // constructor passing in this DIV.
    // const centerControlDiv = document.createElement("div");
    // CenterControl(centerControlDiv, mapTracking);
    // function CenterControl(controlDiv, mapTracking) {
    //   // Set CSS for the control border.
    //   const controlUI = document.createElement("div");

    //   controlUI.style.backgroundColor = "#fff";
    //   controlUI.style.border = "1px solid #fff";
    //   controlUI.style.borderRadius = "2px";
    //   controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    //   controlUI.style.marginTop = "10px";
    //   controlUI.style.marginBottom = "22px";
    //   controlUI.style.textAlign = "bottom";
    //   controlUI.title = "search";
    //   controlUI.style.width = "200px";
    //   controlDiv.appendChild(controlUI);

    //   // Set CSS for the control interior.
    //   const controlText = document.createElement("input");

    //   controlText.style.color = "rgb(25,25,25)";
    //   controlText.style.fontFamily = "Roboto,Arial,sans-serif";
    //   controlText.style.fontSize = "16px";
    //   controlText.style.lineHeight = "38px";
    //   controlText.style.paddingLeft = "5px";
    //   controlText.style.paddingRight = "5px";
    //   controlText.setAttribute("type","text");
    //   controlText.setAttribute("placeholder", i18n.t('search'));
    //   controlText.setAttribute("id","searchInput");
    //   controlText.setAttribute("class","controls");
    //   controlUI.appendChild(controlText);
    //   var input = controlText;
    //   var autocomplete = new google.maps.places.Autocomplete(input);
    //   console.log(autocomplete);
    //   state.autocomplete = autocomplete;
    //   autocomplete.addListener('place_changed', function () {
    //     var place = autocomplete.getPlace();
    //     console.log(place);
    //     if (place == null) {
    //       input.value = "";
    //     } else {
    //       state.referencePoint = place.geometry.location;
    //       //eliminar geocerca anterior
    //       if (state.circleTracking != null) {
    //         state.circleTracking.setMap(null);
    //         state.circleTracking = null;
    //         state.referencePointMarker.setMap(null);
    //         state.referencePointMarker = [];
    //         var toolBox = document.getElementById("sliderTracking");
    //         toolBox.style.display = "none";
    //         state.radiusActive = false;
    //       }

    //       //se crea geocerca
    //       var circle = null;
    //       var referencePointMarker = "";
    //       state.markersInRadius = [];
    //       var trackingList = state.trackingList;
    //       var toolBox = document.getElementById("sliderTracking");
    //       state.givenRadius = 150 * 1000; //se convierten km a m
    //       if (state.SelectedDistance != "Km") {
    //         //se convierten las mi a m
    //         state.givenRadius = (150 * 1609.344).toFixed(3).replace(/\.000$/, "");
    //         state.givenRadius = parseFloat(state.givenRadius);
    //       }
    //       //var origin = "../neutrinost/img/images/";
    //       var origin = "../img/images/";
    //       referencePointMarker = new google.maps.Marker({
    //         position: state.referencePoint,
    //         map: state.insideTrackingMap,
    //         icon: {
    //           url: origin + "referencePoint.png"
    //         }
    //       });
    //       state.referencePointMarker = referencePointMarker;
    //       circle = new google.maps.Circle({
    //         center: state.referencePoint,
    //         radius: state.givenRadius,
    //         clickable: false,
    //         map: state.insideTrackingMap,
    //         strokeOpacity: 0.8,
    //         strokeColor: "#0366fc",
    //         strokeWeight: 2,
    //         fillColor: "#0366fc",
    //         fillOpacity: 0.35
    //       });
    //       state.circleTracking = circle;
    //       for (var i = 0; i < trackingList.length; i++) {
    //         //la api de google maps calcula la distancia en metros
    //         if (
    //           google.maps.geometry.spherical.computeDistanceBetween(
    //             state.referencePoint,
    //             new google.maps.LatLng(
    //               trackingList[i].Location.Lat,
    //               trackingList[i].Location.Lon
    //             )
    //           ) <= state.givenRadius
    //         ) {
    //           state.markersInRadius.push(trackingList[i]);
    //         }
    //       }
    //       mapTracking.fitBounds(circle.getBounds());
    //       //obtengo coordenadas a partir de las coordenadas del referencePoint, los metros del radio y a 180 grados
    //       //ya que google maps cuenta los grados como el reloj y ocupo 180 grados para ubicarme debajo del circulo
    //       var newlatLng = google.maps.geometry.spherical.computeOffset(state.referencePoint, state.givenRadius, 180);
    //       //creo overlay para obtener los pixeles a partir de coordenadas
    //       state.overlayToolBox = new google.maps.OverlayView();
    //       state.overlayToolBox.draw = function () { };
    //       state.overlayToolBox.setMap(state.insideTrackingMap);
    //       console.log(state.overlayToolBox.getProjection().fromLatLngToDivPixel(newlatLng));
    //       var myPixels = state.overlayToolBox.getProjection().fromLatLngToContainerPixel(newlatLng);
    //       //acomodo la toolbox
    //       toolBox.style.left = myPixels.x + "px";
    //       toolBox.style.top = myPixels.y + 20 + "px";
    //       toolBox.style.display = "block";
    //       console.log(myPixels);
    //       dispatch("setTrackingMap", {
    //         listOfVeh: state.markersInRadius,
    //         isRadius: true
    //       });
    //       state.radiusActive = true;
    //       document.getElementById("menuSearchVehT").style.display = "none";
    //       document.getElementById("menuTracking").style.display = "none";
    //     }
    //   });
    // }
    // mapTracking.controls[google.maps.ControlPosition.TOP_LEFT].push(centerControlDiv);
    //// acaba AUTOCOMPLETE

    state.insideTrackingMap = mapTracking;
    if (loadMap) {
      dispatch("fleetLastPosition");
    }
  },
  async fleetLastPosition({ state, commit, dispatch }) {
    commit("progressTracking", true);
    var dID = localStorage.getItem("Dealer_Id");
    var cID = localStorage.getItem("Client_Id");
    var aID = localStorage.getItem("Account_Id");
    cID = cID == "ND" || cID == "NA" ? "" : cID;
    aID = aID == "ND" || aID == "NA" ? "000001" : aID;
    var offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");
      var carrierId = JSON.parse(localStorage.getItem("CarrierId"));
      if (carrierId == null) {
        state.carrierId = carrierId;
      } else {
        state.carrierId = carrierId.Id;
      }
      const url =
        state.NeutrinoUrl +
        "operation/traffic/fleet/positions?did=" +
        dID +
        "&cid=" +
        cID +
        "&acid=" +
        aID;
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var request = {
        from: "FLEET_LAST_POSITION_LIST",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };
      await dispatch("ManageWorker", [request]);
    } else {
      commit("progressTracking", false);
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
    }
    var minutes =
      localStorage.getItem("minutesT") == undefined ||
      localStorage.getItem("minutesT") == null
        ? 5 * 60000
        : localStorage.getItem("minutesT") * 60000;
    setTimeout(function() {
      if (router.app.$route.path == "/tracking") {
        dispatch("fleetLastPosition");
      }
    }, minutes);
  },
  //Centrar vehiculo cuando se usan los botones consultar estatus y centrar en mapa
  goToMarker: ({ state }, centerLatLng) => {
    var center = new google.maps.LatLng(centerLatLng);
    var mapT = state.insideTrackingMap;
    mapT.panTo(center);
    mapT.setZoom(20);
    mapT.panBy(0, 185);
  },
  //Cuando se usa el boton de back se modifica la vista del mapa para que vuelva a mostrar los vehiculos en el mapa con zoom apropiado
  setBounds: ({ state }) => {
    var mapT = state.insideTrackingMap;
    var nbounds = new google.maps.LatLngBounds();
    var list = state.trackingList;
    var i;
    for (i = 0; i < list.length; i++) {
      nbounds.extend(state.listOfMarkersInTracking[i].getPosition());
    }
    mapT.fitBounds(nbounds, { bottom: 300 });
  },
  async setTrackingMap(
    { state, commit, dispatch, getters },
    { listOfVeh, isRadius }
  ) {
    //plasmar lista de vehiculos en tabla y mapa
    if (state.listOfMarkersInTracking.length > 0) {
      for (var i = 0; i < state.listOfMarkersInTracking.length; i++) {
        state.listOfMarkersInTracking[i].setMap(null);
      }
      state.listOfMarkersInTracking = [];
      state.markerClusterTracking.clearMarkers();
    }
    var markerT, i, list;
    var gmarkersT = state.listOfMarkersInTracking;
    var mapT = state.insideTrackingMap;
    var menuDisplayed = false;
    var menuBox = null;
    var overlay = new google.maps.OverlayView();
    overlay.draw = function() {};
    overlay.setMap(mapT);
    menuBox = document.getElementById("menuTracking");
    var overlaySV = new google.maps.OverlayView();
    overlaySV.draw = function() {};
    overlaySV.setMap(mapT);
    var searchVeh = false;
    var touch = false;
    var menuSV = document.getElementById("menuSearchVehT");
    var days =
      localStorage.getItem("numberOfDaysT") == undefined
        ? 30
        : localStorage.getItem("numberOfDaysT");
    if (days == i18n.t("all")) {
      var daysToMilli = days;
    } else {
      var daysToMilli = getters.getDaysToMilli(days);
    }

    if (isRadius == false) {
      //gracias al commit theTrackingList, se le da formato y se guarda la lista de vehiculos de la nueva peticion
      state.trackingList = [];
      await commit("theTrackingList", {
        vehicles: listOfVeh,
        days: daysToMilli,
      });
      if (state.circleTracking == null) {
        //si no se ha usado el buscar vehiculos, se muestran los vehiculos tal cual vienen del ws
        list = state.trackingList;
      } else {
        state.markersInRadius = [];
        //si hay circulo, pero hay nueva peticion por el setTimeout (el setTimeout manda isRadius false)
        // solo se mostraran los vehiculos de la nueva peticion que esten dentro del radio
        for (var i = 0; i < state.trackingList.length; i++) {
          //la api de google maps calcula la distancia en metros
          if (
            google.maps.geometry.spherical.computeDistanceBetween(
              state.referencePoint,
              new google.maps.LatLng(
                state.trackingList[i].Location.Lat,
                state.trackingList[i].Location.Lon
              )
            ) <= state.givenRadius
          ) {
            state.markersInRadius.push(state.trackingList[i]);
          }
        }
        list = state.markersInRadius;
      }
    } else {
      //si se uso el buscar vehiculos y no hay nueva peticion por el setTimeout
      list = state.markersInRadius;
    }
    var myLatLng;
    //var origin = "../neutrinost/img/images/";
    var origin = "../img/images/";
    var vehicleOn = "onLine/";
    var vehicleOff = "offLine/";
    var stateOfVeh;
    var bounds = new google.maps.LatLngBounds();
    for (i = 0; i < list.length; i++) {
      if (list[i].OnLine == true) {
        stateOfVeh = vehicleOn;
      } else {
        stateOfVeh = vehicleOff;
      }
      myLatLng = {
        lat: list[i].Location.Lat,
        lng: list[i].Location.Lon,
      };
      var data = list[i];
      markerT = new google.maps.Marker({
        position: new google.maps.LatLng(myLatLng),
        icon: {
          labelOrigin: new google.maps.Point(28, 28),
          url: origin + stateOfVeh + list[i].Orientation + ".gif",
        },
        label: {
          text: list[i].Nick,
          className: "label",
          fontSize: "0.7rem",
          fontWeight: "bold",
        },
        title: list[i].MovilId,
      });
      bounds.extend(markerT.getPosition());
      gmarkersT.push(markerT);
      (function(marker, data) {
        if (window.matchMedia("(pointer: coarse)").matches) {
          // touchscreen
          //click en el icono del vehiculo
          google.maps.event.addListener(markerT, "click", (ev) => {
            var pixels = overlay
              .getProjection()
              .fromLatLngToContainerPixel(ev.latLng);
            menuBox.style.left = pixels.x + 10 + "px";
            menuBox.style.top = pixels.y + 10 + "px";
            menuBox.style.display = "block";
            menuDisplayed = true;
            state.selectedVeh = data;
          });
        }
        google.maps.event.addListener(
          markerT,
          "rightclick",
          (mapsMouseEvent) => {
            var pixels = overlay
              .getProjection()
              .fromLatLngToContainerPixel(mapsMouseEvent.latLng);
            menuBox.style.left = pixels.x + 10 + "px";
            menuBox.style.top = pixels.y + 10 + "px";
            menuBox.style.display = "block";
            menuDisplayed = true;
            state.selectedVeh = data;
            state.referencePoint = mapsMouseEvent.latLng;
          }
        );
      })(markerT, data);
    }
    // The event occurs when a finger is placed on a touch screen
    google.maps.event.addDomListener(
      document.getElementById("trackingMap"),
      "touchstart",
      () => {
        touch = true;
      }
    );

    google.maps.event.addListener(mapT, "rightclick", (rCEvent) => {
      if (state.circleTracking == null) {
        var pixelsSV = overlaySV
          .getProjection()
          .fromLatLngToContainerPixel(rCEvent.latLng);
        menuSV.style.left = pixelsSV.x + "px";
        menuSV.style.top = pixelsSV.y + "px";
        menuSV.style.display = "block";
        searchVeh = true;
        state.referencePoint = rCEvent.latLng;
      }
    });

    //click en el mapa
    google.maps.event.addListener(mapT, "click", (clickEv) => {
      //si hay touch y no se este mostrando la opcion de buscar vehiculo y no se esta mostrando el context menu
      if (touch == true && searchVeh == false && menuDisplayed == false) {
        if (state.circleTracking == null) {
          var pixelsSV = overlaySV
            .getProjection()
            .fromLatLngToContainerPixel(clickEv.latLng);
          menuSV.style.left = pixelsSV.x + "px";
          menuSV.style.top = pixelsSV.y + "px";
          menuSV.style.display = "block";
          searchVeh = true;
          state.referencePoint = clickEv.latLng;
        }
      } else if (touch && searchVeh) {
        searchVeh = false;
        menuSV.style.display = "none";
      }

      if (menuDisplayed) {
        menuBox.style.display = "none";
        menuDisplayed = false;
      }

      if (searchVeh == true && touch == false) {
        searchVeh = false;
        menuSV.style.display = "none";
      }
    });

    //evento para escuchar cuando se empieza a arrastrar el mapa proceder a ocultar el context menu
    google.maps.event.addListener(mapT, "dragstart", function() {
      menuBox.style.display = "none";
      menuDisplayed = false;
      searchVeh = false;
      menuSV.style.display = "none";
    });
    google.maps.event.addListener(mapT, "zoom_changed", function() {
      menuBox.style.display = "none";
      menuDisplayed = false;
      searchVeh = false;
      menuSV.style.display = "none";
    });
    menuBox.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
    menuSV.addEventListener("contextmenu", (ev) => {
      ev.preventDefault();
    });
    var clustererOptions = {
      maxZoom: 15,
      styles: [
        {
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
          height: 52,
          width: 53,
          anchorText: [20, 27],
        },
        {
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m2.png",
          height: 55,
          width: 56,
          anchorText: [22, 28],
        },
        {
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m3.png",
          height: 65,
          width: 66,
          anchorText: [27, 34],
        },
        {
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m4.png",
          height: 77,
          width: 78,
          anchorText: [32, 40],
        },
        {
          url:
            "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m5.png",
          height: 89,
          width: 90,
          anchorText: [39, 46],
        },
      ],
    };
    state.markerClusterTracking = new MarkerClusterer(
      mapT,
      gmarkersT,
      clustererOptions
    );
    //solo ejecutar la primera vez
    if (state.trackingFirstTime) {
      mapT.fitBounds(bounds, { bottom: 300 });
      state.trackingFirstTime = false;
    }
  },
  async activityOfVehicle({ state, commit, dispatch }, selectedVeh) {
    if (state.initialReport == false) {
      commit("indeterminateReport", true);
    }
    commit("cleanClustersAndMarkersPolyline");
    var dID = localStorage.getItem("Dealer_Id");
    var cID = localStorage.getItem("Client_Id");
    cID = cID == "ND" || cID == "NA" ? "" : cID;
    var stardDateTracking, endDateTracking;
    var offline = JSON.parse(localStorage.getItem("offline"));
    var startDate = localStorage.getItem("startDateTrack");
    var startClock = localStorage.getItem("startClockTrack");
    var endDate = localStorage.getItem("endDateTrack");
    var endClock = localStorage.getItem("endClockTrack");
    if (!offline) {
      var token = state.token;
      if (token == null || token == "") token = localStorage.getItem("Token");

      const url = state.NeutrinoUrl + "operation/vehicle/activity";
      // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
      // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
      // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

      var defaultDate = moment().format("YYYY-MM-DD");
      //console.log(defaultDate);
      stardDateTracking = defaultDate + "T00:00";
      endDateTracking = defaultDate + "T23:59";
      //si se modificó la fecha del calendario
      if (startDate != undefined) {
        startDate = moment(startDate).format("YYYY-MM-DD");
        endDate = moment(endDate).format("YYYY-MM-DD");
        stardDateTracking = startDate + "T" + startClock;
        endDateTracking = endDate + "T" + endClock;
      }
      var data = {
        DealerId: dID,
        ClientId: cID,
        MovilId: selectedVeh.MovilId,
        StartDate: stardDateTracking,
        EndDate: endDateTracking,
      };
      // console.log(data);

      var request = {
        from: "ACTIVITY_OF_VEHICLE",
        URL: url,
        method: "POST",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: data,
      };
      await dispatch("ManageWorker", [request]);
    } else {
      commit("indeterminateReport", false);
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
    }
  },
  zoomActivity: ({ state }, coor) => {
    //console.log("lets center");
    //console.log(coor);
    var centerMap = new google.maps.LatLng(
      coor.Location.Lat,
      coor.Location.Lon
    );
    var mapT = state.insideTrackingMap;
    mapT.panTo(centerMap);
    mapT.setZoom(20);
    mapT.panBy(0, 70);
  },
  async getPerformanceByTrip({ state, dispatch, commit, getters }, id) {
    //  var performance = JSON.parse(localStorage.getItem("ItemsPerformance"));
    var performance = state.itemsPerformanceInfo;
    if (performance == null) {
      performance = await dispatch("getItemPouchdb", "ItemsPerformance");
    }
    // console.log(performance);
    var arrTrips = {
      FinalOdometer: performance.FinalOdometer,
      FinalFuel: performance.FinalFuel,
      Trips: [],
    };
    performance.Trips.forEach((element) => {
      if (element.General.TripId == id) {
        arrTrips.Trips.push(element);
      }
    });

    if (arrTrips != null && arrTrips.Trips.length > 0) {
      commit("viewSkeletonsP", true);
      dispatch("destroyPerformanceCharts");
      dispatch("divideData", {
        itemsPerformance1: arrTrips,
        comparative: false,
        byTrip: true,
      });
    }
  },
  destroyPerformanceCharts: ({ state, dispatch }, data) => {
    var charts = [
      "containerPerformance",
      "container1",
      "container2",
      "container3",
      "EngineUsageTime",
      "FuelConsumed",
      "BadHabits",
      "FuelControlCrucero",
      "TimeControlCrucero",
      "DistanceControlCrucero",
      "container4",
    ];
    try {
      charts.forEach(function(element) {
        var AllCharts = new Highcharts.Chart(element, state + element);
        AllCharts.destroy();
      });
      dispatch("onlyDestroyCharts");
    } catch (e) {
      console.log(e);
    }
    // dispatch("removeAllCharts");
  },
  barGenericChart: (
    { state, dispatch },
    { container, title, series, trips, yaxis, stack, totalSerie }
  ) => {
    var totalSerie1 = 0;
    state.SelectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

    state.SelectedDistance =
      localStorage.getItem("Distance") == undefined
        ? "Km"
        : localStorage.getItem("Distance");

    var unit = "";
    if (
      title == i18n.t("fuelConsum") ||
      title == i18n.t("FuelControlCrucero")
    ) {
      unit = state.SelectedVolume;
    } else if (
      title == i18n.t("timeEngine") ||
      title == i18n.t("TimeControlCrucero")
    ) {
      unit = "H";
    } else if (title == i18n.t("DistanceControlCrucero")) {
      unit = state.SelectedDistance;
    } else {
      unit = "";
    }

    var pointFormat1 =
      stack == "normal"
        ? "{series.name}: {point.y} " + unit
        : // +"<br/>Total: {point.stackTotal} " +
          //unit
          "{series.name}: {point.y} " + unit;
    //  +"<br/>Total: " + totalSerie + " " +unit;

    Highcharts.chart(container, {
      chart: {
        type: "column",
        style: {
          fontFamily: "Arial",
        },
        scrollablePlotArea: {
          minWidth: 700,
          scrollPositionX: 0,
          opacity: 1,
        },
      },
      title: {
        text: title,
      },
      xAxis: {
        categories: trips,
      },
      yAxis: {
        min: 0,
        title: {
          text: yaxis,
        },
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: "bold",
            color:
              // theme
              (Highcharts.defaultOptions.title.style &&
                Highcharts.defaultOptions.title.style.color) ||
              "gray",
          },
        },
      },
      legend: {},
      tooltip: {
        headerFormat: "<b>{point.x}</b><br/>",
        pointFormat: pointFormat1,
      },
      plotOptions: {
        series: {
          pointWidth: 30,
        },
        column: {
          groupPadding: 0.12,
          // pointPadding: 0.2,
          // borderWidth: 0,
          stacking: stack,
          dataLabels: {
            enabled: true,
          },
        },
      },
      credits: {
        enabled: false,
      },
      series: series,
    });
  },
  destroyDetailsAndTable: ({ dispatch, state }) => {
    var chart = [state.titleGraphic, state.titleGraphic + "2"];
    chart.forEach((element) => {
      var AllCharts = new Highcharts.Chart(element, state + element);
      AllCharts.destroy();
    });
  },
  async addItemPouchDB(
    { dispatch, state, commit, getters },
    { id, data, name }
  ) {
    if (data != null) {
      try {
        data._id = id;

        // console.log(data);
        NeurtinoDB.put(data)
          .then(function(doc) {
            // okay, doc contains our document
          })
          .catch(function(err) {
            // oh noes! we got an error
            if (err.status == "409") {
              //If item already exist then this is updated in pouchDB
              dispatch("deteletItemPouchDB", {
                id: id,
                data: data,
                update: true,
              });
              console.log("Elemenet already exist");
            } else {
              console.log("Error" + err);
            }
          });
      } catch (e) {
        console.log(e);
      }
    } else {
      //no userdata
    }
  },

  async DeletePouchDB({ dispatch, commit, state }) {
    return await new PouchDB("NeutrinoData").destroy(function(err, response) {
      if (err) {
        console.log("error");
      } else {
        NeurtinoDB = new PouchDB("NeutrinoData");
        console.log("DESTROYED");
      }
    });
  },

  //Get all items from PouchDB
  getItemPouchdb1: ({ dispatch, commit, state }, itemId) => {
    new PouchDB("NeutrinoData").allDocs(
      { include_docs: true, descending: true },
      function(err, doc) {
        if (err) {
          console.log(err);
          dispatch("DeletePouchDB");
        } else {
          var array = doc.rows;
          var arrFinal;
          if (doc.rows != undefined && doc.total_rows != 0) {
            //  console.log(array);

            array.forEach((element) => {
              if (element.key === itemId) {
                arrFinal = element.doc;
              }
            });
            return arrFinal;
          } else {
            dispatch("NeutrinoData");
            commit("auth", false);
          }
        }
      }
    );
  },

  getItemPouchdb({ dispatch }, itemId) {
    return new PouchDB("NeutrinoData").get(
      itemId,
      { attachments: false },
      function(err, doc) {
        if (err) {
          return console.log(err);
        } else {
          return doc;
        }
      }
    );
  },

  deteletItemPouchDB({ dispatch, commit }, { id, data, update }) {
    return new PouchDB("NeutrinoData").get(id, { attachments: false }, function(
      err,
      doc
    ) {
      if (err) {
        return console.log(err);
      } else {
        return new PouchDB("NeutrinoData").remove(doc._id, doc._rev, function(
          err
        ) {
          if (err) {
            return console.log(err);
          } else {
            if (update) {
              // console.log("OK DELETED");
              dispatch("addItemPouchDB", { id: id, data: data, name: "" });
            }
          }
        });
      }
    });
  },
  async lastLevelCommand({ dispatch, commit, state }, { vehicleId }) {
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    const url = state.NeutrinoUrl + "operation/vehicle/command";
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    var params = {
      Id: "D74AEC5B-11B7-4857-8020-C0AF3822A02A",
      ExtensionId: "00000000-0000-0000-0000-000000000000",
      Parameters: "",
      MovilId: vehicleId,
    };

    var request = {
      from: "LAST_LEVEL_COMMAND",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };

    await dispatch("ManageWorker", [request]);
  },
  setSkeletonsFP: ({ dispatch, commit, state }) => {
    commit("viewSkeletonsFP", true);
    commit("skeletonColumnFP", "outskeletonColumn");
  },
  setSkeletonsAR: ({ dispatch, commit, state }) => {
    commit("viewSkeletonsAR", true);
    commit("skeletonLineAR", "outskeleton");
  },
  setSkeletonsRL: ({ dispatch, commit, state }) => {
    commit("viewSkeletonsRL", true);
    commit("skeletonRL", "outskeleton");
    commit("skeletonColumnRL", "outskeletonColumn");
  },

  async lastLevelWS({ dispatch, commit, state }, { vehicleId }) {
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    var selectedAcces = JSON.parse(localStorage.getItem("SelectedAccess"));
    var dID = localStorage.getItem("Dealer_Id");

    const url =
      state.NeutrinoUrl + "operation/alertfuel/individual/retrievelevel";

    var params = {
      DealerId: dID, //Change
      DeviceId: vehicleId, //Change
    };

    var request = {
      from: "RETRIEVE_LEVEL",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };

    await dispatch("ManageWorker", [request]);
  },
  async fuelPerformance({ dispatch, commit, state }, { vehicleId, showMore }) {
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    var selectedAcces = JSON.parse(localStorage.getItem("SelectedAccess"));
    var dID = localStorage.getItem("Dealer_Id");
    var cID = localStorage.getItem("Client_Id");
    var aID = localStorage.getItem("Account_Id");

    var startDate = localStorage.getItem("startDateAF");
    var startClock = localStorage.getItem("startClockAF");
    var endDate = localStorage.getItem("endDateAF");
    var endClock = localStorage.getItem("endClockAF");

    var startDateFinal = "";
    var endDateFinal = "";

    // cID = "00749"; //temporal TR71-02942 is from marva

    const url =
      state.NeutrinoUrl + "operation/alertfuel/individual/mobile/performance";
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    //Change all params
    var params = {
      DealerId: dID,
      ClientId: cID,
      DeviceId: vehicleId,
      RequestMode: "odometer",
      IncludeUncertainChanges: false,
      IncludePendingChanges: true,
      Iwa: true,
    };

    //Cuando halla fechas consulta por fechas
    if (startDate != undefined) {
      //bydates
      startDateFinal = startDate + " " + startClock;
      endDateFinal = endDate + " " + endClock;

      params.StartDate = startDateFinal;
      params.EndDate = endDateFinal;
    }

    //Si se selecciono showmore se consulta por la ultima fecha
    if (showMore) {
      //getLastDate
      var data = JSON.parse(localStorage.getItem("setitemsPerformanceAF"));
      var dataFuel = data.ALERTFUEL_RECENT_ACTIVTY;

      var dates = dataFuel.filter((e, i) => i == 0 || i == dataFuel.length - 1);
      var dateEnds = dates[0].Date;
      if (dates.length > 1) {
        dateEnds = dates[1].Date;
      }
      var dateFormat = moment(
        dateEnds.replace("T", " "),
        "YYYY-MM-DD HH:mm"
      ).format();
      dateEnds = moment(dateFormat)
        .subtract(10, "second")
        .format("YYYY-MM-DD HH:mm");
      params.EndDate = dateEnds;
      if (params.StartDate != undefined) {
        delete params.StartDate;
      }
    }

    var request = {
      from: "FUEL_PERFORMANCE",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };

    await dispatch("ManageWorker", [request, showMore]);
  },
  async getFuelVehicles({ dispatch, commit, state }) {
    var selectedAcces = JSON.parse(localStorage.getItem("SelectedAccess"));
    var dID = localStorage.getItem("Dealer_Id");
    var cID = localStorage.getItem("Client_Id");
    var aID = localStorage.getItem("Account_Id");
    if (dID == "00000") {
      //is master
    } else {
      var token = state.token;
      if (token == null || token == "" || token == undefined) {
        token = localStorage.getItem("Token");
      }

      cID = cID == "ND" || cID == "NA" ? "" : cID;
      aID = aID == "ND" || aID == "NA" ? "" : aID;

      const url =
        state.NeutrinoUrl +
        "management/vehicles?svc=0&did=" +
        dID +
        "&cid=" +
        cID +
        "&acid=" +
        aID;

      var request = {
        from: "VEHICLES_AF",
        URL: url,
        method: "GET",
        responseType: "",
        headers: {
          Authorization: "bearer " + token,
          "Content-type": "application/json",
        },
        params: "",
      };

      await dispatch("ManageWorker", [request]);
    }
  },
  getAllDataFuel({ dispatch, commit, getters, state }, val) {
    val = JSON.parse(val);
    var itemsPerformance = localStorage.getItem("setitemsPerformanceAF");
    if (itemsPerformance != undefined && itemsPerformance != null) {
      itemsPerformance = JSON.parse(itemsPerformance);
      val.ALERTFUEL_RECENT_ACTIVTY.forEach((element) => {
        itemsPerformance.ALERTFUEL_RECENT_ACTIVTY.push(element);
      });

      val.PERFORMANCE.forEach((element) => {
        itemsPerformance.PERFORMANCE.push(element);
      });
      localStorage.setItem(
        "setitemsPerformanceAF",
        JSON.stringify(itemsPerformance)
      );
      dispatch("convertPerformanceAF");
    } else {
      commit("setitemsPerformanceAF", val);
    }
  },
  setLastLevelCommand({ dispatch, commit, getters, state }, val) {
    var lastVolume = val.FreeText.split(" ");
    if (lastVolume[0] == undefined) {
      //dont know volume
    }
    var obj = {
      MovilId: val.MovilId,
      Nick: val.Nick,
      EventId: "174",
      EventName: val.EventName,
      DateGPS: val.DateGPS,
      Latitude: val.Latitude,
      Longitude: val.Longitude,
      Location: val.Location,
      Speed: val.Speed,
      Odometer: val.Odometer,
      GpsIsValid: val.GpsIsValid == "YES" ? true : false,
      VolumenGlobal: lastVolume[0],
    };
    var sendObj = {};
    sendObj = obj;
    localStorage.setItem("setitemsRetrieveLevel", JSON.stringify(sendObj));
    dispatch("convertRetrieveLevel");
  },

  async convertRetrieveLevel({ dispatch, commit, getters, state }) {
    var items = JSON.parse(localStorage.getItem("setitemsRetrieveLevel"));

    let lastLevelResponse = {
      DeviceId: items.MovilId,
      Nick: items.Nick,
      EventId: items.EventId,
      Lat: items.Latitude,
      Lon: items.Longitude,
      Odometer: items.Odometer,
      Speed: items.Speed,
      Location: items.Location,
      IdReporte: "NA",
      DateTimestamp: moment(items.DateGPS, "YYYY-MM-DDTHH:mm").valueOf(),
      DateGPS: getters.formatDateCustom(items.DateGPS.replace("T", " ")),
      VolumenGlobal: getters.convertVolume(items.VolumenGlobal)
    }
    
    let validateReference = getters.isValidReferenceValue(lastLevelResponse.Location);
    if (validateReference == false) {
      state.addressLastLevel  = i18n.t("loadingLocation");
      let reference = null;
      
      try {
        reference = await dispatch("getReferenceData", lastLevelResponse);
      } catch(e) {
        reference = null;
      }

      reference = reference == null ? i18n.t("notAvailable") : reference;
      lastLevelResponse.Location = reference;
    }

    commit("setitemsRetrieveLevel", lastLevelResponse);
  },

  convertPerformanceAF({ dispatch, commit, getters }) {
    var items = JSON.parse(localStorage.getItem("setitemsPerformanceAF"));
    items.PERFORMANCE.forEach((element) => {
      element.Performance.Performance = getters.convertPerformance(element.Performance.Performance);
      element.Performance.Performance = element.Performance.Performance % 1 !== 0
        ? element.Performance.Performance.toFixed(2)
        : element.Performance.Performance;
    });

    let formattedActivity = [];
    items.ALERTFUEL_RECENT_ACTIVTY.forEach((element) => {

      let selectedVolume =
      localStorage.getItem("Volume") == undefined
        ? "L"
        : localStorage.getItem("Volume");

      let volumeChange = getters.convertVolume(element.VolumenChange);
      if (selectedVolume == "L") {
        volumeChange = volumeChange.toFixed();
        volumeChange = volumeChange + " " + selectedVolume;
      } else {
        volumeChange = volumeChange.toFixed(1).replace(/\.0$/, "") + " " + selectedVolume;
      }

      let activity = {
        DeviceId: "NA",
        Lat: element.Lat,
        Lon: element.Lon,
        Odometer: element.Odometer,
        Speed: element.Speed,
        Location: element.Address,
        Type: element.Type,
        Switch: element.Switch,
        IdReporte: "NA",
        DateTimestamp: moment(element.Date, "YYYY-MM-DDTHH:mm").valueOf(),
        Date: getters.formatDateCustom(element.Date.replace("T", " ")),
        VolumenChange: volumeChange
      };

      let validateReference = getters.isValidReferenceValue(activity.Location);
      if (validateReference == false) activity.Location = i18n.t("showReference");

      formattedActivity.push(activity);
    });

    items.ALERTFUEL_RECENT_ACTIVTY = formattedActivity;

    //console.log(items);
    commit("setitemsPerformanceAF", items);
  },

  async sencCommandTracking(
    { dispatch, commit, state },
    { vehicleId, commanId, parameters }
  ) {
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    const url = state.NeutrinoUrl + "operation/vehicle/command";
    // const url = "https://run.mocky.io/v3/ec82b00b-116b-4461-8291-c053950dfb66";//500
    // const url = "https://run.mocky.io/v3/37684b18-6f07-4aa9-b057-033bba79b45d";//401
    // const url = "https://run.mocky.io/v3/d47c01c4-c5a9-47fa-93a6-4f568ef81b6c";//204

    var params = {
      Id: commanId,
      //ExtensionId: ExtensionId,
      Parameters: parameters,
      MovilId: vehicleId,
    };
    //console.log(params);

    var request = {
      from: "SEND_COMMAND_REQUEST",
      URL: url,
      method: "POST",
      responseType: "",
      headers: {
        Authorization: "bearer " + token,
        "Content-type": "application/json",
      },
      params: params,
    };

    await dispatch("ManageWorker", [request]);
  },
  editActualState({ dispatch, commit, getters, state }, response) {
    var lat = parseFloat(response.Latitude).toFixed(7);
    var lng = parseFloat(response.Longitude).toFixed(7);
    var checkingMarkers = state.listOfMarkersInTracking;
    for (var i = 0; i < checkingMarkers.length; i++) {
      if (checkingMarkers[i].title == response.MovilId) {
        var location = {
          lat: parseFloat(lat),
          lng: parseFloat(lng),
        };
        checkingMarkers[i].setPosition(new google.maps.LatLng(location));
        dispatch("goToMarker", location);
      }
    }
    state.selectedVeh.Batery = response.Batery;
    state.selectedVeh.Course = response.Course;
    var dateOfCommandP = new Date(response.DateSVR);
    var milliOfDateOfCP = dateOfCommandP.getTime();
    var milli = moment().valueOf();
    var idleTime = milli - milliOfDateOfCP;
    var t = idleTime;
    var d = Math.floor(t / (1000 * 60 * 60 * 24));
    var h = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var m = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
    var s = Math.floor((t % (1000 * 60)) / 1000);
    if (d < 10) {
      d = "0" + d;
    }
    if (h < 10) {
      h = "0" + h;
    }
    if (m < 10) {
      m = "0" + m;
    }
    if (s < 10) {
      s = "0" + s;
    }
    idleTime = d + "D, " + h + ":" + m;
    state.selectedVeh.IdleTime = idleTime;
    state.selectedVeh.DateGPS = getters.formatDateCustom(
      response.DateGPS.replace("T", " ")
    );
    state.selectedVeh.DateServer = getters.formatDateCustom(
      response.DateSVR.replace("T", " ")
    );
    state.selectedVeh.IsGpsValid = response.GpsIsValid == "YES" ? true : false;
    state.selectedVeh.Odometer = response.Odometer;
    state.selectedVeh.Orientation = response.Orientation;
    state.selectedVeh.Speed = response.Speed;
    state.selectedVeh.Status = response.Status;
    state.selectedVeh.EventData = response.FreeText;
    state.selectedVeh.Location = {
      Lat: parseFloat(lat),
      Lon: parseFloat(lng),
    };

    if (
      response.EventName == "Consul. IMEI" ||
      response.EventName == "Consul. Datos de SIM Card"
    ) {
      commit("setResponse", {
        command: response.EventName,
        text: response.FreeText,
      });
    }

    commit("setItemsTracking", state.selectedVeh);
  },

  async catalogVehAT({ dispatch, commit, state }) {
    commit("progressVehAT", true);
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    // const url =
    //   state.NeutrinoUrl + "";

    const url = "https://run.mocky.io/v3/2fa08235-be1e-4957-b526-ed4e2280919e";

    var request = {
      from: "VEHICLES_AT",
      URL: url,
      method: "GET",
      responseType: "",
      // headers: {
      //   Authorization: "bearer " + token,
      //   "Content-type": "application/json",
      // },
      //params: "",
    };

    await dispatch("ManageWorker", [request]);
  },
  async catalogTemplatesAT({ dispatch, commit, state }) {
    commit("progressTemplatesAT", true);
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    // const url =
    //   state.NeutrinoUrl + "";

    const url = "https://run.mocky.io/v3/ab82ec86-16f9-4322-a687-08a7ec682a00";

    var request = {
      from: "TEMPLATES_AT",
      URL: url,
      method: "GET",
      responseType: "",
      // headers: {
      //   Authorization: "bearer " + token,
      //   "Content-type": "application/json",
      // },
      params: "",
    };

    await dispatch("ManageWorker", [request]);
  },

  //Función para pedir el contenido de una plantilla
  async getTemplateContent ({ dispatch, commit, state }, template) {
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    // const url =
    //   state.NeutrinoUrl + "" + template.Id;

    const url = "https://run.mocky.io/v3/2a5aad72-8625-48c3-9262-d51f9143e5c2";

    var request = {
      from: "GET_TEMPLATE_CONTENT",
      URL: url,
      method: "GET",
      responseType: "",
      // headers: {
      //   Authorization: "bearer " + token,
      //   "Content-type": "application/json",
      // }
    };

    await dispatch("ManageWorker", [request]);
  },

  newTemplate({ dispatch, commit, getters, state }, item) {
    //temporal
    commit("clearTemplate");
    dispatch("setTemplateView", i18n.t("newTemplate").toUpperCase());
  },

  //Se muestra 1 plantilla nueva o con sus valores
  setTemplateView({ commit }, Payload) {
    commit("showTemplates", false);
    commit("showVehiclesAT", false);
    
    commit("setPageHeader", [
      i18n.t("configTemplates").toUpperCase(),
      Payload,
      "",
      "",
      false
    ]);
  },

  async contentVehicleAT({ dispatch, commit, state }) {
    commit("loadingComparativeTable", true);
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    // const url =
    //   state.NeutrinoUrl + "";

    const url = "https://run.mocky.io/v3/24361094-63eb-45f4-aaac-29be5ec3dd8a";

    var request = {
      from: "CONTENT_VEH_AT",
      URL: url,
      method: "GET",
      responseType: "",
      // headers: {
      //   Authorization: "bearer " + token,
      //   "Content-type": "application/json",
      // },
      params: "",
    };

    await dispatch("ManageWorker", [request]);
  },

  async contentTemplateAT({ dispatch, commit, state }) {
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    // const url =
    //   state.NeutrinoUrl + "";

    const url = "https://run.mocky.io/v3/6d6aefc1-e2c9-4c88-bdb3-c74671f01494";

    var request = {
      from: "CONTENT_TEMPLATE_AT",
      URL: url,
      method: "GET",
      responseType: "",
      // headers: {
      //   Authorization: "bearer " + token,
      //   "Content-type": "application/json",
      // },
      params: "",
    };

    await dispatch("ManageWorker", [request]);
  },
  
  assignTemplate({ dispatch, commit, getters, state }, item) {},
  async configProgress({ dispatch, commit, state }) {
    commit("progressForConfigP", true);
    var token = state.token;
    if (token == null || token == "" || token == undefined) {
      token = localStorage.getItem("Token");
    }

    // const url =
    //   state.NeutrinoUrl + "";

    const url = "https://run.mocky.io/v3/600f7844-2970-4c9d-a64b-582097d6906e";

    var request = {
      from: "CONTENT_CONFIG_AT",
      URL: url,
      method: "GET",
      responseType: "",
      // headers: {
      //   Authorization: "bearer " + token,
      //   "Content-type": "application/json",
      // },
      params: "",
    };

    await dispatch("ManageWorker", [request]);
  },

  //Función para obtener de cada vehículo si tiene información de alertruck en el periodo consultado
  async getAlertruckVehiclesInfo({ dispatch, commit, state, getters }) {
    state.progressAlertruckVehiclesInfo = true;
    let offline = JSON.parse(localStorage.getItem("offline"));
    if (!offline) {
      let lastRequest = JSON.parse(
        localStorage.getItem("alertruckVehiclesInfoRequest")
      );

      let currentDate = moment().format("x");
      let tableItems = JSON.parse(localStorage.getItem("alertruckVehiclesInfo"));

      let token = state.token;
      if (token == null || token == "" || token == undefined) {
        token = localStorage.getItem("Token");
      }

      const url = "https://run.mocky.io/v3/25b5db2d-9cbb-4fa6-b917-4d6b5f5e9141";
      //const url = state.NeutrinoUrl + "operation/alertruck/";

      let dID = localStorage.getItem("Dealer_Id");
      let cID = localStorage.getItem("Client_Id");

      let startDate = moment(localStorage.getItem("datesCalendar1")).format(
        "YYYY-MM-DD"
      );
      let endDate =
        localStorage.getItem("datesCalendar2") == null
          ? startDate
          : moment(localStorage.getItem("datesCalendar2")).format("YYYY-MM-DD");

      startDate = startDate + "T" + state.startClock;
      endDate = endDate + "T" + state.endClock;

      let v_list = JSON.parse(localStorage.getItem("v_list"));

      if (
        localStorage.getItem("checkQuickList") != undefined ||
        localStorage.getItem("checkQuickList") != null
      ) {
        state.checkFastList = JSON.parse(
          localStorage.getItem("checkQuickList")
        );
      }

      if (
        localStorage.getItem("quickList") != undefined ||
        localStorage.getItem("quickList") != null
      ) {
        if (state.checkFastList) {
          v_list = JSON.parse(localStorage.getItem("quickList"));
        }
      }

      let listVehicles = getters.listOfVehicles(v_list);

      let data = {
        DealerId: dID,
        ClientId: cID,
        StartDate: startDate,
        EndDate: endDate,
        Vehicles: listVehicles,
      };

      let request = {
        from: "ALERTRUCK_VEHICLES_INFO",
        URL: url,
        method: "GET",
        responseType: "",
        // headers: {
        //   Authorization: "bearer " + token,
        //   "Content-type": "application/json",
        // },
        params: data,
        //params: "",
      };

      //No se ha realizado petición o en la petición anterior no hubo respuesta o contenido, por lo que se realiza petición
      if (
        lastRequest == null ||
        lastRequest == undefined ||
        tableItems == null ||
        tableItems == undefined
      ) {
        await dispatch("ManageWorker", [request]);
        localStorage.setItem(
          "alertruckVehiclesInfoRequest",
          JSON.stringify([data, moment().format("x")])
        );

      } else {
        //Cambio al menos un elemento de la petición anterior, por lo que se realiza petición

        if (
          lastRequest[0].DealerId != dID ||
          lastRequest[0].ClientId != cID ||
          lastRequest[0].StartDate != startDate ||
          lastRequest[0].EndDate != endDate ||
          currentDate > parseInt(lastRequest[1]) + 600000 ||
          lastRequest[0].Vehicles.length != listVehicles.length
        ) {
          await dispatch("ManageWorker", [request]);
          localStorage.setItem(
            "alertruckVehiclesInfoRequest",
            JSON.stringify([data, moment().format("x")])
          );

        } else {
          //dado que la petcion tiene los mismos elementos y esta dentro del tiempo aceptable, no se realiza peticion, solo se llena tabla con localstorage
          commit("setTableContentAlertruckVehiclesInfo", tableItems);
          state.progressAlertruckVehiclesInfo = false;
        }

      }

    } else {
      await commit("snackbar", {
        snackbar: true,
        text: i18n.t("later"),
      });
    }
    
  },

  exportExcelAlertruckVehiclesInfo({ state }) {
    let createXLSLFormatObj = [];
    let newXlsHeader = [];
    if (state.headersAlertruckVehiclesInfoExcel.length === 0) {
      return;
    }
    if (state.itemsAlertruckVehiclesInfo.length === 0) {
      return;
    }
    $.each(state.headersAlertruckVehiclesInfoExcel, function(index, value) {
      newXlsHeader.push(value.label);
    });
    createXLSLFormatObj.push(newXlsHeader);
    $.each(state.itemsAlertruckVehiclesInfo, function(index, value) {
      let innerRowData = [];
      $.each(state.headersAlertruckVehiclesInfoExcel, function(index, val) {
        if (val.dataFormat && typeof val.dataFormat === "function") {
          innerRowData.push(val.dataFormat(value[val.field]));
        } else {
          innerRowData.push(value[val.field]);
        }
      });
      createXLSLFormatObj.push(innerRowData);
    });
    let timestamp = Date.now();
    var name = "AlertruckInfo-" + timestamp;
    let filename = name + ".xlsx";
    let ws_name = "SheetName";
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.aoa_to_sheet(createXLSLFormatObj);
    XLSX.utils.book_append_sheet(wb, ws, ws_name);
    XLSX.writeFile(wb, filename);
  },

  //Función para obtener referencia de celda de tabla de Performance/Individual
  async getReferenceDataForTable({dispatch, state, commit, getters}, rowData) {
    let result = null;
    try {
      dispatch("updateTableReference", { reference: i18n.t("loading"), rowData});

      let offline = JSON.parse(localStorage.getItem("offline"));
      if (!offline) {
        let dID = localStorage.getItem("Dealer_Id");

        let validateCoordinates = getters.isValidLatLon({ lat: rowData.Lat, lon: rowData.Lon });
        if (validateCoordinates) {
          let date = "";
          if (rowData.DateTimestamp == 0) date = "No disponible";
          else date = moment(rowData.DateTimestamp).format('YYYY-MM-DDTHH:mm:ss');

          const params = {
            DealerId: dID,
            DeviceId: rowData.DeviceId,
            IdReporte: rowData.IdReporte,
            Latitude: rowData.Lat,
            Longitude: rowData.Lon,
            Source: 4,//NA
            Provider: 1,
            Date: date
          };

          try {
            result = await dispatch("getReverseGeocoding", params);
          } catch (e) {
            result = null;
          }
        }

        dispatch("updateTableReference", {reference: result, rowData: rowData});

      }
      else {
          commit("snackbar", { snackbar: true, text: i18n.t("later")});
          dispatch("updateTableReference", { reference: result, rowData});
      }
    }
    catch (e) {
      alert("getReferenceDataForTable, Excepción: " + e.message);
      dispatch("updateTableReference", { reference: result, rowData});
    }
  },

  //Función para obtener referencia
  async getReferenceData({dispatch, state, commit, getters}, rowData) {
    let result = null;
    try {
      let offline = JSON.parse(localStorage.getItem("offline"));
      if (!offline) {
        let dID = localStorage.getItem("Dealer_Id");
        let validateCoordinates = getters.isValidLatLon({ lat: rowData.Lat, lon: rowData.Lon });
        if (validateCoordinates) {
          let date = "";
          if (rowData.DateTimestamp == 0) date = "No disponible";
          else date = moment(rowData.DateTimestamp).format('YYYY-MM-DDTHH:mm:ss');

          const params = {
            DealerId: dID,
            DeviceId: rowData.DeviceId,
            IdReporte: rowData.IdReporte,
            Latitude: rowData.Lat,
            Longitude: rowData.Lon,
            Source: 4,//NA
            Provider: 1,
            Date: date
          };

          try {
            result = await dispatch("getReverseGeocoding", params);
          } catch (e) {
            result = null;
          }
        }

        return result;
      }
      else {
          commit("snackbar", { snackbar: true, text: i18n.t("later")});
          return result;
      }
    }
    catch (e) {
      alert("getReferenceData, Excepción: " + e.message);
      return result;
    }
  },

  //Se obtiene geocodificación inversa por proveedor
  async getReverseGeocoding({state}, params) {
    try {
      var URL = state.NeutrinoUrl + "/geocoder/getGeocoding";
      return new Promise((resolve, reject) => {
        var requestOptions = {
          method: "POST",
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json; charset=utf-8'
          },
          body: JSON.stringify(params)
        };
        fetch(URL, requestOptions)
          .then(response => {
            if (response.ok && response.status == 200) return response.json();
            else reject(null);
          })
          .then(result => {
            try {
              resolve(result.Reference);
            }
            catch (e) {
              reject(null);
            }
          })
          .catch(error => {
            reject(null);
          })
          .finally(() => { });
      });
    } catch (e) {
      alert("getReverseGeocoding, Excepción: " + e.message);
      return null;
    }
  },

  //Función para actualizar el resultado de referencia en el array de items de la tabla
  updateTableReference({state}, response) {
    //como no tenemos IdReporte, se validará coincidencia con Id de evento, fecha y detalles de evento
    let event = state.itemsTableInTransit2.find(event => (event.EventId === response.rowData.EventId) && (event.DateTimestamp === response.rowData.DateTimestamp) && (event.Details === response.rowData.Details));
    if (event) {
      event.Reference = response.reference || i18n.t("notAvailable");
    }
  }
};
